/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as ConfigRouteImport } from './routes/config'
import { Route as CloseRouteImport } from './routes/close'
import { Route as AuthDoneRouteImport } from './routes/auth-done'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/app'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as NotFoundRouteImport } from './routes/$notFound'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as ZendeskLogoutRouteImport } from './routes/zendesk/logout'
import { Route as LoginErrorRouteImport } from './routes/login/error'
import { Route as LoginConsentsRouteImport } from './routes/login/consents'
import { Route as DeeplinkSplatRouteImport } from './routes/deeplink/$'
import { Route as ProtectedBankidRouteImport } from './routes/_protected/bankid'
import { Route as ProtectedHomeRouteRouteImport } from './routes/_protected/home/route'
import { Route as ProtectedDepositOnboardingRouteRouteImport } from './routes/_protected/deposit-onboarding/route'
import { Route as ProtectedWithdrawalIndexRouteImport } from './routes/_protected/withdrawal/index'
import { Route as ProtectedKycIndexRouteImport } from './routes/_protected/kyc/index'
import { Route as ProtectedHomeIndexRouteImport } from './routes/_protected/home/index'
import { Route as ProtectedCreditAccountPaymentIndexRouteImport } from './routes/_protected/credit-account-payment/index'
import { Route as ProtectedBillPaymentIndexRouteImport } from './routes/_protected/bill-payment/index'
import { Route as ProtectedAgreementsIndexRouteImport } from './routes/_protected/agreements/index'
import { Route as ProtectedWithdrawalCallbackRouteImport } from './routes/_protected/withdrawal/callback'
import { Route as ProtectedTransferAccountIdRouteImport } from './routes/_protected/transfer/$accountId'
import { Route as ProtectedMonthlyDepositCallbackRouteImport } from './routes/_protected/monthly-deposit/callback'
import { Route as ProtectedKycSuccessRouteImport } from './routes/_protected/kyc/success'
import { Route as ProtectedKycIdRouteImport } from './routes/_protected/kyc/$id'
import { Route as ProtectedHomePurchasesRouteImport } from './routes/_protected/home/purchases'
import { Route as ProtectedDirectTransferCallbackRouteImport } from './routes/_protected/direct-transfer/callback'
import { Route as ProtectedDepositOnboardingMaxAccountRouteImport } from './routes/_protected/deposit-onboarding/max-account'
import { Route as ProtectedDepositOnboardingErrorRouteImport } from './routes/_protected/deposit-onboarding/error'
import { Route as ProtectedDepositOnboardingDeniedRouteImport } from './routes/_protected/deposit-onboarding/denied'
import { Route as ProtectedDepositOnboardingChooseTermRouteImport } from './routes/_protected/deposit-onboarding/choose-term'
import { Route as ProtectedDepositOnboardingChooseProductRouteImport } from './routes/_protected/deposit-onboarding/choose-product'
import { Route as ProtectedDepositOnboardingApplicationIdRouteImport } from './routes/_protected/deposit-onboarding/$applicationId'
import { Route as ProtectedCreditAccountPaymentCallbackRouteImport } from './routes/_protected/credit-account-payment/callback'
import { Route as ProtectedHomeStatementsRouteRouteImport } from './routes/_protected/home/statements/route'
import { Route as ProtectedHomeServiceRouteRouteImport } from './routes/_protected/home/service/route'
import { Route as ProtectedHomeDiscoverRouteRouteImport } from './routes/_protected/home/discover/route'
import { Route as ProtectedHomeAccountsRouteRouteImport } from './routes/_protected/home/accounts/route'
import { Route as ProtectedHomeStatementsIndexRouteImport } from './routes/_protected/home/statements/index'
import { Route as ProtectedHomeServiceIndexRouteImport } from './routes/_protected/home/service/index'
import { Route as ProtectedHomeDiscoverIndexRouteImport } from './routes/_protected/home/discover/index'
import { Route as ProtectedHomeAccountsIndexRouteImport } from './routes/_protected/home/accounts/index'
import { Route as ProtectedDepositOnboardingApplicationIdIndexRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/index'
import { Route as ProtectedCreditAccountPaymentCreateIndexRouteImport } from './routes/_protected/credit-account-payment/create/index'
import { Route as ProtectedConnectedAccountAddIndexRouteImport } from './routes/_protected/connected-account/add/index'
import { Route as ProtectedBillPaymentBillIdIndexRouteImport } from './routes/_protected/bill-payment/$billId/index'
import { Route as ProtectedAgreementsAgreementIdIndexRouteImport } from './routes/_protected/agreements/$agreementId/index'
import { Route as ProtectedWithdrawalOpenbankingCallbackRouteImport } from './routes/_protected/withdrawal/openbanking.callback'
import { Route as ProtectedWithdrawalAccountsCallbackRouteImport } from './routes/_protected/withdrawal/accounts.callback'
import { Route as ProtectedTransferCallbackFailedRouteImport } from './routes/_protected/transfer/callback/failed'
import { Route as ProtectedStatementPaymentStatementIdPaymentRouteImport } from './routes/_protected/statement-payment/$statementId/_payment'
import { Route as ProtectedSavingsCloseIdAccountNumberRouteImport } from './routes/_protected/savings-close/$id/$accountNumber'
import { Route as ProtectedHomeServiceThemeRouteImport } from './routes/_protected/home/service/theme'
import { Route as ProtectedHomeServiceSavedAccountRouteImport } from './routes/_protected/home/service/saved-account'
import { Route as ProtectedHomeServiceProfileRouteImport } from './routes/_protected/home/service/profile'
import { Route as ProtectedHomeServiceNotificationsRouteImport } from './routes/_protected/home/service/notifications'
import { Route as ProtectedHomeServiceMessagesRouteImport } from './routes/_protected/home/service/messages'
import { Route as ProtectedHomeServiceLanguageRouteImport } from './routes/_protected/home/service/language'
import { Route as ProtectedHomeServiceKycRouteImport } from './routes/_protected/home/service/kyc'
import { Route as ProtectedHomeServiceDocumentsRouteImport } from './routes/_protected/home/service/documents'
import { Route as ProtectedHomeServiceAccountRouteImport } from './routes/_protected/home/service/account'
import { Route as ProtectedDepositOnboardingApplicationIdSummaryRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/summary'
import { Route as ProtectedDepositOnboardingApplicationIdResumeRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/resume'
import { Route as ProtectedDepositOnboardingApplicationIdPendingRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/pending'
import { Route as ProtectedDepositOnboardingApplicationIdExistsRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/exists'
import { Route as ProtectedDepositOnboardingApplicationIdCallbackRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/callback'
import { Route as ProtectedCreditAccountPaymentCreateIdRouteImport } from './routes/_protected/credit-account-payment/create/$id'
import { Route as ProtectedConnectedAccountRemoveCallbackRouteImport } from './routes/_protected/connected-account/remove/callback'
import { Route as ProtectedConnectedAccountAddCallbackRouteImport } from './routes/_protected/connected-account/add/callback'
import { Route as ProtectedBillPaymentBillIdOptionsRouteImport } from './routes/_protected/bill-payment/$billId/options'
import { Route as ProtectedBillPaymentBillIdConversionOptionsRouteImport } from './routes/_protected/bill-payment/$billId/conversion-options'
import { Route as ProtectedAgreementsAgreementIdSuccessRouteImport } from './routes/_protected/agreements/$agreementId/success'
import { Route as ProtectedHomeStatementsIdRouteRouteImport } from './routes/_protected/home/statements/$id/route'
import { Route as ProtectedStatementPaymentStatementIdPaymentIndexRouteImport } from './routes/_protected/statement-payment/$statementId/_payment/index'
import { Route as ProtectedHomeStatementsIdIndexRouteImport } from './routes/_protected/home/statements/$id/index'
import { Route as ProtectedStatementPaymentStatementIdConnectBankSuccessRouteImport } from './routes/_protected/statement-payment/$statementId/connect-bank/success'
import { Route as ProtectedStatementPaymentStatementIdConnectBankErrorRouteImport } from './routes/_protected/statement-payment/$statementId/connect-bank/error'
import { Route as ProtectedStatementPaymentStatementIdConnectBankCancelRouteImport } from './routes/_protected/statement-payment/$statementId/connect-bank/cancel'
import { Route as ProtectedStatementPaymentStatementIdConnectBankCallbackRouteImport } from './routes/_protected/statement-payment/$statementId/connect-bank/callback'
import { Route as ProtectedStatementPaymentStatementIdCancelCallbackRouteImport } from './routes/_protected/statement-payment/$statementId/cancel/callback'
import { Route as ProtectedStatementPaymentStatementIdCallbackOpenBankingRouteImport } from './routes/_protected/statement-payment/$statementId/callback/open-banking'
import { Route as ProtectedStatementPaymentStatementIdCallbackConnectedAccountRouteImport } from './routes/_protected/statement-payment/$statementId/callback/connected-account'
import { Route as ProtectedStatementPaymentStatementIdCallbackStatusesRouteImport } from './routes/_protected/statement-payment/$statementId/callback/_statuses'
import { Route as ProtectedStatementPaymentStatementIdPaymentSelectRouteImport } from './routes/_protected/statement-payment/$statementId/_payment/select'
import { Route as ProtectedStatementPaymentStatementIdPaymentOptionsRouteImport } from './routes/_protected/statement-payment/$statementId/_payment/options'
import { Route as ProtectedHomeStatementsIdOpenBankingRouteImport } from './routes/_protected/home/statements/$id/open-banking'
import { Route as ProtectedHomeStatementsIdConnectedAccountPaymentRouteImport } from './routes/_protected/home/statements/$id/connected-account-payment'
import { Route as ProtectedHomeServiceConnectBankSuccessRouteImport } from './routes/_protected/home/service/connect-bank/success'
import { Route as ProtectedHomeServiceConnectBankErrorRouteImport } from './routes/_protected/home/service/connect-bank/error'
import { Route as ProtectedHomeServiceConnectBankCancelRouteImport } from './routes/_protected/home/service/connect-bank/cancel'
import { Route as ProtectedHomeServiceConnectBankCallbackRouteImport } from './routes/_protected/home/service/connect-bank/callback'
import { Route as ProtectedHomeBillsIdOpenBankingRouteImport } from './routes/_protected/home/bills/$id/open-banking'
import { Route as ProtectedHomeAccountsCardsCardIdRouteImport } from './routes/_protected/home/accounts/cards/$cardId'
import { Route as ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/$productCode/deposit-account'
import { Route as ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/$productCode/add-funds'
import { Route as ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRouteImport } from './routes/_protected/deposit-onboarding/$applicationId/$productCode/$accountId'
import { Route as ProtectedBillPaymentBillIdConnectBankSuccessRouteImport } from './routes/_protected/bill-payment/$billId/connect-bank/success'
import { Route as ProtectedBillPaymentBillIdConnectBankErrorRouteImport } from './routes/_protected/bill-payment/$billId/connect-bank/error'
import { Route as ProtectedBillPaymentBillIdConnectBankCancelRouteImport } from './routes/_protected/bill-payment/$billId/connect-bank/cancel'
import { Route as ProtectedBillPaymentBillIdConnectBankCallbackRouteImport } from './routes/_protected/bill-payment/$billId/connect-bank/callback'
import { Route as ProtectedBillPaymentBillIdCallbackOpenBankingRouteImport } from './routes/_protected/bill-payment/$billId/callback/open-banking'
import { Route as ProtectedBillPaymentBillIdCallbackStatusesRouteImport } from './routes/_protected/bill-payment/$billId/callback/_statuses'
import { Route as ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteImport } from './routes/_protected/home/accounts/one-time-credit/$accountId/route'
import { Route as ProtectedHomeAccountsLoansAccountIdRouteRouteImport } from './routes/_protected/home/accounts/loans/$accountId/route'
import { Route as ProtectedHomeAccountsDepositsAccountIdRouteRouteImport } from './routes/_protected/home/accounts/deposits/$accountId/route'
import { Route as ProtectedHomeAccountsCreditsAccountIdRouteRouteImport } from './routes/_protected/home/accounts/credits/$accountId/route'
import { Route as ProtectedHomeAccountsOneTimeCreditAccountIdIndexRouteImport } from './routes/_protected/home/accounts/one-time-credit/$accountId/index'
import { Route as ProtectedHomeAccountsLoansAccountIdIndexRouteImport } from './routes/_protected/home/accounts/loans/$accountId/index'
import { Route as ProtectedHomeAccountsDepositsAccountIdIndexRouteImport } from './routes/_protected/home/accounts/deposits/$accountId/index'
import { Route as ProtectedHomeAccountsCreditsAccountIdIndexRouteImport } from './routes/_protected/home/accounts/credits/$accountId/index'
import { Route as ProtectedAccountsLoansAccountIdCloseIndexRouteImport } from './routes/_protected/accounts/loans/$accountId/close/index'
import { Route as ProtectedAccountsInvoicesAccountIdCloseIndexRouteImport } from './routes/_protected/accounts/invoices/$accountId/close/index'
import { Route as ProtectedAccountsDepositsAccountIdCloseIndexRouteImport } from './routes/_protected/accounts/deposits/$accountId/close/index'
import { Route as ProtectedAccountsCreditsAccountIdCloseIndexRouteImport } from './routes/_protected/accounts/credits/$accountId/close/index'
import { Route as ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRouteImport } from './routes/_protected/statement-payment/$statementId/callback/_statuses/unknown'
import { Route as ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRouteImport } from './routes/_protected/statement-payment/$statementId/callback/_statuses/timeout'
import { Route as ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRouteImport } from './routes/_protected/statement-payment/$statementId/callback/_statuses/success'
import { Route as ProtectedStatementPaymentStatementIdCallbackStatusesPendingRouteImport } from './routes/_protected/statement-payment/$statementId/callback/_statuses/pending'
import { Route as ProtectedStatementPaymentStatementIdCallbackStatusesErrorRouteImport } from './routes/_protected/statement-payment/$statementId/callback/_statuses/error'
import { Route as ProtectedStatementPaymentStatementIdCallbackStatusesCancelRouteImport } from './routes/_protected/statement-payment/$statementId/callback/_statuses/cancel'
import { Route as ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRouteImport } from './routes/_protected/home/accounts/one-time-credit/$accountId/transactions'
import { Route as ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRouteImport } from './routes/_protected/home/accounts/one-time-credit/$accountId/invoice-history'
import { Route as ProtectedHomeAccountsLoansAccountIdTransactionsRouteImport } from './routes/_protected/home/accounts/loans/$accountId/transactions'
import { Route as ProtectedHomeAccountsLoansAccountIdInvoicesRouteImport } from './routes/_protected/home/accounts/loans/$accountId/invoices'
import { Route as ProtectedHomeAccountsDepositsAccountIdTransactionsRouteImport } from './routes/_protected/home/accounts/deposits/$accountId/transactions'
import { Route as ProtectedHomeAccountsDepositsAccountIdStatementsRouteImport } from './routes/_protected/home/accounts/deposits/$accountId/statements'
import { Route as ProtectedHomeAccountsCreditsAccountIdTransactionsRouteImport } from './routes/_protected/home/accounts/credits/$accountId/transactions'
import { Route as ProtectedHomeAccountsCreditsAccountIdInvoicesRouteImport } from './routes/_protected/home/accounts/credits/$accountId/invoices'
import { Route as ProtectedHomeAccountsCreditsAccountIdBonusChecksRouteImport } from './routes/_protected/home/accounts/credits/$accountId/bonus-checks'
import { Route as ProtectedHomeAccountsCardsCardId3dsPasswordRouteImport } from './routes/_protected/home/accounts/cards/$cardId_.3ds-password'
import { Route as ProtectedBillPaymentBillIdCallbackStatusesUnknownRouteImport } from './routes/_protected/bill-payment/$billId/callback/_statuses/unknown'
import { Route as ProtectedBillPaymentBillIdCallbackStatusesTimeoutRouteImport } from './routes/_protected/bill-payment/$billId/callback/_statuses/timeout'
import { Route as ProtectedBillPaymentBillIdCallbackStatusesSuccessRouteImport } from './routes/_protected/bill-payment/$billId/callback/_statuses/success'
import { Route as ProtectedBillPaymentBillIdCallbackStatusesPendingRouteImport } from './routes/_protected/bill-payment/$billId/callback/_statuses/pending'
import { Route as ProtectedBillPaymentBillIdCallbackStatusesErrorRouteImport } from './routes/_protected/bill-payment/$billId/callback/_statuses/error'
import { Route as ProtectedBillPaymentBillIdCallbackStatusesCancelRouteImport } from './routes/_protected/bill-payment/$billId/callback/_statuses/cancel'
import { Route as ProtectedAccountsLoansAccountIdCloseSuccessRouteImport } from './routes/_protected/accounts/loans/$accountId/close/success'
import { Route as ProtectedAccountsLoansAccountIdCloseConfirmRouteImport } from './routes/_protected/accounts/loans/$accountId/close/confirm'
import { Route as ProtectedAccountsInvoicesAccountIdCloseSuccessRouteImport } from './routes/_protected/accounts/invoices/$accountId/close/success'
import { Route as ProtectedAccountsInvoicesAccountIdCloseConfirmRouteImport } from './routes/_protected/accounts/invoices/$accountId/close/confirm'
import { Route as ProtectedAccountsDepositsAccountIdCloseSuccessRouteImport } from './routes/_protected/accounts/deposits/$accountId/close/success'
import { Route as ProtectedAccountsDepositsAccountIdCloseConfirmRouteImport } from './routes/_protected/accounts/deposits/$accountId/close/confirm'
import { Route as ProtectedAccountsCreditsAccountIdCloseSuccessRouteImport } from './routes/_protected/accounts/credits/$accountId/close/success'
import { Route as ProtectedAccountsCreditsAccountIdCloseConfirmRouteImport } from './routes/_protected/accounts/credits/$accountId/close/confirm'
import { Route as ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteImport } from './routes/_protected/home/accounts/credits/$accountId/bonus-shop/route'
import { Route as ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRouteImport } from './routes/_protected/home/accounts/credits/$accountId/bonus-shop/index'
import { Route as ProtectedAccountsLoansAccountIdPpiCloseIndexRouteImport } from './routes/_protected/accounts/loans/$accountId/ppi/close/index'
import { Route as ProtectedAccountsCreditsAccountIdPpiCloseIndexRouteImport } from './routes/_protected/accounts/credits/$accountId/ppi/close/index'
import { Route as ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRouteImport } from './routes/_protected/transfer/callback/success/$fromAccountId/$toAccountId/$amount'
import { Route as ProtectedHomeAccountsCreditsAccountIdCardsCardIdRouteImport } from './routes/_protected/home/accounts/credits/$accountId/cards/$cardId'
import { Route as ProtectedHomeAccountsCreditsAccountIdBonusShopCartRouteImport } from './routes/_protected/home/accounts/credits/$accountId/bonus-shop/cart'
import { Route as ProtectedAccountsLoansAccountIdPpiCloseSuccessRouteImport } from './routes/_protected/accounts/loans/$accountId/ppi/close/success'
import { Route as ProtectedAccountsLoansAccountIdPpiCloseConfirmRouteImport } from './routes/_protected/accounts/loans/$accountId/ppi/close/confirm'
import { Route as ProtectedAccountsCreditsAccountIdPpiCloseSuccessRouteImport } from './routes/_protected/accounts/credits/$accountId/ppi/close/success'
import { Route as ProtectedAccountsCreditsAccountIdPpiCloseConfirmRouteImport } from './routes/_protected/accounts/credits/$accountId/ppi/close/confirm'
import { Route as ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRouteImport } from './routes/_protected/home/accounts/credits/$accountId/bonus-shop/order.$orderId'

const ProtectedStatementPaymentStatementIdRouteImport = createFileRoute(
  '/_protected/statement-payment/$statementId',
)()
const ProtectedStatementPaymentStatementIdCallbackRouteImport = createFileRoute(
  '/_protected/statement-payment/$statementId/callback',
)()
const ProtectedBillPaymentBillIdCallbackRouteImport = createFileRoute(
  '/_protected/bill-payment/$billId/callback',
)()

const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigRoute = ConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => rootRouteImport,
} as any)
const CloseRoute = CloseRouteImport.update({
  id: '/close',
  path: '/close',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDoneRoute = AuthDoneRouteImport.update({
  id: '/auth-done',
  path: '/auth-done',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/$notFound',
  path: '/$notFound',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const ZendeskLogoutRoute = ZendeskLogoutRouteImport.update({
  id: '/zendesk/logout',
  path: '/zendesk/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginErrorRoute = LoginErrorRouteImport.update({
  id: '/login/error',
  path: '/login/error',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginConsentsRoute = LoginConsentsRouteImport.update({
  id: '/login/consents',
  path: '/login/consents',
  getParentRoute: () => rootRouteImport,
} as any)
const DeeplinkSplatRoute = DeeplinkSplatRouteImport.update({
  id: '/deeplink/$',
  path: '/deeplink/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedBankidRoute = ProtectedBankidRouteImport.update({
  id: '/bankid',
  path: '/bankid',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedHomeRouteRoute = ProtectedHomeRouteRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDepositOnboardingRouteRoute =
  ProtectedDepositOnboardingRouteRouteImport.update({
    id: '/deposit-onboarding',
    path: '/deposit-onboarding',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedStatementPaymentStatementIdRoute =
  ProtectedStatementPaymentStatementIdRouteImport.update({
    id: '/statement-payment/$statementId',
    path: '/statement-payment/$statementId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedWithdrawalIndexRoute =
  ProtectedWithdrawalIndexRouteImport.update({
    id: '/withdrawal/',
    path: '/withdrawal/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedKycIndexRoute = ProtectedKycIndexRouteImport.update({
  id: '/kyc/',
  path: '/kyc/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedHomeIndexRoute = ProtectedHomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedHomeRouteRoute,
} as any)
const ProtectedCreditAccountPaymentIndexRoute =
  ProtectedCreditAccountPaymentIndexRouteImport.update({
    id: '/credit-account-payment/',
    path: '/credit-account-payment/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBillPaymentIndexRoute =
  ProtectedBillPaymentIndexRouteImport.update({
    id: '/bill-payment/',
    path: '/bill-payment/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAgreementsIndexRoute =
  ProtectedAgreementsIndexRouteImport.update({
    id: '/agreements/',
    path: '/agreements/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedWithdrawalCallbackRoute =
  ProtectedWithdrawalCallbackRouteImport.update({
    id: '/withdrawal/callback',
    path: '/withdrawal/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedTransferAccountIdRoute =
  ProtectedTransferAccountIdRouteImport.update({
    id: '/transfer/$accountId',
    path: '/transfer/$accountId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedMonthlyDepositCallbackRoute =
  ProtectedMonthlyDepositCallbackRouteImport.update({
    id: '/monthly-deposit/callback',
    path: '/monthly-deposit/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedKycSuccessRoute = ProtectedKycSuccessRouteImport.update({
  id: '/kyc/success',
  path: '/kyc/success',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedKycIdRoute = ProtectedKycIdRouteImport.update({
  id: '/kyc/$id',
  path: '/kyc/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedHomePurchasesRoute = ProtectedHomePurchasesRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => ProtectedHomeRouteRoute,
} as any)
const ProtectedDirectTransferCallbackRoute =
  ProtectedDirectTransferCallbackRouteImport.update({
    id: '/direct-transfer/callback',
    path: '/direct-transfer/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedDepositOnboardingMaxAccountRoute =
  ProtectedDepositOnboardingMaxAccountRouteImport.update({
    id: '/max-account',
    path: '/max-account',
    getParentRoute: () => ProtectedDepositOnboardingRouteRoute,
  } as any)
const ProtectedDepositOnboardingErrorRoute =
  ProtectedDepositOnboardingErrorRouteImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => ProtectedDepositOnboardingRouteRoute,
  } as any)
const ProtectedDepositOnboardingDeniedRoute =
  ProtectedDepositOnboardingDeniedRouteImport.update({
    id: '/denied',
    path: '/denied',
    getParentRoute: () => ProtectedDepositOnboardingRouteRoute,
  } as any)
const ProtectedDepositOnboardingChooseTermRoute =
  ProtectedDepositOnboardingChooseTermRouteImport.update({
    id: '/choose-term',
    path: '/choose-term',
    getParentRoute: () => ProtectedDepositOnboardingRouteRoute,
  } as any)
const ProtectedDepositOnboardingChooseProductRoute =
  ProtectedDepositOnboardingChooseProductRouteImport.update({
    id: '/choose-product',
    path: '/choose-product',
    getParentRoute: () => ProtectedDepositOnboardingRouteRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdRoute =
  ProtectedDepositOnboardingApplicationIdRouteImport.update({
    id: '/$applicationId',
    path: '/$applicationId',
    getParentRoute: () => ProtectedDepositOnboardingRouteRoute,
  } as any)
const ProtectedCreditAccountPaymentCallbackRoute =
  ProtectedCreditAccountPaymentCallbackRouteImport.update({
    id: '/credit-account-payment/callback',
    path: '/credit-account-payment/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedHomeStatementsRouteRoute =
  ProtectedHomeStatementsRouteRouteImport.update({
    id: '/statements',
    path: '/statements',
    getParentRoute: () => ProtectedHomeRouteRoute,
  } as any)
const ProtectedHomeServiceRouteRoute =
  ProtectedHomeServiceRouteRouteImport.update({
    id: '/service',
    path: '/service',
    getParentRoute: () => ProtectedHomeRouteRoute,
  } as any)
const ProtectedHomeDiscoverRouteRoute =
  ProtectedHomeDiscoverRouteRouteImport.update({
    id: '/discover',
    path: '/discover',
    getParentRoute: () => ProtectedHomeRouteRoute,
  } as any)
const ProtectedHomeAccountsRouteRoute =
  ProtectedHomeAccountsRouteRouteImport.update({
    id: '/accounts',
    path: '/accounts',
    getParentRoute: () => ProtectedHomeRouteRoute,
  } as any)
const ProtectedStatementPaymentStatementIdCallbackRoute =
  ProtectedStatementPaymentStatementIdCallbackRouteImport.update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => ProtectedStatementPaymentStatementIdRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackRoute =
  ProtectedBillPaymentBillIdCallbackRouteImport.update({
    id: '/bill-payment/$billId/callback',
    path: '/bill-payment/$billId/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedHomeStatementsIndexRoute =
  ProtectedHomeStatementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeStatementsRouteRoute,
  } as any)
const ProtectedHomeServiceIndexRoute =
  ProtectedHomeServiceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeDiscoverIndexRoute =
  ProtectedHomeDiscoverIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeDiscoverRouteRoute,
  } as any)
const ProtectedHomeAccountsIndexRoute =
  ProtectedHomeAccountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeAccountsRouteRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdIndexRoute =
  ProtectedDepositOnboardingApplicationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
  } as any)
const ProtectedCreditAccountPaymentCreateIndexRoute =
  ProtectedCreditAccountPaymentCreateIndexRouteImport.update({
    id: '/credit-account-payment/create/',
    path: '/credit-account-payment/create/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedConnectedAccountAddIndexRoute =
  ProtectedConnectedAccountAddIndexRouteImport.update({
    id: '/connected-account/add/',
    path: '/connected-account/add/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBillPaymentBillIdIndexRoute =
  ProtectedBillPaymentBillIdIndexRouteImport.update({
    id: '/bill-payment/$billId/',
    path: '/bill-payment/$billId/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAgreementsAgreementIdIndexRoute =
  ProtectedAgreementsAgreementIdIndexRouteImport.update({
    id: '/agreements/$agreementId/',
    path: '/agreements/$agreementId/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedWithdrawalOpenbankingCallbackRoute =
  ProtectedWithdrawalOpenbankingCallbackRouteImport.update({
    id: '/withdrawal/openbanking/callback',
    path: '/withdrawal/openbanking/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedWithdrawalAccountsCallbackRoute =
  ProtectedWithdrawalAccountsCallbackRouteImport.update({
    id: '/withdrawal/accounts/callback',
    path: '/withdrawal/accounts/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedTransferCallbackFailedRoute =
  ProtectedTransferCallbackFailedRouteImport.update({
    id: '/transfer/callback/failed',
    path: '/transfer/callback/failed',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedStatementPaymentStatementIdPaymentRoute =
  ProtectedStatementPaymentStatementIdPaymentRouteImport.update({
    id: '/_payment',
    getParentRoute: () => ProtectedStatementPaymentStatementIdRoute,
  } as any)
const ProtectedSavingsCloseIdAccountNumberRoute =
  ProtectedSavingsCloseIdAccountNumberRouteImport.update({
    id: '/savings-close/$id/$accountNumber',
    path: '/savings-close/$id/$accountNumber',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedHomeServiceThemeRoute =
  ProtectedHomeServiceThemeRouteImport.update({
    id: '/theme',
    path: '/theme',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceSavedAccountRoute =
  ProtectedHomeServiceSavedAccountRouteImport.update({
    id: '/saved-account',
    path: '/saved-account',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceProfileRoute =
  ProtectedHomeServiceProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceNotificationsRoute =
  ProtectedHomeServiceNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceMessagesRoute =
  ProtectedHomeServiceMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceLanguageRoute =
  ProtectedHomeServiceLanguageRouteImport.update({
    id: '/language',
    path: '/language',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceKycRoute = ProtectedHomeServiceKycRouteImport.update({
  id: '/kyc',
  path: '/kyc',
  getParentRoute: () => ProtectedHomeServiceRouteRoute,
} as any)
const ProtectedHomeServiceDocumentsRoute =
  ProtectedHomeServiceDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceAccountRoute =
  ProtectedHomeServiceAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdSummaryRoute =
  ProtectedDepositOnboardingApplicationIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdResumeRoute =
  ProtectedDepositOnboardingApplicationIdResumeRouteImport.update({
    id: '/resume',
    path: '/resume',
    getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdPendingRoute =
  ProtectedDepositOnboardingApplicationIdPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdExistsRoute =
  ProtectedDepositOnboardingApplicationIdExistsRouteImport.update({
    id: '/exists',
    path: '/exists',
    getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdCallbackRoute =
  ProtectedDepositOnboardingApplicationIdCallbackRouteImport.update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
  } as any)
const ProtectedCreditAccountPaymentCreateIdRoute =
  ProtectedCreditAccountPaymentCreateIdRouteImport.update({
    id: '/credit-account-payment/create/$id',
    path: '/credit-account-payment/create/$id',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedConnectedAccountRemoveCallbackRoute =
  ProtectedConnectedAccountRemoveCallbackRouteImport.update({
    id: '/connected-account/remove/callback',
    path: '/connected-account/remove/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedConnectedAccountAddCallbackRoute =
  ProtectedConnectedAccountAddCallbackRouteImport.update({
    id: '/connected-account/add/callback',
    path: '/connected-account/add/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBillPaymentBillIdOptionsRoute =
  ProtectedBillPaymentBillIdOptionsRouteImport.update({
    id: '/bill-payment/$billId/options',
    path: '/bill-payment/$billId/options',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBillPaymentBillIdConversionOptionsRoute =
  ProtectedBillPaymentBillIdConversionOptionsRouteImport.update({
    id: '/bill-payment/$billId/conversion-options',
    path: '/bill-payment/$billId/conversion-options',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAgreementsAgreementIdSuccessRoute =
  ProtectedAgreementsAgreementIdSuccessRouteImport.update({
    id: '/agreements/$agreementId/success',
    path: '/agreements/$agreementId/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedHomeStatementsIdRouteRoute =
  ProtectedHomeStatementsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProtectedHomeStatementsRouteRoute,
  } as any)
const ProtectedStatementPaymentStatementIdPaymentIndexRoute =
  ProtectedStatementPaymentStatementIdPaymentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedStatementPaymentStatementIdPaymentRoute,
  } as any)
const ProtectedHomeStatementsIdIndexRoute =
  ProtectedHomeStatementsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeStatementsIdRouteRoute,
  } as any)
const ProtectedStatementPaymentStatementIdConnectBankSuccessRoute =
  ProtectedStatementPaymentStatementIdConnectBankSuccessRouteImport.update({
    id: '/connect-bank/success',
    path: '/connect-bank/success',
    getParentRoute: () => ProtectedStatementPaymentStatementIdRoute,
  } as any)
const ProtectedStatementPaymentStatementIdConnectBankErrorRoute =
  ProtectedStatementPaymentStatementIdConnectBankErrorRouteImport.update({
    id: '/connect-bank/error',
    path: '/connect-bank/error',
    getParentRoute: () => ProtectedStatementPaymentStatementIdRoute,
  } as any)
const ProtectedStatementPaymentStatementIdConnectBankCancelRoute =
  ProtectedStatementPaymentStatementIdConnectBankCancelRouteImport.update({
    id: '/connect-bank/cancel',
    path: '/connect-bank/cancel',
    getParentRoute: () => ProtectedStatementPaymentStatementIdRoute,
  } as any)
const ProtectedStatementPaymentStatementIdConnectBankCallbackRoute =
  ProtectedStatementPaymentStatementIdConnectBankCallbackRouteImport.update({
    id: '/connect-bank/callback',
    path: '/connect-bank/callback',
    getParentRoute: () => ProtectedStatementPaymentStatementIdRoute,
  } as any)
const ProtectedStatementPaymentStatementIdCancelCallbackRoute =
  ProtectedStatementPaymentStatementIdCancelCallbackRouteImport.update({
    id: '/cancel/callback',
    path: '/cancel/callback',
    getParentRoute: () => ProtectedStatementPaymentStatementIdRoute,
  } as any)
const ProtectedStatementPaymentStatementIdCallbackOpenBankingRoute =
  ProtectedStatementPaymentStatementIdCallbackOpenBankingRouteImport.update({
    id: '/open-banking',
    path: '/open-banking',
    getParentRoute: () => ProtectedStatementPaymentStatementIdCallbackRoute,
  } as any)
const ProtectedStatementPaymentStatementIdCallbackConnectedAccountRoute =
  ProtectedStatementPaymentStatementIdCallbackConnectedAccountRouteImport.update(
    {
      id: '/connected-account',
      path: '/connected-account',
      getParentRoute: () => ProtectedStatementPaymentStatementIdCallbackRoute,
    } as any,
  )
const ProtectedStatementPaymentStatementIdCallbackStatusesRoute =
  ProtectedStatementPaymentStatementIdCallbackStatusesRouteImport.update({
    id: '/_statuses',
    getParentRoute: () => ProtectedStatementPaymentStatementIdCallbackRoute,
  } as any)
const ProtectedStatementPaymentStatementIdPaymentSelectRoute =
  ProtectedStatementPaymentStatementIdPaymentSelectRouteImport.update({
    id: '/select',
    path: '/select',
    getParentRoute: () => ProtectedStatementPaymentStatementIdPaymentRoute,
  } as any)
const ProtectedStatementPaymentStatementIdPaymentOptionsRoute =
  ProtectedStatementPaymentStatementIdPaymentOptionsRouteImport.update({
    id: '/options',
    path: '/options',
    getParentRoute: () => ProtectedStatementPaymentStatementIdPaymentRoute,
  } as any)
const ProtectedHomeStatementsIdOpenBankingRoute =
  ProtectedHomeStatementsIdOpenBankingRouteImport.update({
    id: '/open-banking',
    path: '/open-banking',
    getParentRoute: () => ProtectedHomeStatementsIdRouteRoute,
  } as any)
const ProtectedHomeStatementsIdConnectedAccountPaymentRoute =
  ProtectedHomeStatementsIdConnectedAccountPaymentRouteImport.update({
    id: '/connected-account-payment',
    path: '/connected-account-payment',
    getParentRoute: () => ProtectedHomeStatementsIdRouteRoute,
  } as any)
const ProtectedHomeServiceConnectBankSuccessRoute =
  ProtectedHomeServiceConnectBankSuccessRouteImport.update({
    id: '/connect-bank/success',
    path: '/connect-bank/success',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceConnectBankErrorRoute =
  ProtectedHomeServiceConnectBankErrorRouteImport.update({
    id: '/connect-bank/error',
    path: '/connect-bank/error',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceConnectBankCancelRoute =
  ProtectedHomeServiceConnectBankCancelRouteImport.update({
    id: '/connect-bank/cancel',
    path: '/connect-bank/cancel',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeServiceConnectBankCallbackRoute =
  ProtectedHomeServiceConnectBankCallbackRouteImport.update({
    id: '/connect-bank/callback',
    path: '/connect-bank/callback',
    getParentRoute: () => ProtectedHomeServiceRouteRoute,
  } as any)
const ProtectedHomeBillsIdOpenBankingRoute =
  ProtectedHomeBillsIdOpenBankingRouteImport.update({
    id: '/bills/$id/open-banking',
    path: '/bills/$id/open-banking',
    getParentRoute: () => ProtectedHomeRouteRoute,
  } as any)
const ProtectedHomeAccountsCardsCardIdRoute =
  ProtectedHomeAccountsCardsCardIdRouteImport.update({
    id: '/cards/$cardId',
    path: '/cards/$cardId',
    getParentRoute: () => ProtectedHomeAccountsRouteRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRoute =
  ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRouteImport.update(
    {
      id: '/$productCode/deposit-account',
      path: '/$productCode/deposit-account',
      getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
    } as any,
  )
const ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRoute =
  ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRouteImport.update({
    id: '/$productCode/add-funds',
    path: '/$productCode/add-funds',
    getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
  } as any)
const ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRoute =
  ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRouteImport.update(
    {
      id: '/$productCode/$accountId',
      path: '/$productCode/$accountId',
      getParentRoute: () => ProtectedDepositOnboardingApplicationIdRoute,
    } as any,
  )
const ProtectedBillPaymentBillIdConnectBankSuccessRoute =
  ProtectedBillPaymentBillIdConnectBankSuccessRouteImport.update({
    id: '/bill-payment/$billId/connect-bank/success',
    path: '/bill-payment/$billId/connect-bank/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBillPaymentBillIdConnectBankErrorRoute =
  ProtectedBillPaymentBillIdConnectBankErrorRouteImport.update({
    id: '/bill-payment/$billId/connect-bank/error',
    path: '/bill-payment/$billId/connect-bank/error',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBillPaymentBillIdConnectBankCancelRoute =
  ProtectedBillPaymentBillIdConnectBankCancelRouteImport.update({
    id: '/bill-payment/$billId/connect-bank/cancel',
    path: '/bill-payment/$billId/connect-bank/cancel',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBillPaymentBillIdConnectBankCallbackRoute =
  ProtectedBillPaymentBillIdConnectBankCallbackRouteImport.update({
    id: '/bill-payment/$billId/connect-bank/callback',
    path: '/bill-payment/$billId/connect-bank/callback',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackOpenBankingRoute =
  ProtectedBillPaymentBillIdCallbackOpenBankingRouteImport.update({
    id: '/open-banking',
    path: '/open-banking',
    getParentRoute: () => ProtectedBillPaymentBillIdCallbackRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackStatusesRoute =
  ProtectedBillPaymentBillIdCallbackStatusesRouteImport.update({
    id: '/_statuses',
    getParentRoute: () => ProtectedBillPaymentBillIdCallbackRoute,
  } as any)
const ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute =
  ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteImport.update({
    id: '/one-time-credit/$accountId',
    path: '/one-time-credit/$accountId',
    getParentRoute: () => ProtectedHomeAccountsRouteRoute,
  } as any)
const ProtectedHomeAccountsLoansAccountIdRouteRoute =
  ProtectedHomeAccountsLoansAccountIdRouteRouteImport.update({
    id: '/loans/$accountId',
    path: '/loans/$accountId',
    getParentRoute: () => ProtectedHomeAccountsRouteRoute,
  } as any)
const ProtectedHomeAccountsDepositsAccountIdRouteRoute =
  ProtectedHomeAccountsDepositsAccountIdRouteRouteImport.update({
    id: '/deposits/$accountId',
    path: '/deposits/$accountId',
    getParentRoute: () => ProtectedHomeAccountsRouteRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdRouteRoute =
  ProtectedHomeAccountsCreditsAccountIdRouteRouteImport.update({
    id: '/credits/$accountId',
    path: '/credits/$accountId',
    getParentRoute: () => ProtectedHomeAccountsRouteRoute,
  } as any)
const ProtectedHomeAccountsOneTimeCreditAccountIdIndexRoute =
  ProtectedHomeAccountsOneTimeCreditAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsLoansAccountIdIndexRoute =
  ProtectedHomeAccountsLoansAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeAccountsLoansAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsDepositsAccountIdIndexRoute =
  ProtectedHomeAccountsDepositsAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeAccountsDepositsAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdIndexRoute =
  ProtectedHomeAccountsCreditsAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedHomeAccountsCreditsAccountIdRouteRoute,
  } as any)
const ProtectedAccountsLoansAccountIdCloseIndexRoute =
  ProtectedAccountsLoansAccountIdCloseIndexRouteImport.update({
    id: '/accounts/loans/$accountId/close/',
    path: '/accounts/loans/$accountId/close/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsInvoicesAccountIdCloseIndexRoute =
  ProtectedAccountsInvoicesAccountIdCloseIndexRouteImport.update({
    id: '/accounts/invoices/$accountId/close/',
    path: '/accounts/invoices/$accountId/close/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsDepositsAccountIdCloseIndexRoute =
  ProtectedAccountsDepositsAccountIdCloseIndexRouteImport.update({
    id: '/accounts/deposits/$accountId/close/',
    path: '/accounts/deposits/$accountId/close/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsCreditsAccountIdCloseIndexRoute =
  ProtectedAccountsCreditsAccountIdCloseIndexRouteImport.update({
    id: '/accounts/credits/$accountId/close/',
    path: '/accounts/credits/$accountId/close/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRoute =
  ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRouteImport.update(
    {
      id: '/unknown',
      path: '/unknown',
      getParentRoute: () =>
        ProtectedStatementPaymentStatementIdCallbackStatusesRoute,
    } as any,
  )
const ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRoute =
  ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRouteImport.update(
    {
      id: '/timeout',
      path: '/timeout',
      getParentRoute: () =>
        ProtectedStatementPaymentStatementIdCallbackStatusesRoute,
    } as any,
  )
const ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRoute =
  ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRouteImport.update(
    {
      id: '/success',
      path: '/success',
      getParentRoute: () =>
        ProtectedStatementPaymentStatementIdCallbackStatusesRoute,
    } as any,
  )
const ProtectedStatementPaymentStatementIdCallbackStatusesPendingRoute =
  ProtectedStatementPaymentStatementIdCallbackStatusesPendingRouteImport.update(
    {
      id: '/pending',
      path: '/pending',
      getParentRoute: () =>
        ProtectedStatementPaymentStatementIdCallbackStatusesRoute,
    } as any,
  )
const ProtectedStatementPaymentStatementIdCallbackStatusesErrorRoute =
  ProtectedStatementPaymentStatementIdCallbackStatusesErrorRouteImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () =>
      ProtectedStatementPaymentStatementIdCallbackStatusesRoute,
  } as any)
const ProtectedStatementPaymentStatementIdCallbackStatusesCancelRoute =
  ProtectedStatementPaymentStatementIdCallbackStatusesCancelRouteImport.update({
    id: '/cancel',
    path: '/cancel',
    getParentRoute: () =>
      ProtectedStatementPaymentStatementIdCallbackStatusesRoute,
  } as any)
const ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRoute =
  ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRoute =
  ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRouteImport.update({
    id: '/invoice-history',
    path: '/invoice-history',
    getParentRoute: () => ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsLoansAccountIdTransactionsRoute =
  ProtectedHomeAccountsLoansAccountIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => ProtectedHomeAccountsLoansAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsLoansAccountIdInvoicesRoute =
  ProtectedHomeAccountsLoansAccountIdInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => ProtectedHomeAccountsLoansAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsDepositsAccountIdTransactionsRoute =
  ProtectedHomeAccountsDepositsAccountIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => ProtectedHomeAccountsDepositsAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsDepositsAccountIdStatementsRoute =
  ProtectedHomeAccountsDepositsAccountIdStatementsRouteImport.update({
    id: '/statements',
    path: '/statements',
    getParentRoute: () => ProtectedHomeAccountsDepositsAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdTransactionsRoute =
  ProtectedHomeAccountsCreditsAccountIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => ProtectedHomeAccountsCreditsAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdInvoicesRoute =
  ProtectedHomeAccountsCreditsAccountIdInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => ProtectedHomeAccountsCreditsAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdBonusChecksRoute =
  ProtectedHomeAccountsCreditsAccountIdBonusChecksRouteImport.update({
    id: '/bonus-checks',
    path: '/bonus-checks',
    getParentRoute: () => ProtectedHomeAccountsCreditsAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsCardsCardId3dsPasswordRoute =
  ProtectedHomeAccountsCardsCardId3dsPasswordRouteImport.update({
    id: '/cards/$cardId_/3ds-password',
    path: '/cards/$cardId/3ds-password',
    getParentRoute: () => ProtectedHomeAccountsRouteRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackStatusesUnknownRoute =
  ProtectedBillPaymentBillIdCallbackStatusesUnknownRouteImport.update({
    id: '/unknown',
    path: '/unknown',
    getParentRoute: () => ProtectedBillPaymentBillIdCallbackStatusesRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackStatusesTimeoutRoute =
  ProtectedBillPaymentBillIdCallbackStatusesTimeoutRouteImport.update({
    id: '/timeout',
    path: '/timeout',
    getParentRoute: () => ProtectedBillPaymentBillIdCallbackStatusesRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackStatusesSuccessRoute =
  ProtectedBillPaymentBillIdCallbackStatusesSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => ProtectedBillPaymentBillIdCallbackStatusesRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackStatusesPendingRoute =
  ProtectedBillPaymentBillIdCallbackStatusesPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => ProtectedBillPaymentBillIdCallbackStatusesRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackStatusesErrorRoute =
  ProtectedBillPaymentBillIdCallbackStatusesErrorRouteImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => ProtectedBillPaymentBillIdCallbackStatusesRoute,
  } as any)
const ProtectedBillPaymentBillIdCallbackStatusesCancelRoute =
  ProtectedBillPaymentBillIdCallbackStatusesCancelRouteImport.update({
    id: '/cancel',
    path: '/cancel',
    getParentRoute: () => ProtectedBillPaymentBillIdCallbackStatusesRoute,
  } as any)
const ProtectedAccountsLoansAccountIdCloseSuccessRoute =
  ProtectedAccountsLoansAccountIdCloseSuccessRouteImport.update({
    id: '/accounts/loans/$accountId/close/success',
    path: '/accounts/loans/$accountId/close/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsLoansAccountIdCloseConfirmRoute =
  ProtectedAccountsLoansAccountIdCloseConfirmRouteImport.update({
    id: '/accounts/loans/$accountId/close/confirm',
    path: '/accounts/loans/$accountId/close/confirm',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsInvoicesAccountIdCloseSuccessRoute =
  ProtectedAccountsInvoicesAccountIdCloseSuccessRouteImport.update({
    id: '/accounts/invoices/$accountId/close/success',
    path: '/accounts/invoices/$accountId/close/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsInvoicesAccountIdCloseConfirmRoute =
  ProtectedAccountsInvoicesAccountIdCloseConfirmRouteImport.update({
    id: '/accounts/invoices/$accountId/close/confirm',
    path: '/accounts/invoices/$accountId/close/confirm',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsDepositsAccountIdCloseSuccessRoute =
  ProtectedAccountsDepositsAccountIdCloseSuccessRouteImport.update({
    id: '/accounts/deposits/$accountId/close/success',
    path: '/accounts/deposits/$accountId/close/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsDepositsAccountIdCloseConfirmRoute =
  ProtectedAccountsDepositsAccountIdCloseConfirmRouteImport.update({
    id: '/accounts/deposits/$accountId/close/confirm',
    path: '/accounts/deposits/$accountId/close/confirm',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsCreditsAccountIdCloseSuccessRoute =
  ProtectedAccountsCreditsAccountIdCloseSuccessRouteImport.update({
    id: '/accounts/credits/$accountId/close/success',
    path: '/accounts/credits/$accountId/close/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsCreditsAccountIdCloseConfirmRoute =
  ProtectedAccountsCreditsAccountIdCloseConfirmRouteImport.update({
    id: '/accounts/credits/$accountId/close/confirm',
    path: '/accounts/credits/$accountId/close/confirm',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute =
  ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteImport.update({
    id: '/bonus-shop',
    path: '/bonus-shop',
    getParentRoute: () => ProtectedHomeAccountsCreditsAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRoute =
  ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute,
  } as any)
const ProtectedAccountsLoansAccountIdPpiCloseIndexRoute =
  ProtectedAccountsLoansAccountIdPpiCloseIndexRouteImport.update({
    id: '/accounts/loans/$accountId/ppi/close/',
    path: '/accounts/loans/$accountId/ppi/close/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsCreditsAccountIdPpiCloseIndexRoute =
  ProtectedAccountsCreditsAccountIdPpiCloseIndexRouteImport.update({
    id: '/accounts/credits/$accountId/ppi/close/',
    path: '/accounts/credits/$accountId/ppi/close/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRoute =
  ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRouteImport.update(
    {
      id: '/transfer/callback/success/$fromAccountId/$toAccountId/$amount',
      path: '/transfer/callback/success/$fromAccountId/$toAccountId/$amount',
      getParentRoute: () => ProtectedRoute,
    } as any,
  )
const ProtectedHomeAccountsCreditsAccountIdCardsCardIdRoute =
  ProtectedHomeAccountsCreditsAccountIdCardsCardIdRouteImport.update({
    id: '/cards/$cardId',
    path: '/cards/$cardId',
    getParentRoute: () => ProtectedHomeAccountsCreditsAccountIdRouteRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdBonusShopCartRoute =
  ProtectedHomeAccountsCreditsAccountIdBonusShopCartRouteImport.update({
    id: '/cart',
    path: '/cart',
    getParentRoute: () =>
      ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute,
  } as any)
const ProtectedAccountsLoansAccountIdPpiCloseSuccessRoute =
  ProtectedAccountsLoansAccountIdPpiCloseSuccessRouteImport.update({
    id: '/accounts/loans/$accountId/ppi/close/success',
    path: '/accounts/loans/$accountId/ppi/close/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsLoansAccountIdPpiCloseConfirmRoute =
  ProtectedAccountsLoansAccountIdPpiCloseConfirmRouteImport.update({
    id: '/accounts/loans/$accountId/ppi/close/confirm',
    path: '/accounts/loans/$accountId/ppi/close/confirm',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsCreditsAccountIdPpiCloseSuccessRoute =
  ProtectedAccountsCreditsAccountIdPpiCloseSuccessRouteImport.update({
    id: '/accounts/credits/$accountId/ppi/close/success',
    path: '/accounts/credits/$accountId/ppi/close/success',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountsCreditsAccountIdPpiCloseConfirmRoute =
  ProtectedAccountsCreditsAccountIdPpiCloseConfirmRouteImport.update({
    id: '/accounts/credits/$accountId/ppi/close/confirm',
    path: '/accounts/credits/$accountId/ppi/close/confirm',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRoute =
  ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRouteImport.update({
    id: '/order/$orderId',
    path: '/order/$orderId',
    getParentRoute: () =>
      ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$notFound': typeof NotFoundRoute
  '/app': typeof AppRoute
  '/auth': typeof AuthRoute
  '/auth-done': typeof AuthDoneRoute
  '/close': typeof CloseRoute
  '/config': typeof ConfigRoute
  '/demo': typeof DemoRoute
  '/error': typeof ErrorRoute
  '/logout': typeof LogoutRoute
  '/maintenance': typeof MaintenanceRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/deposit-onboarding': typeof ProtectedDepositOnboardingRouteRouteWithChildren
  '/home': typeof ProtectedHomeRouteRouteWithChildren
  '/bankid': typeof ProtectedBankidRoute
  '/deeplink/$': typeof DeeplinkSplatRoute
  '/login/consents': typeof LoginConsentsRoute
  '/login/error': typeof LoginErrorRoute
  '/zendesk/logout': typeof ZendeskLogoutRoute
  '/login': typeof LoginIndexRoute
  '/home/accounts': typeof ProtectedHomeAccountsRouteRouteWithChildren
  '/home/discover': typeof ProtectedHomeDiscoverRouteRouteWithChildren
  '/home/service': typeof ProtectedHomeServiceRouteRouteWithChildren
  '/home/statements': typeof ProtectedHomeStatementsRouteRouteWithChildren
  '/credit-account-payment/callback': typeof ProtectedCreditAccountPaymentCallbackRoute
  '/deposit-onboarding/$applicationId': typeof ProtectedDepositOnboardingApplicationIdRouteWithChildren
  '/deposit-onboarding/choose-product': typeof ProtectedDepositOnboardingChooseProductRoute
  '/deposit-onboarding/choose-term': typeof ProtectedDepositOnboardingChooseTermRoute
  '/deposit-onboarding/denied': typeof ProtectedDepositOnboardingDeniedRoute
  '/deposit-onboarding/error': typeof ProtectedDepositOnboardingErrorRoute
  '/deposit-onboarding/max-account': typeof ProtectedDepositOnboardingMaxAccountRoute
  '/direct-transfer/callback': typeof ProtectedDirectTransferCallbackRoute
  '/home/purchases': typeof ProtectedHomePurchasesRoute
  '/kyc/$id': typeof ProtectedKycIdRoute
  '/kyc/success': typeof ProtectedKycSuccessRoute
  '/monthly-deposit/callback': typeof ProtectedMonthlyDepositCallbackRoute
  '/transfer/$accountId': typeof ProtectedTransferAccountIdRoute
  '/withdrawal/callback': typeof ProtectedWithdrawalCallbackRoute
  '/agreements': typeof ProtectedAgreementsIndexRoute
  '/bill-payment': typeof ProtectedBillPaymentIndexRoute
  '/credit-account-payment': typeof ProtectedCreditAccountPaymentIndexRoute
  '/home/': typeof ProtectedHomeIndexRoute
  '/kyc': typeof ProtectedKycIndexRoute
  '/withdrawal': typeof ProtectedWithdrawalIndexRoute
  '/home/statements/$id': typeof ProtectedHomeStatementsIdRouteRouteWithChildren
  '/agreements/$agreementId/success': typeof ProtectedAgreementsAgreementIdSuccessRoute
  '/bill-payment/$billId/conversion-options': typeof ProtectedBillPaymentBillIdConversionOptionsRoute
  '/bill-payment/$billId/options': typeof ProtectedBillPaymentBillIdOptionsRoute
  '/connected-account/add/callback': typeof ProtectedConnectedAccountAddCallbackRoute
  '/connected-account/remove/callback': typeof ProtectedConnectedAccountRemoveCallbackRoute
  '/credit-account-payment/create/$id': typeof ProtectedCreditAccountPaymentCreateIdRoute
  '/deposit-onboarding/$applicationId/callback': typeof ProtectedDepositOnboardingApplicationIdCallbackRoute
  '/deposit-onboarding/$applicationId/exists': typeof ProtectedDepositOnboardingApplicationIdExistsRoute
  '/deposit-onboarding/$applicationId/pending': typeof ProtectedDepositOnboardingApplicationIdPendingRoute
  '/deposit-onboarding/$applicationId/resume': typeof ProtectedDepositOnboardingApplicationIdResumeRoute
  '/deposit-onboarding/$applicationId/summary': typeof ProtectedDepositOnboardingApplicationIdSummaryRoute
  '/home/service/account': typeof ProtectedHomeServiceAccountRoute
  '/home/service/documents': typeof ProtectedHomeServiceDocumentsRoute
  '/home/service/kyc': typeof ProtectedHomeServiceKycRoute
  '/home/service/language': typeof ProtectedHomeServiceLanguageRoute
  '/home/service/messages': typeof ProtectedHomeServiceMessagesRoute
  '/home/service/notifications': typeof ProtectedHomeServiceNotificationsRoute
  '/home/service/profile': typeof ProtectedHomeServiceProfileRoute
  '/home/service/saved-account': typeof ProtectedHomeServiceSavedAccountRoute
  '/home/service/theme': typeof ProtectedHomeServiceThemeRoute
  '/savings-close/$id/$accountNumber': typeof ProtectedSavingsCloseIdAccountNumberRoute
  '/statement-payment/$statementId': typeof ProtectedStatementPaymentStatementIdPaymentRouteWithChildren
  '/transfer/callback/failed': typeof ProtectedTransferCallbackFailedRoute
  '/withdrawal/accounts/callback': typeof ProtectedWithdrawalAccountsCallbackRoute
  '/withdrawal/openbanking/callback': typeof ProtectedWithdrawalOpenbankingCallbackRoute
  '/agreements/$agreementId': typeof ProtectedAgreementsAgreementIdIndexRoute
  '/bill-payment/$billId': typeof ProtectedBillPaymentBillIdIndexRoute
  '/connected-account/add': typeof ProtectedConnectedAccountAddIndexRoute
  '/credit-account-payment/create': typeof ProtectedCreditAccountPaymentCreateIndexRoute
  '/deposit-onboarding/$applicationId/': typeof ProtectedDepositOnboardingApplicationIdIndexRoute
  '/home/accounts/': typeof ProtectedHomeAccountsIndexRoute
  '/home/discover/': typeof ProtectedHomeDiscoverIndexRoute
  '/home/service/': typeof ProtectedHomeServiceIndexRoute
  '/home/statements/': typeof ProtectedHomeStatementsIndexRoute
  '/home/accounts/credits/$accountId': typeof ProtectedHomeAccountsCreditsAccountIdRouteRouteWithChildren
  '/home/accounts/deposits/$accountId': typeof ProtectedHomeAccountsDepositsAccountIdRouteRouteWithChildren
  '/home/accounts/loans/$accountId': typeof ProtectedHomeAccountsLoansAccountIdRouteRouteWithChildren
  '/home/accounts/one-time-credit/$accountId': typeof ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteWithChildren
  '/bill-payment/$billId/callback': typeof ProtectedBillPaymentBillIdCallbackStatusesRouteWithChildren
  '/bill-payment/$billId/callback/open-banking': typeof ProtectedBillPaymentBillIdCallbackOpenBankingRoute
  '/bill-payment/$billId/connect-bank/callback': typeof ProtectedBillPaymentBillIdConnectBankCallbackRoute
  '/bill-payment/$billId/connect-bank/cancel': typeof ProtectedBillPaymentBillIdConnectBankCancelRoute
  '/bill-payment/$billId/connect-bank/error': typeof ProtectedBillPaymentBillIdConnectBankErrorRoute
  '/bill-payment/$billId/connect-bank/success': typeof ProtectedBillPaymentBillIdConnectBankSuccessRoute
  '/deposit-onboarding/$applicationId/$productCode/$accountId': typeof ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRoute
  '/deposit-onboarding/$applicationId/$productCode/add-funds': typeof ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRoute
  '/deposit-onboarding/$applicationId/$productCode/deposit-account': typeof ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRoute
  '/home/accounts/cards/$cardId': typeof ProtectedHomeAccountsCardsCardIdRoute
  '/home/bills/$id/open-banking': typeof ProtectedHomeBillsIdOpenBankingRoute
  '/home/service/connect-bank/callback': typeof ProtectedHomeServiceConnectBankCallbackRoute
  '/home/service/connect-bank/cancel': typeof ProtectedHomeServiceConnectBankCancelRoute
  '/home/service/connect-bank/error': typeof ProtectedHomeServiceConnectBankErrorRoute
  '/home/service/connect-bank/success': typeof ProtectedHomeServiceConnectBankSuccessRoute
  '/home/statements/$id/connected-account-payment': typeof ProtectedHomeStatementsIdConnectedAccountPaymentRoute
  '/home/statements/$id/open-banking': typeof ProtectedHomeStatementsIdOpenBankingRoute
  '/statement-payment/$statementId/options': typeof ProtectedStatementPaymentStatementIdPaymentOptionsRoute
  '/statement-payment/$statementId/select': typeof ProtectedStatementPaymentStatementIdPaymentSelectRoute
  '/statement-payment/$statementId/callback': typeof ProtectedStatementPaymentStatementIdCallbackStatusesRouteWithChildren
  '/statement-payment/$statementId/callback/connected-account': typeof ProtectedStatementPaymentStatementIdCallbackConnectedAccountRoute
  '/statement-payment/$statementId/callback/open-banking': typeof ProtectedStatementPaymentStatementIdCallbackOpenBankingRoute
  '/statement-payment/$statementId/cancel/callback': typeof ProtectedStatementPaymentStatementIdCancelCallbackRoute
  '/statement-payment/$statementId/connect-bank/callback': typeof ProtectedStatementPaymentStatementIdConnectBankCallbackRoute
  '/statement-payment/$statementId/connect-bank/cancel': typeof ProtectedStatementPaymentStatementIdConnectBankCancelRoute
  '/statement-payment/$statementId/connect-bank/error': typeof ProtectedStatementPaymentStatementIdConnectBankErrorRoute
  '/statement-payment/$statementId/connect-bank/success': typeof ProtectedStatementPaymentStatementIdConnectBankSuccessRoute
  '/home/statements/$id/': typeof ProtectedHomeStatementsIdIndexRoute
  '/statement-payment/$statementId/': typeof ProtectedStatementPaymentStatementIdPaymentIndexRoute
  '/home/accounts/credits/$accountId/bonus-shop': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteWithChildren
  '/accounts/credits/$accountId/close/confirm': typeof ProtectedAccountsCreditsAccountIdCloseConfirmRoute
  '/accounts/credits/$accountId/close/success': typeof ProtectedAccountsCreditsAccountIdCloseSuccessRoute
  '/accounts/deposits/$accountId/close/confirm': typeof ProtectedAccountsDepositsAccountIdCloseConfirmRoute
  '/accounts/deposits/$accountId/close/success': typeof ProtectedAccountsDepositsAccountIdCloseSuccessRoute
  '/accounts/invoices/$accountId/close/confirm': typeof ProtectedAccountsInvoicesAccountIdCloseConfirmRoute
  '/accounts/invoices/$accountId/close/success': typeof ProtectedAccountsInvoicesAccountIdCloseSuccessRoute
  '/accounts/loans/$accountId/close/confirm': typeof ProtectedAccountsLoansAccountIdCloseConfirmRoute
  '/accounts/loans/$accountId/close/success': typeof ProtectedAccountsLoansAccountIdCloseSuccessRoute
  '/bill-payment/$billId/callback/cancel': typeof ProtectedBillPaymentBillIdCallbackStatusesCancelRoute
  '/bill-payment/$billId/callback/error': typeof ProtectedBillPaymentBillIdCallbackStatusesErrorRoute
  '/bill-payment/$billId/callback/pending': typeof ProtectedBillPaymentBillIdCallbackStatusesPendingRoute
  '/bill-payment/$billId/callback/success': typeof ProtectedBillPaymentBillIdCallbackStatusesSuccessRoute
  '/bill-payment/$billId/callback/timeout': typeof ProtectedBillPaymentBillIdCallbackStatusesTimeoutRoute
  '/bill-payment/$billId/callback/unknown': typeof ProtectedBillPaymentBillIdCallbackStatusesUnknownRoute
  '/home/accounts/cards/$cardId/3ds-password': typeof ProtectedHomeAccountsCardsCardId3dsPasswordRoute
  '/home/accounts/credits/$accountId/bonus-checks': typeof ProtectedHomeAccountsCreditsAccountIdBonusChecksRoute
  '/home/accounts/credits/$accountId/invoices': typeof ProtectedHomeAccountsCreditsAccountIdInvoicesRoute
  '/home/accounts/credits/$accountId/transactions': typeof ProtectedHomeAccountsCreditsAccountIdTransactionsRoute
  '/home/accounts/deposits/$accountId/statements': typeof ProtectedHomeAccountsDepositsAccountIdStatementsRoute
  '/home/accounts/deposits/$accountId/transactions': typeof ProtectedHomeAccountsDepositsAccountIdTransactionsRoute
  '/home/accounts/loans/$accountId/invoices': typeof ProtectedHomeAccountsLoansAccountIdInvoicesRoute
  '/home/accounts/loans/$accountId/transactions': typeof ProtectedHomeAccountsLoansAccountIdTransactionsRoute
  '/home/accounts/one-time-credit/$accountId/invoice-history': typeof ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRoute
  '/home/accounts/one-time-credit/$accountId/transactions': typeof ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRoute
  '/statement-payment/$statementId/callback/cancel': typeof ProtectedStatementPaymentStatementIdCallbackStatusesCancelRoute
  '/statement-payment/$statementId/callback/error': typeof ProtectedStatementPaymentStatementIdCallbackStatusesErrorRoute
  '/statement-payment/$statementId/callback/pending': typeof ProtectedStatementPaymentStatementIdCallbackStatusesPendingRoute
  '/statement-payment/$statementId/callback/success': typeof ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRoute
  '/statement-payment/$statementId/callback/timeout': typeof ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRoute
  '/statement-payment/$statementId/callback/unknown': typeof ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRoute
  '/accounts/credits/$accountId/close': typeof ProtectedAccountsCreditsAccountIdCloseIndexRoute
  '/accounts/deposits/$accountId/close': typeof ProtectedAccountsDepositsAccountIdCloseIndexRoute
  '/accounts/invoices/$accountId/close': typeof ProtectedAccountsInvoicesAccountIdCloseIndexRoute
  '/accounts/loans/$accountId/close': typeof ProtectedAccountsLoansAccountIdCloseIndexRoute
  '/home/accounts/credits/$accountId/': typeof ProtectedHomeAccountsCreditsAccountIdIndexRoute
  '/home/accounts/deposits/$accountId/': typeof ProtectedHomeAccountsDepositsAccountIdIndexRoute
  '/home/accounts/loans/$accountId/': typeof ProtectedHomeAccountsLoansAccountIdIndexRoute
  '/home/accounts/one-time-credit/$accountId/': typeof ProtectedHomeAccountsOneTimeCreditAccountIdIndexRoute
  '/accounts/credits/$accountId/ppi/close/confirm': typeof ProtectedAccountsCreditsAccountIdPpiCloseConfirmRoute
  '/accounts/credits/$accountId/ppi/close/success': typeof ProtectedAccountsCreditsAccountIdPpiCloseSuccessRoute
  '/accounts/loans/$accountId/ppi/close/confirm': typeof ProtectedAccountsLoansAccountIdPpiCloseConfirmRoute
  '/accounts/loans/$accountId/ppi/close/success': typeof ProtectedAccountsLoansAccountIdPpiCloseSuccessRoute
  '/home/accounts/credits/$accountId/bonus-shop/cart': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopCartRoute
  '/home/accounts/credits/$accountId/cards/$cardId': typeof ProtectedHomeAccountsCreditsAccountIdCardsCardIdRoute
  '/transfer/callback/success/$fromAccountId/$toAccountId/$amount': typeof ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRoute
  '/accounts/credits/$accountId/ppi/close': typeof ProtectedAccountsCreditsAccountIdPpiCloseIndexRoute
  '/accounts/loans/$accountId/ppi/close': typeof ProtectedAccountsLoansAccountIdPpiCloseIndexRoute
  '/home/accounts/credits/$accountId/bonus-shop/': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRoute
  '/home/accounts/credits/$accountId/bonus-shop/order/$orderId': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$notFound': typeof NotFoundRoute
  '/app': typeof AppRoute
  '/auth': typeof AuthRoute
  '/auth-done': typeof AuthDoneRoute
  '/close': typeof CloseRoute
  '/config': typeof ConfigRoute
  '/demo': typeof DemoRoute
  '/error': typeof ErrorRoute
  '/logout': typeof LogoutRoute
  '/maintenance': typeof MaintenanceRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/deposit-onboarding': typeof ProtectedDepositOnboardingRouteRouteWithChildren
  '/bankid': typeof ProtectedBankidRoute
  '/deeplink/$': typeof DeeplinkSplatRoute
  '/login/consents': typeof LoginConsentsRoute
  '/login/error': typeof LoginErrorRoute
  '/zendesk/logout': typeof ZendeskLogoutRoute
  '/login': typeof LoginIndexRoute
  '/credit-account-payment/callback': typeof ProtectedCreditAccountPaymentCallbackRoute
  '/deposit-onboarding/choose-product': typeof ProtectedDepositOnboardingChooseProductRoute
  '/deposit-onboarding/choose-term': typeof ProtectedDepositOnboardingChooseTermRoute
  '/deposit-onboarding/denied': typeof ProtectedDepositOnboardingDeniedRoute
  '/deposit-onboarding/error': typeof ProtectedDepositOnboardingErrorRoute
  '/deposit-onboarding/max-account': typeof ProtectedDepositOnboardingMaxAccountRoute
  '/direct-transfer/callback': typeof ProtectedDirectTransferCallbackRoute
  '/home/purchases': typeof ProtectedHomePurchasesRoute
  '/kyc/$id': typeof ProtectedKycIdRoute
  '/kyc/success': typeof ProtectedKycSuccessRoute
  '/monthly-deposit/callback': typeof ProtectedMonthlyDepositCallbackRoute
  '/transfer/$accountId': typeof ProtectedTransferAccountIdRoute
  '/withdrawal/callback': typeof ProtectedWithdrawalCallbackRoute
  '/agreements': typeof ProtectedAgreementsIndexRoute
  '/bill-payment': typeof ProtectedBillPaymentIndexRoute
  '/credit-account-payment': typeof ProtectedCreditAccountPaymentIndexRoute
  '/home': typeof ProtectedHomeIndexRoute
  '/kyc': typeof ProtectedKycIndexRoute
  '/withdrawal': typeof ProtectedWithdrawalIndexRoute
  '/agreements/$agreementId/success': typeof ProtectedAgreementsAgreementIdSuccessRoute
  '/bill-payment/$billId/conversion-options': typeof ProtectedBillPaymentBillIdConversionOptionsRoute
  '/bill-payment/$billId/options': typeof ProtectedBillPaymentBillIdOptionsRoute
  '/connected-account/add/callback': typeof ProtectedConnectedAccountAddCallbackRoute
  '/connected-account/remove/callback': typeof ProtectedConnectedAccountRemoveCallbackRoute
  '/credit-account-payment/create/$id': typeof ProtectedCreditAccountPaymentCreateIdRoute
  '/deposit-onboarding/$applicationId/callback': typeof ProtectedDepositOnboardingApplicationIdCallbackRoute
  '/deposit-onboarding/$applicationId/exists': typeof ProtectedDepositOnboardingApplicationIdExistsRoute
  '/deposit-onboarding/$applicationId/pending': typeof ProtectedDepositOnboardingApplicationIdPendingRoute
  '/deposit-onboarding/$applicationId/resume': typeof ProtectedDepositOnboardingApplicationIdResumeRoute
  '/deposit-onboarding/$applicationId/summary': typeof ProtectedDepositOnboardingApplicationIdSummaryRoute
  '/home/service/account': typeof ProtectedHomeServiceAccountRoute
  '/home/service/documents': typeof ProtectedHomeServiceDocumentsRoute
  '/home/service/kyc': typeof ProtectedHomeServiceKycRoute
  '/home/service/language': typeof ProtectedHomeServiceLanguageRoute
  '/home/service/messages': typeof ProtectedHomeServiceMessagesRoute
  '/home/service/notifications': typeof ProtectedHomeServiceNotificationsRoute
  '/home/service/profile': typeof ProtectedHomeServiceProfileRoute
  '/home/service/saved-account': typeof ProtectedHomeServiceSavedAccountRoute
  '/home/service/theme': typeof ProtectedHomeServiceThemeRoute
  '/savings-close/$id/$accountNumber': typeof ProtectedSavingsCloseIdAccountNumberRoute
  '/statement-payment/$statementId': typeof ProtectedStatementPaymentStatementIdPaymentIndexRoute
  '/transfer/callback/failed': typeof ProtectedTransferCallbackFailedRoute
  '/withdrawal/accounts/callback': typeof ProtectedWithdrawalAccountsCallbackRoute
  '/withdrawal/openbanking/callback': typeof ProtectedWithdrawalOpenbankingCallbackRoute
  '/agreements/$agreementId': typeof ProtectedAgreementsAgreementIdIndexRoute
  '/bill-payment/$billId': typeof ProtectedBillPaymentBillIdIndexRoute
  '/connected-account/add': typeof ProtectedConnectedAccountAddIndexRoute
  '/credit-account-payment/create': typeof ProtectedCreditAccountPaymentCreateIndexRoute
  '/deposit-onboarding/$applicationId': typeof ProtectedDepositOnboardingApplicationIdIndexRoute
  '/home/accounts': typeof ProtectedHomeAccountsIndexRoute
  '/home/discover': typeof ProtectedHomeDiscoverIndexRoute
  '/home/service': typeof ProtectedHomeServiceIndexRoute
  '/home/statements': typeof ProtectedHomeStatementsIndexRoute
  '/bill-payment/$billId/callback': typeof ProtectedBillPaymentBillIdCallbackStatusesRouteWithChildren
  '/bill-payment/$billId/callback/open-banking': typeof ProtectedBillPaymentBillIdCallbackOpenBankingRoute
  '/bill-payment/$billId/connect-bank/callback': typeof ProtectedBillPaymentBillIdConnectBankCallbackRoute
  '/bill-payment/$billId/connect-bank/cancel': typeof ProtectedBillPaymentBillIdConnectBankCancelRoute
  '/bill-payment/$billId/connect-bank/error': typeof ProtectedBillPaymentBillIdConnectBankErrorRoute
  '/bill-payment/$billId/connect-bank/success': typeof ProtectedBillPaymentBillIdConnectBankSuccessRoute
  '/deposit-onboarding/$applicationId/$productCode/$accountId': typeof ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRoute
  '/deposit-onboarding/$applicationId/$productCode/add-funds': typeof ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRoute
  '/deposit-onboarding/$applicationId/$productCode/deposit-account': typeof ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRoute
  '/home/accounts/cards/$cardId': typeof ProtectedHomeAccountsCardsCardIdRoute
  '/home/bills/$id/open-banking': typeof ProtectedHomeBillsIdOpenBankingRoute
  '/home/service/connect-bank/callback': typeof ProtectedHomeServiceConnectBankCallbackRoute
  '/home/service/connect-bank/cancel': typeof ProtectedHomeServiceConnectBankCancelRoute
  '/home/service/connect-bank/error': typeof ProtectedHomeServiceConnectBankErrorRoute
  '/home/service/connect-bank/success': typeof ProtectedHomeServiceConnectBankSuccessRoute
  '/home/statements/$id/connected-account-payment': typeof ProtectedHomeStatementsIdConnectedAccountPaymentRoute
  '/home/statements/$id/open-banking': typeof ProtectedHomeStatementsIdOpenBankingRoute
  '/statement-payment/$statementId/options': typeof ProtectedStatementPaymentStatementIdPaymentOptionsRoute
  '/statement-payment/$statementId/select': typeof ProtectedStatementPaymentStatementIdPaymentSelectRoute
  '/statement-payment/$statementId/callback': typeof ProtectedStatementPaymentStatementIdCallbackStatusesRouteWithChildren
  '/statement-payment/$statementId/callback/connected-account': typeof ProtectedStatementPaymentStatementIdCallbackConnectedAccountRoute
  '/statement-payment/$statementId/callback/open-banking': typeof ProtectedStatementPaymentStatementIdCallbackOpenBankingRoute
  '/statement-payment/$statementId/cancel/callback': typeof ProtectedStatementPaymentStatementIdCancelCallbackRoute
  '/statement-payment/$statementId/connect-bank/callback': typeof ProtectedStatementPaymentStatementIdConnectBankCallbackRoute
  '/statement-payment/$statementId/connect-bank/cancel': typeof ProtectedStatementPaymentStatementIdConnectBankCancelRoute
  '/statement-payment/$statementId/connect-bank/error': typeof ProtectedStatementPaymentStatementIdConnectBankErrorRoute
  '/statement-payment/$statementId/connect-bank/success': typeof ProtectedStatementPaymentStatementIdConnectBankSuccessRoute
  '/home/statements/$id': typeof ProtectedHomeStatementsIdIndexRoute
  '/accounts/credits/$accountId/close/confirm': typeof ProtectedAccountsCreditsAccountIdCloseConfirmRoute
  '/accounts/credits/$accountId/close/success': typeof ProtectedAccountsCreditsAccountIdCloseSuccessRoute
  '/accounts/deposits/$accountId/close/confirm': typeof ProtectedAccountsDepositsAccountIdCloseConfirmRoute
  '/accounts/deposits/$accountId/close/success': typeof ProtectedAccountsDepositsAccountIdCloseSuccessRoute
  '/accounts/invoices/$accountId/close/confirm': typeof ProtectedAccountsInvoicesAccountIdCloseConfirmRoute
  '/accounts/invoices/$accountId/close/success': typeof ProtectedAccountsInvoicesAccountIdCloseSuccessRoute
  '/accounts/loans/$accountId/close/confirm': typeof ProtectedAccountsLoansAccountIdCloseConfirmRoute
  '/accounts/loans/$accountId/close/success': typeof ProtectedAccountsLoansAccountIdCloseSuccessRoute
  '/bill-payment/$billId/callback/cancel': typeof ProtectedBillPaymentBillIdCallbackStatusesCancelRoute
  '/bill-payment/$billId/callback/error': typeof ProtectedBillPaymentBillIdCallbackStatusesErrorRoute
  '/bill-payment/$billId/callback/pending': typeof ProtectedBillPaymentBillIdCallbackStatusesPendingRoute
  '/bill-payment/$billId/callback/success': typeof ProtectedBillPaymentBillIdCallbackStatusesSuccessRoute
  '/bill-payment/$billId/callback/timeout': typeof ProtectedBillPaymentBillIdCallbackStatusesTimeoutRoute
  '/bill-payment/$billId/callback/unknown': typeof ProtectedBillPaymentBillIdCallbackStatusesUnknownRoute
  '/home/accounts/cards/$cardId/3ds-password': typeof ProtectedHomeAccountsCardsCardId3dsPasswordRoute
  '/home/accounts/credits/$accountId/bonus-checks': typeof ProtectedHomeAccountsCreditsAccountIdBonusChecksRoute
  '/home/accounts/credits/$accountId/invoices': typeof ProtectedHomeAccountsCreditsAccountIdInvoicesRoute
  '/home/accounts/credits/$accountId/transactions': typeof ProtectedHomeAccountsCreditsAccountIdTransactionsRoute
  '/home/accounts/deposits/$accountId/statements': typeof ProtectedHomeAccountsDepositsAccountIdStatementsRoute
  '/home/accounts/deposits/$accountId/transactions': typeof ProtectedHomeAccountsDepositsAccountIdTransactionsRoute
  '/home/accounts/loans/$accountId/invoices': typeof ProtectedHomeAccountsLoansAccountIdInvoicesRoute
  '/home/accounts/loans/$accountId/transactions': typeof ProtectedHomeAccountsLoansAccountIdTransactionsRoute
  '/home/accounts/one-time-credit/$accountId/invoice-history': typeof ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRoute
  '/home/accounts/one-time-credit/$accountId/transactions': typeof ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRoute
  '/statement-payment/$statementId/callback/cancel': typeof ProtectedStatementPaymentStatementIdCallbackStatusesCancelRoute
  '/statement-payment/$statementId/callback/error': typeof ProtectedStatementPaymentStatementIdCallbackStatusesErrorRoute
  '/statement-payment/$statementId/callback/pending': typeof ProtectedStatementPaymentStatementIdCallbackStatusesPendingRoute
  '/statement-payment/$statementId/callback/success': typeof ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRoute
  '/statement-payment/$statementId/callback/timeout': typeof ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRoute
  '/statement-payment/$statementId/callback/unknown': typeof ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRoute
  '/accounts/credits/$accountId/close': typeof ProtectedAccountsCreditsAccountIdCloseIndexRoute
  '/accounts/deposits/$accountId/close': typeof ProtectedAccountsDepositsAccountIdCloseIndexRoute
  '/accounts/invoices/$accountId/close': typeof ProtectedAccountsInvoicesAccountIdCloseIndexRoute
  '/accounts/loans/$accountId/close': typeof ProtectedAccountsLoansAccountIdCloseIndexRoute
  '/home/accounts/credits/$accountId': typeof ProtectedHomeAccountsCreditsAccountIdIndexRoute
  '/home/accounts/deposits/$accountId': typeof ProtectedHomeAccountsDepositsAccountIdIndexRoute
  '/home/accounts/loans/$accountId': typeof ProtectedHomeAccountsLoansAccountIdIndexRoute
  '/home/accounts/one-time-credit/$accountId': typeof ProtectedHomeAccountsOneTimeCreditAccountIdIndexRoute
  '/accounts/credits/$accountId/ppi/close/confirm': typeof ProtectedAccountsCreditsAccountIdPpiCloseConfirmRoute
  '/accounts/credits/$accountId/ppi/close/success': typeof ProtectedAccountsCreditsAccountIdPpiCloseSuccessRoute
  '/accounts/loans/$accountId/ppi/close/confirm': typeof ProtectedAccountsLoansAccountIdPpiCloseConfirmRoute
  '/accounts/loans/$accountId/ppi/close/success': typeof ProtectedAccountsLoansAccountIdPpiCloseSuccessRoute
  '/home/accounts/credits/$accountId/bonus-shop/cart': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopCartRoute
  '/home/accounts/credits/$accountId/cards/$cardId': typeof ProtectedHomeAccountsCreditsAccountIdCardsCardIdRoute
  '/transfer/callback/success/$fromAccountId/$toAccountId/$amount': typeof ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRoute
  '/accounts/credits/$accountId/ppi/close': typeof ProtectedAccountsCreditsAccountIdPpiCloseIndexRoute
  '/accounts/loans/$accountId/ppi/close': typeof ProtectedAccountsLoansAccountIdPpiCloseIndexRoute
  '/home/accounts/credits/$accountId/bonus-shop': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRoute
  '/home/accounts/credits/$accountId/bonus-shop/order/$orderId': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$notFound': typeof NotFoundRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/app': typeof AppRoute
  '/auth': typeof AuthRoute
  '/auth-done': typeof AuthDoneRoute
  '/close': typeof CloseRoute
  '/config': typeof ConfigRoute
  '/demo': typeof DemoRoute
  '/error': typeof ErrorRoute
  '/logout': typeof LogoutRoute
  '/maintenance': typeof MaintenanceRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/_protected/deposit-onboarding': typeof ProtectedDepositOnboardingRouteRouteWithChildren
  '/_protected/home': typeof ProtectedHomeRouteRouteWithChildren
  '/_protected/bankid': typeof ProtectedBankidRoute
  '/deeplink/$': typeof DeeplinkSplatRoute
  '/login/consents': typeof LoginConsentsRoute
  '/login/error': typeof LoginErrorRoute
  '/zendesk/logout': typeof ZendeskLogoutRoute
  '/login/': typeof LoginIndexRoute
  '/_protected/home/accounts': typeof ProtectedHomeAccountsRouteRouteWithChildren
  '/_protected/home/discover': typeof ProtectedHomeDiscoverRouteRouteWithChildren
  '/_protected/home/service': typeof ProtectedHomeServiceRouteRouteWithChildren
  '/_protected/home/statements': typeof ProtectedHomeStatementsRouteRouteWithChildren
  '/_protected/credit-account-payment/callback': typeof ProtectedCreditAccountPaymentCallbackRoute
  '/_protected/deposit-onboarding/$applicationId': typeof ProtectedDepositOnboardingApplicationIdRouteWithChildren
  '/_protected/deposit-onboarding/choose-product': typeof ProtectedDepositOnboardingChooseProductRoute
  '/_protected/deposit-onboarding/choose-term': typeof ProtectedDepositOnboardingChooseTermRoute
  '/_protected/deposit-onboarding/denied': typeof ProtectedDepositOnboardingDeniedRoute
  '/_protected/deposit-onboarding/error': typeof ProtectedDepositOnboardingErrorRoute
  '/_protected/deposit-onboarding/max-account': typeof ProtectedDepositOnboardingMaxAccountRoute
  '/_protected/direct-transfer/callback': typeof ProtectedDirectTransferCallbackRoute
  '/_protected/home/purchases': typeof ProtectedHomePurchasesRoute
  '/_protected/kyc/$id': typeof ProtectedKycIdRoute
  '/_protected/kyc/success': typeof ProtectedKycSuccessRoute
  '/_protected/monthly-deposit/callback': typeof ProtectedMonthlyDepositCallbackRoute
  '/_protected/transfer/$accountId': typeof ProtectedTransferAccountIdRoute
  '/_protected/withdrawal/callback': typeof ProtectedWithdrawalCallbackRoute
  '/_protected/agreements/': typeof ProtectedAgreementsIndexRoute
  '/_protected/bill-payment/': typeof ProtectedBillPaymentIndexRoute
  '/_protected/credit-account-payment/': typeof ProtectedCreditAccountPaymentIndexRoute
  '/_protected/home/': typeof ProtectedHomeIndexRoute
  '/_protected/kyc/': typeof ProtectedKycIndexRoute
  '/_protected/withdrawal/': typeof ProtectedWithdrawalIndexRoute
  '/_protected/home/statements/$id': typeof ProtectedHomeStatementsIdRouteRouteWithChildren
  '/_protected/agreements/$agreementId/success': typeof ProtectedAgreementsAgreementIdSuccessRoute
  '/_protected/bill-payment/$billId/conversion-options': typeof ProtectedBillPaymentBillIdConversionOptionsRoute
  '/_protected/bill-payment/$billId/options': typeof ProtectedBillPaymentBillIdOptionsRoute
  '/_protected/connected-account/add/callback': typeof ProtectedConnectedAccountAddCallbackRoute
  '/_protected/connected-account/remove/callback': typeof ProtectedConnectedAccountRemoveCallbackRoute
  '/_protected/credit-account-payment/create/$id': typeof ProtectedCreditAccountPaymentCreateIdRoute
  '/_protected/deposit-onboarding/$applicationId/callback': typeof ProtectedDepositOnboardingApplicationIdCallbackRoute
  '/_protected/deposit-onboarding/$applicationId/exists': typeof ProtectedDepositOnboardingApplicationIdExistsRoute
  '/_protected/deposit-onboarding/$applicationId/pending': typeof ProtectedDepositOnboardingApplicationIdPendingRoute
  '/_protected/deposit-onboarding/$applicationId/resume': typeof ProtectedDepositOnboardingApplicationIdResumeRoute
  '/_protected/deposit-onboarding/$applicationId/summary': typeof ProtectedDepositOnboardingApplicationIdSummaryRoute
  '/_protected/home/service/account': typeof ProtectedHomeServiceAccountRoute
  '/_protected/home/service/documents': typeof ProtectedHomeServiceDocumentsRoute
  '/_protected/home/service/kyc': typeof ProtectedHomeServiceKycRoute
  '/_protected/home/service/language': typeof ProtectedHomeServiceLanguageRoute
  '/_protected/home/service/messages': typeof ProtectedHomeServiceMessagesRoute
  '/_protected/home/service/notifications': typeof ProtectedHomeServiceNotificationsRoute
  '/_protected/home/service/profile': typeof ProtectedHomeServiceProfileRoute
  '/_protected/home/service/saved-account': typeof ProtectedHomeServiceSavedAccountRoute
  '/_protected/home/service/theme': typeof ProtectedHomeServiceThemeRoute
  '/_protected/savings-close/$id/$accountNumber': typeof ProtectedSavingsCloseIdAccountNumberRoute
  '/_protected/statement-payment/$statementId': typeof ProtectedStatementPaymentStatementIdRouteWithChildren
  '/_protected/statement-payment/$statementId/_payment': typeof ProtectedStatementPaymentStatementIdPaymentRouteWithChildren
  '/_protected/transfer/callback/failed': typeof ProtectedTransferCallbackFailedRoute
  '/_protected/withdrawal/accounts/callback': typeof ProtectedWithdrawalAccountsCallbackRoute
  '/_protected/withdrawal/openbanking/callback': typeof ProtectedWithdrawalOpenbankingCallbackRoute
  '/_protected/agreements/$agreementId/': typeof ProtectedAgreementsAgreementIdIndexRoute
  '/_protected/bill-payment/$billId/': typeof ProtectedBillPaymentBillIdIndexRoute
  '/_protected/connected-account/add/': typeof ProtectedConnectedAccountAddIndexRoute
  '/_protected/credit-account-payment/create/': typeof ProtectedCreditAccountPaymentCreateIndexRoute
  '/_protected/deposit-onboarding/$applicationId/': typeof ProtectedDepositOnboardingApplicationIdIndexRoute
  '/_protected/home/accounts/': typeof ProtectedHomeAccountsIndexRoute
  '/_protected/home/discover/': typeof ProtectedHomeDiscoverIndexRoute
  '/_protected/home/service/': typeof ProtectedHomeServiceIndexRoute
  '/_protected/home/statements/': typeof ProtectedHomeStatementsIndexRoute
  '/_protected/home/accounts/credits/$accountId': typeof ProtectedHomeAccountsCreditsAccountIdRouteRouteWithChildren
  '/_protected/home/accounts/deposits/$accountId': typeof ProtectedHomeAccountsDepositsAccountIdRouteRouteWithChildren
  '/_protected/home/accounts/loans/$accountId': typeof ProtectedHomeAccountsLoansAccountIdRouteRouteWithChildren
  '/_protected/home/accounts/one-time-credit/$accountId': typeof ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteWithChildren
  '/_protected/bill-payment/$billId/callback': typeof ProtectedBillPaymentBillIdCallbackRouteWithChildren
  '/_protected/bill-payment/$billId/callback/_statuses': typeof ProtectedBillPaymentBillIdCallbackStatusesRouteWithChildren
  '/_protected/bill-payment/$billId/callback/open-banking': typeof ProtectedBillPaymentBillIdCallbackOpenBankingRoute
  '/_protected/bill-payment/$billId/connect-bank/callback': typeof ProtectedBillPaymentBillIdConnectBankCallbackRoute
  '/_protected/bill-payment/$billId/connect-bank/cancel': typeof ProtectedBillPaymentBillIdConnectBankCancelRoute
  '/_protected/bill-payment/$billId/connect-bank/error': typeof ProtectedBillPaymentBillIdConnectBankErrorRoute
  '/_protected/bill-payment/$billId/connect-bank/success': typeof ProtectedBillPaymentBillIdConnectBankSuccessRoute
  '/_protected/deposit-onboarding/$applicationId/$productCode/$accountId': typeof ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRoute
  '/_protected/deposit-onboarding/$applicationId/$productCode/add-funds': typeof ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRoute
  '/_protected/deposit-onboarding/$applicationId/$productCode/deposit-account': typeof ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRoute
  '/_protected/home/accounts/cards/$cardId': typeof ProtectedHomeAccountsCardsCardIdRoute
  '/_protected/home/bills/$id/open-banking': typeof ProtectedHomeBillsIdOpenBankingRoute
  '/_protected/home/service/connect-bank/callback': typeof ProtectedHomeServiceConnectBankCallbackRoute
  '/_protected/home/service/connect-bank/cancel': typeof ProtectedHomeServiceConnectBankCancelRoute
  '/_protected/home/service/connect-bank/error': typeof ProtectedHomeServiceConnectBankErrorRoute
  '/_protected/home/service/connect-bank/success': typeof ProtectedHomeServiceConnectBankSuccessRoute
  '/_protected/home/statements/$id/connected-account-payment': typeof ProtectedHomeStatementsIdConnectedAccountPaymentRoute
  '/_protected/home/statements/$id/open-banking': typeof ProtectedHomeStatementsIdOpenBankingRoute
  '/_protected/statement-payment/$statementId/_payment/options': typeof ProtectedStatementPaymentStatementIdPaymentOptionsRoute
  '/_protected/statement-payment/$statementId/_payment/select': typeof ProtectedStatementPaymentStatementIdPaymentSelectRoute
  '/_protected/statement-payment/$statementId/callback': typeof ProtectedStatementPaymentStatementIdCallbackRouteWithChildren
  '/_protected/statement-payment/$statementId/callback/_statuses': typeof ProtectedStatementPaymentStatementIdCallbackStatusesRouteWithChildren
  '/_protected/statement-payment/$statementId/callback/connected-account': typeof ProtectedStatementPaymentStatementIdCallbackConnectedAccountRoute
  '/_protected/statement-payment/$statementId/callback/open-banking': typeof ProtectedStatementPaymentStatementIdCallbackOpenBankingRoute
  '/_protected/statement-payment/$statementId/cancel/callback': typeof ProtectedStatementPaymentStatementIdCancelCallbackRoute
  '/_protected/statement-payment/$statementId/connect-bank/callback': typeof ProtectedStatementPaymentStatementIdConnectBankCallbackRoute
  '/_protected/statement-payment/$statementId/connect-bank/cancel': typeof ProtectedStatementPaymentStatementIdConnectBankCancelRoute
  '/_protected/statement-payment/$statementId/connect-bank/error': typeof ProtectedStatementPaymentStatementIdConnectBankErrorRoute
  '/_protected/statement-payment/$statementId/connect-bank/success': typeof ProtectedStatementPaymentStatementIdConnectBankSuccessRoute
  '/_protected/home/statements/$id/': typeof ProtectedHomeStatementsIdIndexRoute
  '/_protected/statement-payment/$statementId/_payment/': typeof ProtectedStatementPaymentStatementIdPaymentIndexRoute
  '/_protected/home/accounts/credits/$accountId/bonus-shop': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteWithChildren
  '/_protected/accounts/credits/$accountId/close/confirm': typeof ProtectedAccountsCreditsAccountIdCloseConfirmRoute
  '/_protected/accounts/credits/$accountId/close/success': typeof ProtectedAccountsCreditsAccountIdCloseSuccessRoute
  '/_protected/accounts/deposits/$accountId/close/confirm': typeof ProtectedAccountsDepositsAccountIdCloseConfirmRoute
  '/_protected/accounts/deposits/$accountId/close/success': typeof ProtectedAccountsDepositsAccountIdCloseSuccessRoute
  '/_protected/accounts/invoices/$accountId/close/confirm': typeof ProtectedAccountsInvoicesAccountIdCloseConfirmRoute
  '/_protected/accounts/invoices/$accountId/close/success': typeof ProtectedAccountsInvoicesAccountIdCloseSuccessRoute
  '/_protected/accounts/loans/$accountId/close/confirm': typeof ProtectedAccountsLoansAccountIdCloseConfirmRoute
  '/_protected/accounts/loans/$accountId/close/success': typeof ProtectedAccountsLoansAccountIdCloseSuccessRoute
  '/_protected/bill-payment/$billId/callback/_statuses/cancel': typeof ProtectedBillPaymentBillIdCallbackStatusesCancelRoute
  '/_protected/bill-payment/$billId/callback/_statuses/error': typeof ProtectedBillPaymentBillIdCallbackStatusesErrorRoute
  '/_protected/bill-payment/$billId/callback/_statuses/pending': typeof ProtectedBillPaymentBillIdCallbackStatusesPendingRoute
  '/_protected/bill-payment/$billId/callback/_statuses/success': typeof ProtectedBillPaymentBillIdCallbackStatusesSuccessRoute
  '/_protected/bill-payment/$billId/callback/_statuses/timeout': typeof ProtectedBillPaymentBillIdCallbackStatusesTimeoutRoute
  '/_protected/bill-payment/$billId/callback/_statuses/unknown': typeof ProtectedBillPaymentBillIdCallbackStatusesUnknownRoute
  '/_protected/home/accounts/cards/$cardId_/3ds-password': typeof ProtectedHomeAccountsCardsCardId3dsPasswordRoute
  '/_protected/home/accounts/credits/$accountId/bonus-checks': typeof ProtectedHomeAccountsCreditsAccountIdBonusChecksRoute
  '/_protected/home/accounts/credits/$accountId/invoices': typeof ProtectedHomeAccountsCreditsAccountIdInvoicesRoute
  '/_protected/home/accounts/credits/$accountId/transactions': typeof ProtectedHomeAccountsCreditsAccountIdTransactionsRoute
  '/_protected/home/accounts/deposits/$accountId/statements': typeof ProtectedHomeAccountsDepositsAccountIdStatementsRoute
  '/_protected/home/accounts/deposits/$accountId/transactions': typeof ProtectedHomeAccountsDepositsAccountIdTransactionsRoute
  '/_protected/home/accounts/loans/$accountId/invoices': typeof ProtectedHomeAccountsLoansAccountIdInvoicesRoute
  '/_protected/home/accounts/loans/$accountId/transactions': typeof ProtectedHomeAccountsLoansAccountIdTransactionsRoute
  '/_protected/home/accounts/one-time-credit/$accountId/invoice-history': typeof ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRoute
  '/_protected/home/accounts/one-time-credit/$accountId/transactions': typeof ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRoute
  '/_protected/statement-payment/$statementId/callback/_statuses/cancel': typeof ProtectedStatementPaymentStatementIdCallbackStatusesCancelRoute
  '/_protected/statement-payment/$statementId/callback/_statuses/error': typeof ProtectedStatementPaymentStatementIdCallbackStatusesErrorRoute
  '/_protected/statement-payment/$statementId/callback/_statuses/pending': typeof ProtectedStatementPaymentStatementIdCallbackStatusesPendingRoute
  '/_protected/statement-payment/$statementId/callback/_statuses/success': typeof ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRoute
  '/_protected/statement-payment/$statementId/callback/_statuses/timeout': typeof ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRoute
  '/_protected/statement-payment/$statementId/callback/_statuses/unknown': typeof ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRoute
  '/_protected/accounts/credits/$accountId/close/': typeof ProtectedAccountsCreditsAccountIdCloseIndexRoute
  '/_protected/accounts/deposits/$accountId/close/': typeof ProtectedAccountsDepositsAccountIdCloseIndexRoute
  '/_protected/accounts/invoices/$accountId/close/': typeof ProtectedAccountsInvoicesAccountIdCloseIndexRoute
  '/_protected/accounts/loans/$accountId/close/': typeof ProtectedAccountsLoansAccountIdCloseIndexRoute
  '/_protected/home/accounts/credits/$accountId/': typeof ProtectedHomeAccountsCreditsAccountIdIndexRoute
  '/_protected/home/accounts/deposits/$accountId/': typeof ProtectedHomeAccountsDepositsAccountIdIndexRoute
  '/_protected/home/accounts/loans/$accountId/': typeof ProtectedHomeAccountsLoansAccountIdIndexRoute
  '/_protected/home/accounts/one-time-credit/$accountId/': typeof ProtectedHomeAccountsOneTimeCreditAccountIdIndexRoute
  '/_protected/accounts/credits/$accountId/ppi/close/confirm': typeof ProtectedAccountsCreditsAccountIdPpiCloseConfirmRoute
  '/_protected/accounts/credits/$accountId/ppi/close/success': typeof ProtectedAccountsCreditsAccountIdPpiCloseSuccessRoute
  '/_protected/accounts/loans/$accountId/ppi/close/confirm': typeof ProtectedAccountsLoansAccountIdPpiCloseConfirmRoute
  '/_protected/accounts/loans/$accountId/ppi/close/success': typeof ProtectedAccountsLoansAccountIdPpiCloseSuccessRoute
  '/_protected/home/accounts/credits/$accountId/bonus-shop/cart': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopCartRoute
  '/_protected/home/accounts/credits/$accountId/cards/$cardId': typeof ProtectedHomeAccountsCreditsAccountIdCardsCardIdRoute
  '/_protected/transfer/callback/success/$fromAccountId/$toAccountId/$amount': typeof ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRoute
  '/_protected/accounts/credits/$accountId/ppi/close/': typeof ProtectedAccountsCreditsAccountIdPpiCloseIndexRoute
  '/_protected/accounts/loans/$accountId/ppi/close/': typeof ProtectedAccountsLoansAccountIdPpiCloseIndexRoute
  '/_protected/home/accounts/credits/$accountId/bonus-shop/': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRoute
  '/_protected/home/accounts/credits/$accountId/bonus-shop/order/$orderId': typeof ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$notFound'
    | '/app'
    | '/auth'
    | '/auth-done'
    | '/close'
    | '/config'
    | '/demo'
    | '/error'
    | '/logout'
    | '/maintenance'
    | '/terms-and-conditions'
    | '/deposit-onboarding'
    | '/home'
    | '/bankid'
    | '/deeplink/$'
    | '/login/consents'
    | '/login/error'
    | '/zendesk/logout'
    | '/login'
    | '/home/accounts'
    | '/home/discover'
    | '/home/service'
    | '/home/statements'
    | '/credit-account-payment/callback'
    | '/deposit-onboarding/$applicationId'
    | '/deposit-onboarding/choose-product'
    | '/deposit-onboarding/choose-term'
    | '/deposit-onboarding/denied'
    | '/deposit-onboarding/error'
    | '/deposit-onboarding/max-account'
    | '/direct-transfer/callback'
    | '/home/purchases'
    | '/kyc/$id'
    | '/kyc/success'
    | '/monthly-deposit/callback'
    | '/transfer/$accountId'
    | '/withdrawal/callback'
    | '/agreements'
    | '/bill-payment'
    | '/credit-account-payment'
    | '/home/'
    | '/kyc'
    | '/withdrawal'
    | '/home/statements/$id'
    | '/agreements/$agreementId/success'
    | '/bill-payment/$billId/conversion-options'
    | '/bill-payment/$billId/options'
    | '/connected-account/add/callback'
    | '/connected-account/remove/callback'
    | '/credit-account-payment/create/$id'
    | '/deposit-onboarding/$applicationId/callback'
    | '/deposit-onboarding/$applicationId/exists'
    | '/deposit-onboarding/$applicationId/pending'
    | '/deposit-onboarding/$applicationId/resume'
    | '/deposit-onboarding/$applicationId/summary'
    | '/home/service/account'
    | '/home/service/documents'
    | '/home/service/kyc'
    | '/home/service/language'
    | '/home/service/messages'
    | '/home/service/notifications'
    | '/home/service/profile'
    | '/home/service/saved-account'
    | '/home/service/theme'
    | '/savings-close/$id/$accountNumber'
    | '/statement-payment/$statementId'
    | '/transfer/callback/failed'
    | '/withdrawal/accounts/callback'
    | '/withdrawal/openbanking/callback'
    | '/agreements/$agreementId'
    | '/bill-payment/$billId'
    | '/connected-account/add'
    | '/credit-account-payment/create'
    | '/deposit-onboarding/$applicationId/'
    | '/home/accounts/'
    | '/home/discover/'
    | '/home/service/'
    | '/home/statements/'
    | '/home/accounts/credits/$accountId'
    | '/home/accounts/deposits/$accountId'
    | '/home/accounts/loans/$accountId'
    | '/home/accounts/one-time-credit/$accountId'
    | '/bill-payment/$billId/callback'
    | '/bill-payment/$billId/callback/open-banking'
    | '/bill-payment/$billId/connect-bank/callback'
    | '/bill-payment/$billId/connect-bank/cancel'
    | '/bill-payment/$billId/connect-bank/error'
    | '/bill-payment/$billId/connect-bank/success'
    | '/deposit-onboarding/$applicationId/$productCode/$accountId'
    | '/deposit-onboarding/$applicationId/$productCode/add-funds'
    | '/deposit-onboarding/$applicationId/$productCode/deposit-account'
    | '/home/accounts/cards/$cardId'
    | '/home/bills/$id/open-banking'
    | '/home/service/connect-bank/callback'
    | '/home/service/connect-bank/cancel'
    | '/home/service/connect-bank/error'
    | '/home/service/connect-bank/success'
    | '/home/statements/$id/connected-account-payment'
    | '/home/statements/$id/open-banking'
    | '/statement-payment/$statementId/options'
    | '/statement-payment/$statementId/select'
    | '/statement-payment/$statementId/callback'
    | '/statement-payment/$statementId/callback/connected-account'
    | '/statement-payment/$statementId/callback/open-banking'
    | '/statement-payment/$statementId/cancel/callback'
    | '/statement-payment/$statementId/connect-bank/callback'
    | '/statement-payment/$statementId/connect-bank/cancel'
    | '/statement-payment/$statementId/connect-bank/error'
    | '/statement-payment/$statementId/connect-bank/success'
    | '/home/statements/$id/'
    | '/statement-payment/$statementId/'
    | '/home/accounts/credits/$accountId/bonus-shop'
    | '/accounts/credits/$accountId/close/confirm'
    | '/accounts/credits/$accountId/close/success'
    | '/accounts/deposits/$accountId/close/confirm'
    | '/accounts/deposits/$accountId/close/success'
    | '/accounts/invoices/$accountId/close/confirm'
    | '/accounts/invoices/$accountId/close/success'
    | '/accounts/loans/$accountId/close/confirm'
    | '/accounts/loans/$accountId/close/success'
    | '/bill-payment/$billId/callback/cancel'
    | '/bill-payment/$billId/callback/error'
    | '/bill-payment/$billId/callback/pending'
    | '/bill-payment/$billId/callback/success'
    | '/bill-payment/$billId/callback/timeout'
    | '/bill-payment/$billId/callback/unknown'
    | '/home/accounts/cards/$cardId/3ds-password'
    | '/home/accounts/credits/$accountId/bonus-checks'
    | '/home/accounts/credits/$accountId/invoices'
    | '/home/accounts/credits/$accountId/transactions'
    | '/home/accounts/deposits/$accountId/statements'
    | '/home/accounts/deposits/$accountId/transactions'
    | '/home/accounts/loans/$accountId/invoices'
    | '/home/accounts/loans/$accountId/transactions'
    | '/home/accounts/one-time-credit/$accountId/invoice-history'
    | '/home/accounts/one-time-credit/$accountId/transactions'
    | '/statement-payment/$statementId/callback/cancel'
    | '/statement-payment/$statementId/callback/error'
    | '/statement-payment/$statementId/callback/pending'
    | '/statement-payment/$statementId/callback/success'
    | '/statement-payment/$statementId/callback/timeout'
    | '/statement-payment/$statementId/callback/unknown'
    | '/accounts/credits/$accountId/close'
    | '/accounts/deposits/$accountId/close'
    | '/accounts/invoices/$accountId/close'
    | '/accounts/loans/$accountId/close'
    | '/home/accounts/credits/$accountId/'
    | '/home/accounts/deposits/$accountId/'
    | '/home/accounts/loans/$accountId/'
    | '/home/accounts/one-time-credit/$accountId/'
    | '/accounts/credits/$accountId/ppi/close/confirm'
    | '/accounts/credits/$accountId/ppi/close/success'
    | '/accounts/loans/$accountId/ppi/close/confirm'
    | '/accounts/loans/$accountId/ppi/close/success'
    | '/home/accounts/credits/$accountId/bonus-shop/cart'
    | '/home/accounts/credits/$accountId/cards/$cardId'
    | '/transfer/callback/success/$fromAccountId/$toAccountId/$amount'
    | '/accounts/credits/$accountId/ppi/close'
    | '/accounts/loans/$accountId/ppi/close'
    | '/home/accounts/credits/$accountId/bonus-shop/'
    | '/home/accounts/credits/$accountId/bonus-shop/order/$orderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$notFound'
    | '/app'
    | '/auth'
    | '/auth-done'
    | '/close'
    | '/config'
    | '/demo'
    | '/error'
    | '/logout'
    | '/maintenance'
    | '/terms-and-conditions'
    | '/deposit-onboarding'
    | '/bankid'
    | '/deeplink/$'
    | '/login/consents'
    | '/login/error'
    | '/zendesk/logout'
    | '/login'
    | '/credit-account-payment/callback'
    | '/deposit-onboarding/choose-product'
    | '/deposit-onboarding/choose-term'
    | '/deposit-onboarding/denied'
    | '/deposit-onboarding/error'
    | '/deposit-onboarding/max-account'
    | '/direct-transfer/callback'
    | '/home/purchases'
    | '/kyc/$id'
    | '/kyc/success'
    | '/monthly-deposit/callback'
    | '/transfer/$accountId'
    | '/withdrawal/callback'
    | '/agreements'
    | '/bill-payment'
    | '/credit-account-payment'
    | '/home'
    | '/kyc'
    | '/withdrawal'
    | '/agreements/$agreementId/success'
    | '/bill-payment/$billId/conversion-options'
    | '/bill-payment/$billId/options'
    | '/connected-account/add/callback'
    | '/connected-account/remove/callback'
    | '/credit-account-payment/create/$id'
    | '/deposit-onboarding/$applicationId/callback'
    | '/deposit-onboarding/$applicationId/exists'
    | '/deposit-onboarding/$applicationId/pending'
    | '/deposit-onboarding/$applicationId/resume'
    | '/deposit-onboarding/$applicationId/summary'
    | '/home/service/account'
    | '/home/service/documents'
    | '/home/service/kyc'
    | '/home/service/language'
    | '/home/service/messages'
    | '/home/service/notifications'
    | '/home/service/profile'
    | '/home/service/saved-account'
    | '/home/service/theme'
    | '/savings-close/$id/$accountNumber'
    | '/statement-payment/$statementId'
    | '/transfer/callback/failed'
    | '/withdrawal/accounts/callback'
    | '/withdrawal/openbanking/callback'
    | '/agreements/$agreementId'
    | '/bill-payment/$billId'
    | '/connected-account/add'
    | '/credit-account-payment/create'
    | '/deposit-onboarding/$applicationId'
    | '/home/accounts'
    | '/home/discover'
    | '/home/service'
    | '/home/statements'
    | '/bill-payment/$billId/callback'
    | '/bill-payment/$billId/callback/open-banking'
    | '/bill-payment/$billId/connect-bank/callback'
    | '/bill-payment/$billId/connect-bank/cancel'
    | '/bill-payment/$billId/connect-bank/error'
    | '/bill-payment/$billId/connect-bank/success'
    | '/deposit-onboarding/$applicationId/$productCode/$accountId'
    | '/deposit-onboarding/$applicationId/$productCode/add-funds'
    | '/deposit-onboarding/$applicationId/$productCode/deposit-account'
    | '/home/accounts/cards/$cardId'
    | '/home/bills/$id/open-banking'
    | '/home/service/connect-bank/callback'
    | '/home/service/connect-bank/cancel'
    | '/home/service/connect-bank/error'
    | '/home/service/connect-bank/success'
    | '/home/statements/$id/connected-account-payment'
    | '/home/statements/$id/open-banking'
    | '/statement-payment/$statementId/options'
    | '/statement-payment/$statementId/select'
    | '/statement-payment/$statementId/callback'
    | '/statement-payment/$statementId/callback/connected-account'
    | '/statement-payment/$statementId/callback/open-banking'
    | '/statement-payment/$statementId/cancel/callback'
    | '/statement-payment/$statementId/connect-bank/callback'
    | '/statement-payment/$statementId/connect-bank/cancel'
    | '/statement-payment/$statementId/connect-bank/error'
    | '/statement-payment/$statementId/connect-bank/success'
    | '/home/statements/$id'
    | '/accounts/credits/$accountId/close/confirm'
    | '/accounts/credits/$accountId/close/success'
    | '/accounts/deposits/$accountId/close/confirm'
    | '/accounts/deposits/$accountId/close/success'
    | '/accounts/invoices/$accountId/close/confirm'
    | '/accounts/invoices/$accountId/close/success'
    | '/accounts/loans/$accountId/close/confirm'
    | '/accounts/loans/$accountId/close/success'
    | '/bill-payment/$billId/callback/cancel'
    | '/bill-payment/$billId/callback/error'
    | '/bill-payment/$billId/callback/pending'
    | '/bill-payment/$billId/callback/success'
    | '/bill-payment/$billId/callback/timeout'
    | '/bill-payment/$billId/callback/unknown'
    | '/home/accounts/cards/$cardId/3ds-password'
    | '/home/accounts/credits/$accountId/bonus-checks'
    | '/home/accounts/credits/$accountId/invoices'
    | '/home/accounts/credits/$accountId/transactions'
    | '/home/accounts/deposits/$accountId/statements'
    | '/home/accounts/deposits/$accountId/transactions'
    | '/home/accounts/loans/$accountId/invoices'
    | '/home/accounts/loans/$accountId/transactions'
    | '/home/accounts/one-time-credit/$accountId/invoice-history'
    | '/home/accounts/one-time-credit/$accountId/transactions'
    | '/statement-payment/$statementId/callback/cancel'
    | '/statement-payment/$statementId/callback/error'
    | '/statement-payment/$statementId/callback/pending'
    | '/statement-payment/$statementId/callback/success'
    | '/statement-payment/$statementId/callback/timeout'
    | '/statement-payment/$statementId/callback/unknown'
    | '/accounts/credits/$accountId/close'
    | '/accounts/deposits/$accountId/close'
    | '/accounts/invoices/$accountId/close'
    | '/accounts/loans/$accountId/close'
    | '/home/accounts/credits/$accountId'
    | '/home/accounts/deposits/$accountId'
    | '/home/accounts/loans/$accountId'
    | '/home/accounts/one-time-credit/$accountId'
    | '/accounts/credits/$accountId/ppi/close/confirm'
    | '/accounts/credits/$accountId/ppi/close/success'
    | '/accounts/loans/$accountId/ppi/close/confirm'
    | '/accounts/loans/$accountId/ppi/close/success'
    | '/home/accounts/credits/$accountId/bonus-shop/cart'
    | '/home/accounts/credits/$accountId/cards/$cardId'
    | '/transfer/callback/success/$fromAccountId/$toAccountId/$amount'
    | '/accounts/credits/$accountId/ppi/close'
    | '/accounts/loans/$accountId/ppi/close'
    | '/home/accounts/credits/$accountId/bonus-shop'
    | '/home/accounts/credits/$accountId/bonus-shop/order/$orderId'
  id:
    | '__root__'
    | '/'
    | '/$notFound'
    | '/_protected'
    | '/app'
    | '/auth'
    | '/auth-done'
    | '/close'
    | '/config'
    | '/demo'
    | '/error'
    | '/logout'
    | '/maintenance'
    | '/terms-and-conditions'
    | '/_protected/deposit-onboarding'
    | '/_protected/home'
    | '/_protected/bankid'
    | '/deeplink/$'
    | '/login/consents'
    | '/login/error'
    | '/zendesk/logout'
    | '/login/'
    | '/_protected/home/accounts'
    | '/_protected/home/discover'
    | '/_protected/home/service'
    | '/_protected/home/statements'
    | '/_protected/credit-account-payment/callback'
    | '/_protected/deposit-onboarding/$applicationId'
    | '/_protected/deposit-onboarding/choose-product'
    | '/_protected/deposit-onboarding/choose-term'
    | '/_protected/deposit-onboarding/denied'
    | '/_protected/deposit-onboarding/error'
    | '/_protected/deposit-onboarding/max-account'
    | '/_protected/direct-transfer/callback'
    | '/_protected/home/purchases'
    | '/_protected/kyc/$id'
    | '/_protected/kyc/success'
    | '/_protected/monthly-deposit/callback'
    | '/_protected/transfer/$accountId'
    | '/_protected/withdrawal/callback'
    | '/_protected/agreements/'
    | '/_protected/bill-payment/'
    | '/_protected/credit-account-payment/'
    | '/_protected/home/'
    | '/_protected/kyc/'
    | '/_protected/withdrawal/'
    | '/_protected/home/statements/$id'
    | '/_protected/agreements/$agreementId/success'
    | '/_protected/bill-payment/$billId/conversion-options'
    | '/_protected/bill-payment/$billId/options'
    | '/_protected/connected-account/add/callback'
    | '/_protected/connected-account/remove/callback'
    | '/_protected/credit-account-payment/create/$id'
    | '/_protected/deposit-onboarding/$applicationId/callback'
    | '/_protected/deposit-onboarding/$applicationId/exists'
    | '/_protected/deposit-onboarding/$applicationId/pending'
    | '/_protected/deposit-onboarding/$applicationId/resume'
    | '/_protected/deposit-onboarding/$applicationId/summary'
    | '/_protected/home/service/account'
    | '/_protected/home/service/documents'
    | '/_protected/home/service/kyc'
    | '/_protected/home/service/language'
    | '/_protected/home/service/messages'
    | '/_protected/home/service/notifications'
    | '/_protected/home/service/profile'
    | '/_protected/home/service/saved-account'
    | '/_protected/home/service/theme'
    | '/_protected/savings-close/$id/$accountNumber'
    | '/_protected/statement-payment/$statementId'
    | '/_protected/statement-payment/$statementId/_payment'
    | '/_protected/transfer/callback/failed'
    | '/_protected/withdrawal/accounts/callback'
    | '/_protected/withdrawal/openbanking/callback'
    | '/_protected/agreements/$agreementId/'
    | '/_protected/bill-payment/$billId/'
    | '/_protected/connected-account/add/'
    | '/_protected/credit-account-payment/create/'
    | '/_protected/deposit-onboarding/$applicationId/'
    | '/_protected/home/accounts/'
    | '/_protected/home/discover/'
    | '/_protected/home/service/'
    | '/_protected/home/statements/'
    | '/_protected/home/accounts/credits/$accountId'
    | '/_protected/home/accounts/deposits/$accountId'
    | '/_protected/home/accounts/loans/$accountId'
    | '/_protected/home/accounts/one-time-credit/$accountId'
    | '/_protected/bill-payment/$billId/callback'
    | '/_protected/bill-payment/$billId/callback/_statuses'
    | '/_protected/bill-payment/$billId/callback/open-banking'
    | '/_protected/bill-payment/$billId/connect-bank/callback'
    | '/_protected/bill-payment/$billId/connect-bank/cancel'
    | '/_protected/bill-payment/$billId/connect-bank/error'
    | '/_protected/bill-payment/$billId/connect-bank/success'
    | '/_protected/deposit-onboarding/$applicationId/$productCode/$accountId'
    | '/_protected/deposit-onboarding/$applicationId/$productCode/add-funds'
    | '/_protected/deposit-onboarding/$applicationId/$productCode/deposit-account'
    | '/_protected/home/accounts/cards/$cardId'
    | '/_protected/home/bills/$id/open-banking'
    | '/_protected/home/service/connect-bank/callback'
    | '/_protected/home/service/connect-bank/cancel'
    | '/_protected/home/service/connect-bank/error'
    | '/_protected/home/service/connect-bank/success'
    | '/_protected/home/statements/$id/connected-account-payment'
    | '/_protected/home/statements/$id/open-banking'
    | '/_protected/statement-payment/$statementId/_payment/options'
    | '/_protected/statement-payment/$statementId/_payment/select'
    | '/_protected/statement-payment/$statementId/callback'
    | '/_protected/statement-payment/$statementId/callback/_statuses'
    | '/_protected/statement-payment/$statementId/callback/connected-account'
    | '/_protected/statement-payment/$statementId/callback/open-banking'
    | '/_protected/statement-payment/$statementId/cancel/callback'
    | '/_protected/statement-payment/$statementId/connect-bank/callback'
    | '/_protected/statement-payment/$statementId/connect-bank/cancel'
    | '/_protected/statement-payment/$statementId/connect-bank/error'
    | '/_protected/statement-payment/$statementId/connect-bank/success'
    | '/_protected/home/statements/$id/'
    | '/_protected/statement-payment/$statementId/_payment/'
    | '/_protected/home/accounts/credits/$accountId/bonus-shop'
    | '/_protected/accounts/credits/$accountId/close/confirm'
    | '/_protected/accounts/credits/$accountId/close/success'
    | '/_protected/accounts/deposits/$accountId/close/confirm'
    | '/_protected/accounts/deposits/$accountId/close/success'
    | '/_protected/accounts/invoices/$accountId/close/confirm'
    | '/_protected/accounts/invoices/$accountId/close/success'
    | '/_protected/accounts/loans/$accountId/close/confirm'
    | '/_protected/accounts/loans/$accountId/close/success'
    | '/_protected/bill-payment/$billId/callback/_statuses/cancel'
    | '/_protected/bill-payment/$billId/callback/_statuses/error'
    | '/_protected/bill-payment/$billId/callback/_statuses/pending'
    | '/_protected/bill-payment/$billId/callback/_statuses/success'
    | '/_protected/bill-payment/$billId/callback/_statuses/timeout'
    | '/_protected/bill-payment/$billId/callback/_statuses/unknown'
    | '/_protected/home/accounts/cards/$cardId_/3ds-password'
    | '/_protected/home/accounts/credits/$accountId/bonus-checks'
    | '/_protected/home/accounts/credits/$accountId/invoices'
    | '/_protected/home/accounts/credits/$accountId/transactions'
    | '/_protected/home/accounts/deposits/$accountId/statements'
    | '/_protected/home/accounts/deposits/$accountId/transactions'
    | '/_protected/home/accounts/loans/$accountId/invoices'
    | '/_protected/home/accounts/loans/$accountId/transactions'
    | '/_protected/home/accounts/one-time-credit/$accountId/invoice-history'
    | '/_protected/home/accounts/one-time-credit/$accountId/transactions'
    | '/_protected/statement-payment/$statementId/callback/_statuses/cancel'
    | '/_protected/statement-payment/$statementId/callback/_statuses/error'
    | '/_protected/statement-payment/$statementId/callback/_statuses/pending'
    | '/_protected/statement-payment/$statementId/callback/_statuses/success'
    | '/_protected/statement-payment/$statementId/callback/_statuses/timeout'
    | '/_protected/statement-payment/$statementId/callback/_statuses/unknown'
    | '/_protected/accounts/credits/$accountId/close/'
    | '/_protected/accounts/deposits/$accountId/close/'
    | '/_protected/accounts/invoices/$accountId/close/'
    | '/_protected/accounts/loans/$accountId/close/'
    | '/_protected/home/accounts/credits/$accountId/'
    | '/_protected/home/accounts/deposits/$accountId/'
    | '/_protected/home/accounts/loans/$accountId/'
    | '/_protected/home/accounts/one-time-credit/$accountId/'
    | '/_protected/accounts/credits/$accountId/ppi/close/confirm'
    | '/_protected/accounts/credits/$accountId/ppi/close/success'
    | '/_protected/accounts/loans/$accountId/ppi/close/confirm'
    | '/_protected/accounts/loans/$accountId/ppi/close/success'
    | '/_protected/home/accounts/credits/$accountId/bonus-shop/cart'
    | '/_protected/home/accounts/credits/$accountId/cards/$cardId'
    | '/_protected/transfer/callback/success/$fromAccountId/$toAccountId/$amount'
    | '/_protected/accounts/credits/$accountId/ppi/close/'
    | '/_protected/accounts/loans/$accountId/ppi/close/'
    | '/_protected/home/accounts/credits/$accountId/bonus-shop/'
    | '/_protected/home/accounts/credits/$accountId/bonus-shop/order/$orderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  NotFoundRoute: typeof NotFoundRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  AppRoute: typeof AppRoute
  AuthRoute: typeof AuthRoute
  AuthDoneRoute: typeof AuthDoneRoute
  CloseRoute: typeof CloseRoute
  ConfigRoute: typeof ConfigRoute
  DemoRoute: typeof DemoRoute
  ErrorRoute: typeof ErrorRoute
  LogoutRoute: typeof LogoutRoute
  MaintenanceRoute: typeof MaintenanceRoute
  TermsAndConditionsRoute: typeof TermsAndConditionsRoute
  DeeplinkSplatRoute: typeof DeeplinkSplatRoute
  LoginConsentsRoute: typeof LoginConsentsRoute
  LoginErrorRoute: typeof LoginErrorRoute
  ZendeskLogoutRoute: typeof ZendeskLogoutRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config': {
      id: '/config'
      path: '/config'
      fullPath: '/config'
      preLoaderRoute: typeof ConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/close': {
      id: '/close'
      path: '/close'
      fullPath: '/close'
      preLoaderRoute: typeof CloseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-done': {
      id: '/auth-done'
      path: '/auth-done'
      fullPath: '/auth-done'
      preLoaderRoute: typeof AuthDoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$notFound': {
      id: '/$notFound'
      path: '/$notFound'
      fullPath: '/$notFound'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/zendesk/logout': {
      id: '/zendesk/logout'
      path: '/zendesk/logout'
      fullPath: '/zendesk/logout'
      preLoaderRoute: typeof ZendeskLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/error': {
      id: '/login/error'
      path: '/login/error'
      fullPath: '/login/error'
      preLoaderRoute: typeof LoginErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/consents': {
      id: '/login/consents'
      path: '/login/consents'
      fullPath: '/login/consents'
      preLoaderRoute: typeof LoginConsentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deeplink/$': {
      id: '/deeplink/$'
      path: '/deeplink/$'
      fullPath: '/deeplink/$'
      preLoaderRoute: typeof DeeplinkSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/bankid': {
      id: '/_protected/bankid'
      path: '/bankid'
      fullPath: '/bankid'
      preLoaderRoute: typeof ProtectedBankidRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home': {
      id: '/_protected/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof ProtectedHomeRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/deposit-onboarding': {
      id: '/_protected/deposit-onboarding'
      path: '/deposit-onboarding'
      fullPath: '/deposit-onboarding'
      preLoaderRoute: typeof ProtectedDepositOnboardingRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/statement-payment/$statementId': {
      id: '/_protected/statement-payment/$statementId'
      path: '/statement-payment/$statementId'
      fullPath: '/statement-payment/$statementId'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/withdrawal/': {
      id: '/_protected/withdrawal/'
      path: '/withdrawal'
      fullPath: '/withdrawal'
      preLoaderRoute: typeof ProtectedWithdrawalIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/kyc/': {
      id: '/_protected/kyc/'
      path: '/kyc'
      fullPath: '/kyc'
      preLoaderRoute: typeof ProtectedKycIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/': {
      id: '/_protected/home/'
      path: '/'
      fullPath: '/home/'
      preLoaderRoute: typeof ProtectedHomeIndexRouteImport
      parentRoute: typeof ProtectedHomeRouteRoute
    }
    '/_protected/credit-account-payment/': {
      id: '/_protected/credit-account-payment/'
      path: '/credit-account-payment'
      fullPath: '/credit-account-payment'
      preLoaderRoute: typeof ProtectedCreditAccountPaymentIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bill-payment/': {
      id: '/_protected/bill-payment/'
      path: '/bill-payment'
      fullPath: '/bill-payment'
      preLoaderRoute: typeof ProtectedBillPaymentIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/agreements/': {
      id: '/_protected/agreements/'
      path: '/agreements'
      fullPath: '/agreements'
      preLoaderRoute: typeof ProtectedAgreementsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/withdrawal/callback': {
      id: '/_protected/withdrawal/callback'
      path: '/withdrawal/callback'
      fullPath: '/withdrawal/callback'
      preLoaderRoute: typeof ProtectedWithdrawalCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/transfer/$accountId': {
      id: '/_protected/transfer/$accountId'
      path: '/transfer/$accountId'
      fullPath: '/transfer/$accountId'
      preLoaderRoute: typeof ProtectedTransferAccountIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/monthly-deposit/callback': {
      id: '/_protected/monthly-deposit/callback'
      path: '/monthly-deposit/callback'
      fullPath: '/monthly-deposit/callback'
      preLoaderRoute: typeof ProtectedMonthlyDepositCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/kyc/success': {
      id: '/_protected/kyc/success'
      path: '/kyc/success'
      fullPath: '/kyc/success'
      preLoaderRoute: typeof ProtectedKycSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/kyc/$id': {
      id: '/_protected/kyc/$id'
      path: '/kyc/$id'
      fullPath: '/kyc/$id'
      preLoaderRoute: typeof ProtectedKycIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/purchases': {
      id: '/_protected/home/purchases'
      path: '/purchases'
      fullPath: '/home/purchases'
      preLoaderRoute: typeof ProtectedHomePurchasesRouteImport
      parentRoute: typeof ProtectedHomeRouteRoute
    }
    '/_protected/direct-transfer/callback': {
      id: '/_protected/direct-transfer/callback'
      path: '/direct-transfer/callback'
      fullPath: '/direct-transfer/callback'
      preLoaderRoute: typeof ProtectedDirectTransferCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/deposit-onboarding/max-account': {
      id: '/_protected/deposit-onboarding/max-account'
      path: '/max-account'
      fullPath: '/deposit-onboarding/max-account'
      preLoaderRoute: typeof ProtectedDepositOnboardingMaxAccountRouteImport
      parentRoute: typeof ProtectedDepositOnboardingRouteRoute
    }
    '/_protected/deposit-onboarding/error': {
      id: '/_protected/deposit-onboarding/error'
      path: '/error'
      fullPath: '/deposit-onboarding/error'
      preLoaderRoute: typeof ProtectedDepositOnboardingErrorRouteImport
      parentRoute: typeof ProtectedDepositOnboardingRouteRoute
    }
    '/_protected/deposit-onboarding/denied': {
      id: '/_protected/deposit-onboarding/denied'
      path: '/denied'
      fullPath: '/deposit-onboarding/denied'
      preLoaderRoute: typeof ProtectedDepositOnboardingDeniedRouteImport
      parentRoute: typeof ProtectedDepositOnboardingRouteRoute
    }
    '/_protected/deposit-onboarding/choose-term': {
      id: '/_protected/deposit-onboarding/choose-term'
      path: '/choose-term'
      fullPath: '/deposit-onboarding/choose-term'
      preLoaderRoute: typeof ProtectedDepositOnboardingChooseTermRouteImport
      parentRoute: typeof ProtectedDepositOnboardingRouteRoute
    }
    '/_protected/deposit-onboarding/choose-product': {
      id: '/_protected/deposit-onboarding/choose-product'
      path: '/choose-product'
      fullPath: '/deposit-onboarding/choose-product'
      preLoaderRoute: typeof ProtectedDepositOnboardingChooseProductRouteImport
      parentRoute: typeof ProtectedDepositOnboardingRouteRoute
    }
    '/_protected/deposit-onboarding/$applicationId': {
      id: '/_protected/deposit-onboarding/$applicationId'
      path: '/$applicationId'
      fullPath: '/deposit-onboarding/$applicationId'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdRouteImport
      parentRoute: typeof ProtectedDepositOnboardingRouteRoute
    }
    '/_protected/credit-account-payment/callback': {
      id: '/_protected/credit-account-payment/callback'
      path: '/credit-account-payment/callback'
      fullPath: '/credit-account-payment/callback'
      preLoaderRoute: typeof ProtectedCreditAccountPaymentCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/statements': {
      id: '/_protected/home/statements'
      path: '/statements'
      fullPath: '/home/statements'
      preLoaderRoute: typeof ProtectedHomeStatementsRouteRouteImport
      parentRoute: typeof ProtectedHomeRouteRoute
    }
    '/_protected/home/service': {
      id: '/_protected/home/service'
      path: '/service'
      fullPath: '/home/service'
      preLoaderRoute: typeof ProtectedHomeServiceRouteRouteImport
      parentRoute: typeof ProtectedHomeRouteRoute
    }
    '/_protected/home/discover': {
      id: '/_protected/home/discover'
      path: '/discover'
      fullPath: '/home/discover'
      preLoaderRoute: typeof ProtectedHomeDiscoverRouteRouteImport
      parentRoute: typeof ProtectedHomeRouteRoute
    }
    '/_protected/home/accounts': {
      id: '/_protected/home/accounts'
      path: '/accounts'
      fullPath: '/home/accounts'
      preLoaderRoute: typeof ProtectedHomeAccountsRouteRouteImport
      parentRoute: typeof ProtectedHomeRouteRoute
    }
    '/_protected/statement-payment/$statementId/callback': {
      id: '/_protected/statement-payment/$statementId/callback'
      path: '/callback'
      fullPath: '/statement-payment/$statementId/callback'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdRoute
    }
    '/_protected/bill-payment/$billId/callback': {
      id: '/_protected/bill-payment/$billId/callback'
      path: '/bill-payment/$billId/callback'
      fullPath: '/bill-payment/$billId/callback'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/statements/': {
      id: '/_protected/home/statements/'
      path: '/'
      fullPath: '/home/statements/'
      preLoaderRoute: typeof ProtectedHomeStatementsIndexRouteImport
      parentRoute: typeof ProtectedHomeStatementsRouteRoute
    }
    '/_protected/home/service/': {
      id: '/_protected/home/service/'
      path: '/'
      fullPath: '/home/service/'
      preLoaderRoute: typeof ProtectedHomeServiceIndexRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/discover/': {
      id: '/_protected/home/discover/'
      path: '/'
      fullPath: '/home/discover/'
      preLoaderRoute: typeof ProtectedHomeDiscoverIndexRouteImport
      parentRoute: typeof ProtectedHomeDiscoverRouteRoute
    }
    '/_protected/home/accounts/': {
      id: '/_protected/home/accounts/'
      path: '/'
      fullPath: '/home/accounts/'
      preLoaderRoute: typeof ProtectedHomeAccountsIndexRouteImport
      parentRoute: typeof ProtectedHomeAccountsRouteRoute
    }
    '/_protected/deposit-onboarding/$applicationId/': {
      id: '/_protected/deposit-onboarding/$applicationId/'
      path: '/'
      fullPath: '/deposit-onboarding/$applicationId/'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdIndexRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/credit-account-payment/create/': {
      id: '/_protected/credit-account-payment/create/'
      path: '/credit-account-payment/create'
      fullPath: '/credit-account-payment/create'
      preLoaderRoute: typeof ProtectedCreditAccountPaymentCreateIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/connected-account/add/': {
      id: '/_protected/connected-account/add/'
      path: '/connected-account/add'
      fullPath: '/connected-account/add'
      preLoaderRoute: typeof ProtectedConnectedAccountAddIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bill-payment/$billId/': {
      id: '/_protected/bill-payment/$billId/'
      path: '/bill-payment/$billId'
      fullPath: '/bill-payment/$billId'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/agreements/$agreementId/': {
      id: '/_protected/agreements/$agreementId/'
      path: '/agreements/$agreementId'
      fullPath: '/agreements/$agreementId'
      preLoaderRoute: typeof ProtectedAgreementsAgreementIdIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/withdrawal/openbanking/callback': {
      id: '/_protected/withdrawal/openbanking/callback'
      path: '/withdrawal/openbanking/callback'
      fullPath: '/withdrawal/openbanking/callback'
      preLoaderRoute: typeof ProtectedWithdrawalOpenbankingCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/withdrawal/accounts/callback': {
      id: '/_protected/withdrawal/accounts/callback'
      path: '/withdrawal/accounts/callback'
      fullPath: '/withdrawal/accounts/callback'
      preLoaderRoute: typeof ProtectedWithdrawalAccountsCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/transfer/callback/failed': {
      id: '/_protected/transfer/callback/failed'
      path: '/transfer/callback/failed'
      fullPath: '/transfer/callback/failed'
      preLoaderRoute: typeof ProtectedTransferCallbackFailedRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/statement-payment/$statementId/_payment': {
      id: '/_protected/statement-payment/$statementId/_payment'
      path: '/statement-payment/$statementId'
      fullPath: '/statement-payment/$statementId'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdPaymentRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdRoute
    }
    '/_protected/savings-close/$id/$accountNumber': {
      id: '/_protected/savings-close/$id/$accountNumber'
      path: '/savings-close/$id/$accountNumber'
      fullPath: '/savings-close/$id/$accountNumber'
      preLoaderRoute: typeof ProtectedSavingsCloseIdAccountNumberRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/service/theme': {
      id: '/_protected/home/service/theme'
      path: '/theme'
      fullPath: '/home/service/theme'
      preLoaderRoute: typeof ProtectedHomeServiceThemeRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/saved-account': {
      id: '/_protected/home/service/saved-account'
      path: '/saved-account'
      fullPath: '/home/service/saved-account'
      preLoaderRoute: typeof ProtectedHomeServiceSavedAccountRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/profile': {
      id: '/_protected/home/service/profile'
      path: '/profile'
      fullPath: '/home/service/profile'
      preLoaderRoute: typeof ProtectedHomeServiceProfileRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/notifications': {
      id: '/_protected/home/service/notifications'
      path: '/notifications'
      fullPath: '/home/service/notifications'
      preLoaderRoute: typeof ProtectedHomeServiceNotificationsRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/messages': {
      id: '/_protected/home/service/messages'
      path: '/messages'
      fullPath: '/home/service/messages'
      preLoaderRoute: typeof ProtectedHomeServiceMessagesRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/language': {
      id: '/_protected/home/service/language'
      path: '/language'
      fullPath: '/home/service/language'
      preLoaderRoute: typeof ProtectedHomeServiceLanguageRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/kyc': {
      id: '/_protected/home/service/kyc'
      path: '/kyc'
      fullPath: '/home/service/kyc'
      preLoaderRoute: typeof ProtectedHomeServiceKycRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/documents': {
      id: '/_protected/home/service/documents'
      path: '/documents'
      fullPath: '/home/service/documents'
      preLoaderRoute: typeof ProtectedHomeServiceDocumentsRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/account': {
      id: '/_protected/home/service/account'
      path: '/account'
      fullPath: '/home/service/account'
      preLoaderRoute: typeof ProtectedHomeServiceAccountRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/deposit-onboarding/$applicationId/summary': {
      id: '/_protected/deposit-onboarding/$applicationId/summary'
      path: '/summary'
      fullPath: '/deposit-onboarding/$applicationId/summary'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdSummaryRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/deposit-onboarding/$applicationId/resume': {
      id: '/_protected/deposit-onboarding/$applicationId/resume'
      path: '/resume'
      fullPath: '/deposit-onboarding/$applicationId/resume'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdResumeRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/deposit-onboarding/$applicationId/pending': {
      id: '/_protected/deposit-onboarding/$applicationId/pending'
      path: '/pending'
      fullPath: '/deposit-onboarding/$applicationId/pending'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdPendingRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/deposit-onboarding/$applicationId/exists': {
      id: '/_protected/deposit-onboarding/$applicationId/exists'
      path: '/exists'
      fullPath: '/deposit-onboarding/$applicationId/exists'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdExistsRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/deposit-onboarding/$applicationId/callback': {
      id: '/_protected/deposit-onboarding/$applicationId/callback'
      path: '/callback'
      fullPath: '/deposit-onboarding/$applicationId/callback'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdCallbackRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/credit-account-payment/create/$id': {
      id: '/_protected/credit-account-payment/create/$id'
      path: '/credit-account-payment/create/$id'
      fullPath: '/credit-account-payment/create/$id'
      preLoaderRoute: typeof ProtectedCreditAccountPaymentCreateIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/connected-account/remove/callback': {
      id: '/_protected/connected-account/remove/callback'
      path: '/connected-account/remove/callback'
      fullPath: '/connected-account/remove/callback'
      preLoaderRoute: typeof ProtectedConnectedAccountRemoveCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/connected-account/add/callback': {
      id: '/_protected/connected-account/add/callback'
      path: '/connected-account/add/callback'
      fullPath: '/connected-account/add/callback'
      preLoaderRoute: typeof ProtectedConnectedAccountAddCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bill-payment/$billId/options': {
      id: '/_protected/bill-payment/$billId/options'
      path: '/bill-payment/$billId/options'
      fullPath: '/bill-payment/$billId/options'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdOptionsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bill-payment/$billId/conversion-options': {
      id: '/_protected/bill-payment/$billId/conversion-options'
      path: '/bill-payment/$billId/conversion-options'
      fullPath: '/bill-payment/$billId/conversion-options'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdConversionOptionsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/agreements/$agreementId/success': {
      id: '/_protected/agreements/$agreementId/success'
      path: '/agreements/$agreementId/success'
      fullPath: '/agreements/$agreementId/success'
      preLoaderRoute: typeof ProtectedAgreementsAgreementIdSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/statements/$id': {
      id: '/_protected/home/statements/$id'
      path: '/$id'
      fullPath: '/home/statements/$id'
      preLoaderRoute: typeof ProtectedHomeStatementsIdRouteRouteImport
      parentRoute: typeof ProtectedHomeStatementsRouteRoute
    }
    '/_protected/statement-payment/$statementId/_payment/': {
      id: '/_protected/statement-payment/$statementId/_payment/'
      path: '/'
      fullPath: '/statement-payment/$statementId/'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdPaymentIndexRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdPaymentRoute
    }
    '/_protected/home/statements/$id/': {
      id: '/_protected/home/statements/$id/'
      path: '/'
      fullPath: '/home/statements/$id/'
      preLoaderRoute: typeof ProtectedHomeStatementsIdIndexRouteImport
      parentRoute: typeof ProtectedHomeStatementsIdRouteRoute
    }
    '/_protected/statement-payment/$statementId/connect-bank/success': {
      id: '/_protected/statement-payment/$statementId/connect-bank/success'
      path: '/connect-bank/success'
      fullPath: '/statement-payment/$statementId/connect-bank/success'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdConnectBankSuccessRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdRoute
    }
    '/_protected/statement-payment/$statementId/connect-bank/error': {
      id: '/_protected/statement-payment/$statementId/connect-bank/error'
      path: '/connect-bank/error'
      fullPath: '/statement-payment/$statementId/connect-bank/error'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdConnectBankErrorRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdRoute
    }
    '/_protected/statement-payment/$statementId/connect-bank/cancel': {
      id: '/_protected/statement-payment/$statementId/connect-bank/cancel'
      path: '/connect-bank/cancel'
      fullPath: '/statement-payment/$statementId/connect-bank/cancel'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdConnectBankCancelRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdRoute
    }
    '/_protected/statement-payment/$statementId/connect-bank/callback': {
      id: '/_protected/statement-payment/$statementId/connect-bank/callback'
      path: '/connect-bank/callback'
      fullPath: '/statement-payment/$statementId/connect-bank/callback'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdConnectBankCallbackRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdRoute
    }
    '/_protected/statement-payment/$statementId/cancel/callback': {
      id: '/_protected/statement-payment/$statementId/cancel/callback'
      path: '/cancel/callback'
      fullPath: '/statement-payment/$statementId/cancel/callback'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCancelCallbackRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdRoute
    }
    '/_protected/statement-payment/$statementId/callback/open-banking': {
      id: '/_protected/statement-payment/$statementId/callback/open-banking'
      path: '/open-banking'
      fullPath: '/statement-payment/$statementId/callback/open-banking'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackOpenBankingRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackRoute
    }
    '/_protected/statement-payment/$statementId/callback/connected-account': {
      id: '/_protected/statement-payment/$statementId/callback/connected-account'
      path: '/connected-account'
      fullPath: '/statement-payment/$statementId/callback/connected-account'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackConnectedAccountRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackRoute
    }
    '/_protected/statement-payment/$statementId/callback/_statuses': {
      id: '/_protected/statement-payment/$statementId/callback/_statuses'
      path: '/callback'
      fullPath: '/statement-payment/$statementId/callback'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackRoute
    }
    '/_protected/statement-payment/$statementId/_payment/select': {
      id: '/_protected/statement-payment/$statementId/_payment/select'
      path: '/select'
      fullPath: '/statement-payment/$statementId/select'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdPaymentSelectRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdPaymentRoute
    }
    '/_protected/statement-payment/$statementId/_payment/options': {
      id: '/_protected/statement-payment/$statementId/_payment/options'
      path: '/options'
      fullPath: '/statement-payment/$statementId/options'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdPaymentOptionsRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdPaymentRoute
    }
    '/_protected/home/statements/$id/open-banking': {
      id: '/_protected/home/statements/$id/open-banking'
      path: '/open-banking'
      fullPath: '/home/statements/$id/open-banking'
      preLoaderRoute: typeof ProtectedHomeStatementsIdOpenBankingRouteImport
      parentRoute: typeof ProtectedHomeStatementsIdRouteRoute
    }
    '/_protected/home/statements/$id/connected-account-payment': {
      id: '/_protected/home/statements/$id/connected-account-payment'
      path: '/connected-account-payment'
      fullPath: '/home/statements/$id/connected-account-payment'
      preLoaderRoute: typeof ProtectedHomeStatementsIdConnectedAccountPaymentRouteImport
      parentRoute: typeof ProtectedHomeStatementsIdRouteRoute
    }
    '/_protected/home/service/connect-bank/success': {
      id: '/_protected/home/service/connect-bank/success'
      path: '/connect-bank/success'
      fullPath: '/home/service/connect-bank/success'
      preLoaderRoute: typeof ProtectedHomeServiceConnectBankSuccessRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/connect-bank/error': {
      id: '/_protected/home/service/connect-bank/error'
      path: '/connect-bank/error'
      fullPath: '/home/service/connect-bank/error'
      preLoaderRoute: typeof ProtectedHomeServiceConnectBankErrorRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/connect-bank/cancel': {
      id: '/_protected/home/service/connect-bank/cancel'
      path: '/connect-bank/cancel'
      fullPath: '/home/service/connect-bank/cancel'
      preLoaderRoute: typeof ProtectedHomeServiceConnectBankCancelRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/service/connect-bank/callback': {
      id: '/_protected/home/service/connect-bank/callback'
      path: '/connect-bank/callback'
      fullPath: '/home/service/connect-bank/callback'
      preLoaderRoute: typeof ProtectedHomeServiceConnectBankCallbackRouteImport
      parentRoute: typeof ProtectedHomeServiceRouteRoute
    }
    '/_protected/home/bills/$id/open-banking': {
      id: '/_protected/home/bills/$id/open-banking'
      path: '/bills/$id/open-banking'
      fullPath: '/home/bills/$id/open-banking'
      preLoaderRoute: typeof ProtectedHomeBillsIdOpenBankingRouteImport
      parentRoute: typeof ProtectedHomeRouteRoute
    }
    '/_protected/home/accounts/cards/$cardId': {
      id: '/_protected/home/accounts/cards/$cardId'
      path: '/cards/$cardId'
      fullPath: '/home/accounts/cards/$cardId'
      preLoaderRoute: typeof ProtectedHomeAccountsCardsCardIdRouteImport
      parentRoute: typeof ProtectedHomeAccountsRouteRoute
    }
    '/_protected/deposit-onboarding/$applicationId/$productCode/deposit-account': {
      id: '/_protected/deposit-onboarding/$applicationId/$productCode/deposit-account'
      path: '/$productCode/deposit-account'
      fullPath: '/deposit-onboarding/$applicationId/$productCode/deposit-account'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/deposit-onboarding/$applicationId/$productCode/add-funds': {
      id: '/_protected/deposit-onboarding/$applicationId/$productCode/add-funds'
      path: '/$productCode/add-funds'
      fullPath: '/deposit-onboarding/$applicationId/$productCode/add-funds'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/deposit-onboarding/$applicationId/$productCode/$accountId': {
      id: '/_protected/deposit-onboarding/$applicationId/$productCode/$accountId'
      path: '/$productCode/$accountId'
      fullPath: '/deposit-onboarding/$applicationId/$productCode/$accountId'
      preLoaderRoute: typeof ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRouteImport
      parentRoute: typeof ProtectedDepositOnboardingApplicationIdRoute
    }
    '/_protected/bill-payment/$billId/connect-bank/success': {
      id: '/_protected/bill-payment/$billId/connect-bank/success'
      path: '/bill-payment/$billId/connect-bank/success'
      fullPath: '/bill-payment/$billId/connect-bank/success'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdConnectBankSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bill-payment/$billId/connect-bank/error': {
      id: '/_protected/bill-payment/$billId/connect-bank/error'
      path: '/bill-payment/$billId/connect-bank/error'
      fullPath: '/bill-payment/$billId/connect-bank/error'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdConnectBankErrorRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bill-payment/$billId/connect-bank/cancel': {
      id: '/_protected/bill-payment/$billId/connect-bank/cancel'
      path: '/bill-payment/$billId/connect-bank/cancel'
      fullPath: '/bill-payment/$billId/connect-bank/cancel'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdConnectBankCancelRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bill-payment/$billId/connect-bank/callback': {
      id: '/_protected/bill-payment/$billId/connect-bank/callback'
      path: '/bill-payment/$billId/connect-bank/callback'
      fullPath: '/bill-payment/$billId/connect-bank/callback'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdConnectBankCallbackRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/bill-payment/$billId/callback/open-banking': {
      id: '/_protected/bill-payment/$billId/callback/open-banking'
      path: '/open-banking'
      fullPath: '/bill-payment/$billId/callback/open-banking'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackOpenBankingRouteImport
      parentRoute: typeof ProtectedBillPaymentBillIdCallbackRoute
    }
    '/_protected/bill-payment/$billId/callback/_statuses': {
      id: '/_protected/bill-payment/$billId/callback/_statuses'
      path: '/bill-payment/$billId/callback'
      fullPath: '/bill-payment/$billId/callback'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesRouteImport
      parentRoute: typeof ProtectedBillPaymentBillIdCallbackRoute
    }
    '/_protected/home/accounts/one-time-credit/$accountId': {
      id: '/_protected/home/accounts/one-time-credit/$accountId'
      path: '/one-time-credit/$accountId'
      fullPath: '/home/accounts/one-time-credit/$accountId'
      preLoaderRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteImport
      parentRoute: typeof ProtectedHomeAccountsRouteRoute
    }
    '/_protected/home/accounts/loans/$accountId': {
      id: '/_protected/home/accounts/loans/$accountId'
      path: '/loans/$accountId'
      fullPath: '/home/accounts/loans/$accountId'
      preLoaderRoute: typeof ProtectedHomeAccountsLoansAccountIdRouteRouteImport
      parentRoute: typeof ProtectedHomeAccountsRouteRoute
    }
    '/_protected/home/accounts/deposits/$accountId': {
      id: '/_protected/home/accounts/deposits/$accountId'
      path: '/deposits/$accountId'
      fullPath: '/home/accounts/deposits/$accountId'
      preLoaderRoute: typeof ProtectedHomeAccountsDepositsAccountIdRouteRouteImport
      parentRoute: typeof ProtectedHomeAccountsRouteRoute
    }
    '/_protected/home/accounts/credits/$accountId': {
      id: '/_protected/home/accounts/credits/$accountId'
      path: '/credits/$accountId'
      fullPath: '/home/accounts/credits/$accountId'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdRouteRouteImport
      parentRoute: typeof ProtectedHomeAccountsRouteRoute
    }
    '/_protected/home/accounts/one-time-credit/$accountId/': {
      id: '/_protected/home/accounts/one-time-credit/$accountId/'
      path: '/'
      fullPath: '/home/accounts/one-time-credit/$accountId/'
      preLoaderRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdIndexRouteImport
      parentRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute
    }
    '/_protected/home/accounts/loans/$accountId/': {
      id: '/_protected/home/accounts/loans/$accountId/'
      path: '/'
      fullPath: '/home/accounts/loans/$accountId/'
      preLoaderRoute: typeof ProtectedHomeAccountsLoansAccountIdIndexRouteImport
      parentRoute: typeof ProtectedHomeAccountsLoansAccountIdRouteRoute
    }
    '/_protected/home/accounts/deposits/$accountId/': {
      id: '/_protected/home/accounts/deposits/$accountId/'
      path: '/'
      fullPath: '/home/accounts/deposits/$accountId/'
      preLoaderRoute: typeof ProtectedHomeAccountsDepositsAccountIdIndexRouteImport
      parentRoute: typeof ProtectedHomeAccountsDepositsAccountIdRouteRoute
    }
    '/_protected/home/accounts/credits/$accountId/': {
      id: '/_protected/home/accounts/credits/$accountId/'
      path: '/'
      fullPath: '/home/accounts/credits/$accountId/'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdIndexRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdRouteRoute
    }
    '/_protected/accounts/loans/$accountId/close/': {
      id: '/_protected/accounts/loans/$accountId/close/'
      path: '/accounts/loans/$accountId/close'
      fullPath: '/accounts/loans/$accountId/close'
      preLoaderRoute: typeof ProtectedAccountsLoansAccountIdCloseIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/invoices/$accountId/close/': {
      id: '/_protected/accounts/invoices/$accountId/close/'
      path: '/accounts/invoices/$accountId/close'
      fullPath: '/accounts/invoices/$accountId/close'
      preLoaderRoute: typeof ProtectedAccountsInvoicesAccountIdCloseIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/deposits/$accountId/close/': {
      id: '/_protected/accounts/deposits/$accountId/close/'
      path: '/accounts/deposits/$accountId/close'
      fullPath: '/accounts/deposits/$accountId/close'
      preLoaderRoute: typeof ProtectedAccountsDepositsAccountIdCloseIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/credits/$accountId/close/': {
      id: '/_protected/accounts/credits/$accountId/close/'
      path: '/accounts/credits/$accountId/close'
      fullPath: '/accounts/credits/$accountId/close'
      preLoaderRoute: typeof ProtectedAccountsCreditsAccountIdCloseIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/statement-payment/$statementId/callback/_statuses/unknown': {
      id: '/_protected/statement-payment/$statementId/callback/_statuses/unknown'
      path: '/unknown'
      fullPath: '/statement-payment/$statementId/callback/unknown'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesRoute
    }
    '/_protected/statement-payment/$statementId/callback/_statuses/timeout': {
      id: '/_protected/statement-payment/$statementId/callback/_statuses/timeout'
      path: '/timeout'
      fullPath: '/statement-payment/$statementId/callback/timeout'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesRoute
    }
    '/_protected/statement-payment/$statementId/callback/_statuses/success': {
      id: '/_protected/statement-payment/$statementId/callback/_statuses/success'
      path: '/success'
      fullPath: '/statement-payment/$statementId/callback/success'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesRoute
    }
    '/_protected/statement-payment/$statementId/callback/_statuses/pending': {
      id: '/_protected/statement-payment/$statementId/callback/_statuses/pending'
      path: '/pending'
      fullPath: '/statement-payment/$statementId/callback/pending'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesPendingRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesRoute
    }
    '/_protected/statement-payment/$statementId/callback/_statuses/error': {
      id: '/_protected/statement-payment/$statementId/callback/_statuses/error'
      path: '/error'
      fullPath: '/statement-payment/$statementId/callback/error'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesErrorRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesRoute
    }
    '/_protected/statement-payment/$statementId/callback/_statuses/cancel': {
      id: '/_protected/statement-payment/$statementId/callback/_statuses/cancel'
      path: '/cancel'
      fullPath: '/statement-payment/$statementId/callback/cancel'
      preLoaderRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesCancelRouteImport
      parentRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesRoute
    }
    '/_protected/home/accounts/one-time-credit/$accountId/transactions': {
      id: '/_protected/home/accounts/one-time-credit/$accountId/transactions'
      path: '/transactions'
      fullPath: '/home/accounts/one-time-credit/$accountId/transactions'
      preLoaderRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRouteImport
      parentRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute
    }
    '/_protected/home/accounts/one-time-credit/$accountId/invoice-history': {
      id: '/_protected/home/accounts/one-time-credit/$accountId/invoice-history'
      path: '/invoice-history'
      fullPath: '/home/accounts/one-time-credit/$accountId/invoice-history'
      preLoaderRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRouteImport
      parentRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute
    }
    '/_protected/home/accounts/loans/$accountId/transactions': {
      id: '/_protected/home/accounts/loans/$accountId/transactions'
      path: '/transactions'
      fullPath: '/home/accounts/loans/$accountId/transactions'
      preLoaderRoute: typeof ProtectedHomeAccountsLoansAccountIdTransactionsRouteImport
      parentRoute: typeof ProtectedHomeAccountsLoansAccountIdRouteRoute
    }
    '/_protected/home/accounts/loans/$accountId/invoices': {
      id: '/_protected/home/accounts/loans/$accountId/invoices'
      path: '/invoices'
      fullPath: '/home/accounts/loans/$accountId/invoices'
      preLoaderRoute: typeof ProtectedHomeAccountsLoansAccountIdInvoicesRouteImport
      parentRoute: typeof ProtectedHomeAccountsLoansAccountIdRouteRoute
    }
    '/_protected/home/accounts/deposits/$accountId/transactions': {
      id: '/_protected/home/accounts/deposits/$accountId/transactions'
      path: '/transactions'
      fullPath: '/home/accounts/deposits/$accountId/transactions'
      preLoaderRoute: typeof ProtectedHomeAccountsDepositsAccountIdTransactionsRouteImport
      parentRoute: typeof ProtectedHomeAccountsDepositsAccountIdRouteRoute
    }
    '/_protected/home/accounts/deposits/$accountId/statements': {
      id: '/_protected/home/accounts/deposits/$accountId/statements'
      path: '/statements'
      fullPath: '/home/accounts/deposits/$accountId/statements'
      preLoaderRoute: typeof ProtectedHomeAccountsDepositsAccountIdStatementsRouteImport
      parentRoute: typeof ProtectedHomeAccountsDepositsAccountIdRouteRoute
    }
    '/_protected/home/accounts/credits/$accountId/transactions': {
      id: '/_protected/home/accounts/credits/$accountId/transactions'
      path: '/transactions'
      fullPath: '/home/accounts/credits/$accountId/transactions'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdTransactionsRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdRouteRoute
    }
    '/_protected/home/accounts/credits/$accountId/invoices': {
      id: '/_protected/home/accounts/credits/$accountId/invoices'
      path: '/invoices'
      fullPath: '/home/accounts/credits/$accountId/invoices'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdInvoicesRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdRouteRoute
    }
    '/_protected/home/accounts/credits/$accountId/bonus-checks': {
      id: '/_protected/home/accounts/credits/$accountId/bonus-checks'
      path: '/bonus-checks'
      fullPath: '/home/accounts/credits/$accountId/bonus-checks'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusChecksRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdRouteRoute
    }
    '/_protected/home/accounts/cards/$cardId_/3ds-password': {
      id: '/_protected/home/accounts/cards/$cardId_/3ds-password'
      path: '/cards/$cardId/3ds-password'
      fullPath: '/home/accounts/cards/$cardId/3ds-password'
      preLoaderRoute: typeof ProtectedHomeAccountsCardsCardId3dsPasswordRouteImport
      parentRoute: typeof ProtectedHomeAccountsRouteRoute
    }
    '/_protected/bill-payment/$billId/callback/_statuses/unknown': {
      id: '/_protected/bill-payment/$billId/callback/_statuses/unknown'
      path: '/unknown'
      fullPath: '/bill-payment/$billId/callback/unknown'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesUnknownRouteImport
      parentRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesRoute
    }
    '/_protected/bill-payment/$billId/callback/_statuses/timeout': {
      id: '/_protected/bill-payment/$billId/callback/_statuses/timeout'
      path: '/timeout'
      fullPath: '/bill-payment/$billId/callback/timeout'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesTimeoutRouteImport
      parentRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesRoute
    }
    '/_protected/bill-payment/$billId/callback/_statuses/success': {
      id: '/_protected/bill-payment/$billId/callback/_statuses/success'
      path: '/success'
      fullPath: '/bill-payment/$billId/callback/success'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesSuccessRouteImport
      parentRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesRoute
    }
    '/_protected/bill-payment/$billId/callback/_statuses/pending': {
      id: '/_protected/bill-payment/$billId/callback/_statuses/pending'
      path: '/pending'
      fullPath: '/bill-payment/$billId/callback/pending'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesPendingRouteImport
      parentRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesRoute
    }
    '/_protected/bill-payment/$billId/callback/_statuses/error': {
      id: '/_protected/bill-payment/$billId/callback/_statuses/error'
      path: '/error'
      fullPath: '/bill-payment/$billId/callback/error'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesErrorRouteImport
      parentRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesRoute
    }
    '/_protected/bill-payment/$billId/callback/_statuses/cancel': {
      id: '/_protected/bill-payment/$billId/callback/_statuses/cancel'
      path: '/cancel'
      fullPath: '/bill-payment/$billId/callback/cancel'
      preLoaderRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesCancelRouteImport
      parentRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesRoute
    }
    '/_protected/accounts/loans/$accountId/close/success': {
      id: '/_protected/accounts/loans/$accountId/close/success'
      path: '/accounts/loans/$accountId/close/success'
      fullPath: '/accounts/loans/$accountId/close/success'
      preLoaderRoute: typeof ProtectedAccountsLoansAccountIdCloseSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/loans/$accountId/close/confirm': {
      id: '/_protected/accounts/loans/$accountId/close/confirm'
      path: '/accounts/loans/$accountId/close/confirm'
      fullPath: '/accounts/loans/$accountId/close/confirm'
      preLoaderRoute: typeof ProtectedAccountsLoansAccountIdCloseConfirmRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/invoices/$accountId/close/success': {
      id: '/_protected/accounts/invoices/$accountId/close/success'
      path: '/accounts/invoices/$accountId/close/success'
      fullPath: '/accounts/invoices/$accountId/close/success'
      preLoaderRoute: typeof ProtectedAccountsInvoicesAccountIdCloseSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/invoices/$accountId/close/confirm': {
      id: '/_protected/accounts/invoices/$accountId/close/confirm'
      path: '/accounts/invoices/$accountId/close/confirm'
      fullPath: '/accounts/invoices/$accountId/close/confirm'
      preLoaderRoute: typeof ProtectedAccountsInvoicesAccountIdCloseConfirmRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/deposits/$accountId/close/success': {
      id: '/_protected/accounts/deposits/$accountId/close/success'
      path: '/accounts/deposits/$accountId/close/success'
      fullPath: '/accounts/deposits/$accountId/close/success'
      preLoaderRoute: typeof ProtectedAccountsDepositsAccountIdCloseSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/deposits/$accountId/close/confirm': {
      id: '/_protected/accounts/deposits/$accountId/close/confirm'
      path: '/accounts/deposits/$accountId/close/confirm'
      fullPath: '/accounts/deposits/$accountId/close/confirm'
      preLoaderRoute: typeof ProtectedAccountsDepositsAccountIdCloseConfirmRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/credits/$accountId/close/success': {
      id: '/_protected/accounts/credits/$accountId/close/success'
      path: '/accounts/credits/$accountId/close/success'
      fullPath: '/accounts/credits/$accountId/close/success'
      preLoaderRoute: typeof ProtectedAccountsCreditsAccountIdCloseSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/credits/$accountId/close/confirm': {
      id: '/_protected/accounts/credits/$accountId/close/confirm'
      path: '/accounts/credits/$accountId/close/confirm'
      fullPath: '/accounts/credits/$accountId/close/confirm'
      preLoaderRoute: typeof ProtectedAccountsCreditsAccountIdCloseConfirmRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/accounts/credits/$accountId/bonus-shop': {
      id: '/_protected/home/accounts/credits/$accountId/bonus-shop'
      path: '/bonus-shop'
      fullPath: '/home/accounts/credits/$accountId/bonus-shop'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdRouteRoute
    }
    '/_protected/home/accounts/credits/$accountId/bonus-shop/': {
      id: '/_protected/home/accounts/credits/$accountId/bonus-shop/'
      path: '/'
      fullPath: '/home/accounts/credits/$accountId/bonus-shop/'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute
    }
    '/_protected/accounts/loans/$accountId/ppi/close/': {
      id: '/_protected/accounts/loans/$accountId/ppi/close/'
      path: '/accounts/loans/$accountId/ppi/close'
      fullPath: '/accounts/loans/$accountId/ppi/close'
      preLoaderRoute: typeof ProtectedAccountsLoansAccountIdPpiCloseIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/credits/$accountId/ppi/close/': {
      id: '/_protected/accounts/credits/$accountId/ppi/close/'
      path: '/accounts/credits/$accountId/ppi/close'
      fullPath: '/accounts/credits/$accountId/ppi/close'
      preLoaderRoute: typeof ProtectedAccountsCreditsAccountIdPpiCloseIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/transfer/callback/success/$fromAccountId/$toAccountId/$amount': {
      id: '/_protected/transfer/callback/success/$fromAccountId/$toAccountId/$amount'
      path: '/transfer/callback/success/$fromAccountId/$toAccountId/$amount'
      fullPath: '/transfer/callback/success/$fromAccountId/$toAccountId/$amount'
      preLoaderRoute: typeof ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/accounts/credits/$accountId/cards/$cardId': {
      id: '/_protected/home/accounts/credits/$accountId/cards/$cardId'
      path: '/cards/$cardId'
      fullPath: '/home/accounts/credits/$accountId/cards/$cardId'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdCardsCardIdRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdRouteRoute
    }
    '/_protected/home/accounts/credits/$accountId/bonus-shop/cart': {
      id: '/_protected/home/accounts/credits/$accountId/bonus-shop/cart'
      path: '/cart'
      fullPath: '/home/accounts/credits/$accountId/bonus-shop/cart'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopCartRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute
    }
    '/_protected/accounts/loans/$accountId/ppi/close/success': {
      id: '/_protected/accounts/loans/$accountId/ppi/close/success'
      path: '/accounts/loans/$accountId/ppi/close/success'
      fullPath: '/accounts/loans/$accountId/ppi/close/success'
      preLoaderRoute: typeof ProtectedAccountsLoansAccountIdPpiCloseSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/loans/$accountId/ppi/close/confirm': {
      id: '/_protected/accounts/loans/$accountId/ppi/close/confirm'
      path: '/accounts/loans/$accountId/ppi/close/confirm'
      fullPath: '/accounts/loans/$accountId/ppi/close/confirm'
      preLoaderRoute: typeof ProtectedAccountsLoansAccountIdPpiCloseConfirmRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/credits/$accountId/ppi/close/success': {
      id: '/_protected/accounts/credits/$accountId/ppi/close/success'
      path: '/accounts/credits/$accountId/ppi/close/success'
      fullPath: '/accounts/credits/$accountId/ppi/close/success'
      preLoaderRoute: typeof ProtectedAccountsCreditsAccountIdPpiCloseSuccessRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/credits/$accountId/ppi/close/confirm': {
      id: '/_protected/accounts/credits/$accountId/ppi/close/confirm'
      path: '/accounts/credits/$accountId/ppi/close/confirm'
      fullPath: '/accounts/credits/$accountId/ppi/close/confirm'
      preLoaderRoute: typeof ProtectedAccountsCreditsAccountIdPpiCloseConfirmRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home/accounts/credits/$accountId/bonus-shop/order/$orderId': {
      id: '/_protected/home/accounts/credits/$accountId/bonus-shop/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/home/accounts/credits/$accountId/bonus-shop/order/$orderId'
      preLoaderRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRouteImport
      parentRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute
    }
  }
}

interface ProtectedDepositOnboardingApplicationIdRouteChildren {
  ProtectedDepositOnboardingApplicationIdCallbackRoute: typeof ProtectedDepositOnboardingApplicationIdCallbackRoute
  ProtectedDepositOnboardingApplicationIdExistsRoute: typeof ProtectedDepositOnboardingApplicationIdExistsRoute
  ProtectedDepositOnboardingApplicationIdPendingRoute: typeof ProtectedDepositOnboardingApplicationIdPendingRoute
  ProtectedDepositOnboardingApplicationIdResumeRoute: typeof ProtectedDepositOnboardingApplicationIdResumeRoute
  ProtectedDepositOnboardingApplicationIdSummaryRoute: typeof ProtectedDepositOnboardingApplicationIdSummaryRoute
  ProtectedDepositOnboardingApplicationIdIndexRoute: typeof ProtectedDepositOnboardingApplicationIdIndexRoute
  ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRoute: typeof ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRoute
  ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRoute: typeof ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRoute
  ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRoute: typeof ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRoute
}

const ProtectedDepositOnboardingApplicationIdRouteChildren: ProtectedDepositOnboardingApplicationIdRouteChildren =
  {
    ProtectedDepositOnboardingApplicationIdCallbackRoute:
      ProtectedDepositOnboardingApplicationIdCallbackRoute,
    ProtectedDepositOnboardingApplicationIdExistsRoute:
      ProtectedDepositOnboardingApplicationIdExistsRoute,
    ProtectedDepositOnboardingApplicationIdPendingRoute:
      ProtectedDepositOnboardingApplicationIdPendingRoute,
    ProtectedDepositOnboardingApplicationIdResumeRoute:
      ProtectedDepositOnboardingApplicationIdResumeRoute,
    ProtectedDepositOnboardingApplicationIdSummaryRoute:
      ProtectedDepositOnboardingApplicationIdSummaryRoute,
    ProtectedDepositOnboardingApplicationIdIndexRoute:
      ProtectedDepositOnboardingApplicationIdIndexRoute,
    ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRoute:
      ProtectedDepositOnboardingApplicationIdProductCodeAccountIdRoute,
    ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRoute:
      ProtectedDepositOnboardingApplicationIdProductCodeAddFundsRoute,
    ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRoute:
      ProtectedDepositOnboardingApplicationIdProductCodeDepositAccountRoute,
  }

const ProtectedDepositOnboardingApplicationIdRouteWithChildren =
  ProtectedDepositOnboardingApplicationIdRoute._addFileChildren(
    ProtectedDepositOnboardingApplicationIdRouteChildren,
  )

interface ProtectedDepositOnboardingRouteRouteChildren {
  ProtectedDepositOnboardingApplicationIdRoute: typeof ProtectedDepositOnboardingApplicationIdRouteWithChildren
  ProtectedDepositOnboardingChooseProductRoute: typeof ProtectedDepositOnboardingChooseProductRoute
  ProtectedDepositOnboardingChooseTermRoute: typeof ProtectedDepositOnboardingChooseTermRoute
  ProtectedDepositOnboardingDeniedRoute: typeof ProtectedDepositOnboardingDeniedRoute
  ProtectedDepositOnboardingErrorRoute: typeof ProtectedDepositOnboardingErrorRoute
  ProtectedDepositOnboardingMaxAccountRoute: typeof ProtectedDepositOnboardingMaxAccountRoute
}

const ProtectedDepositOnboardingRouteRouteChildren: ProtectedDepositOnboardingRouteRouteChildren =
  {
    ProtectedDepositOnboardingApplicationIdRoute:
      ProtectedDepositOnboardingApplicationIdRouteWithChildren,
    ProtectedDepositOnboardingChooseProductRoute:
      ProtectedDepositOnboardingChooseProductRoute,
    ProtectedDepositOnboardingChooseTermRoute:
      ProtectedDepositOnboardingChooseTermRoute,
    ProtectedDepositOnboardingDeniedRoute:
      ProtectedDepositOnboardingDeniedRoute,
    ProtectedDepositOnboardingErrorRoute: ProtectedDepositOnboardingErrorRoute,
    ProtectedDepositOnboardingMaxAccountRoute:
      ProtectedDepositOnboardingMaxAccountRoute,
  }

const ProtectedDepositOnboardingRouteRouteWithChildren =
  ProtectedDepositOnboardingRouteRoute._addFileChildren(
    ProtectedDepositOnboardingRouteRouteChildren,
  )

interface ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteChildren {
  ProtectedHomeAccountsCreditsAccountIdBonusShopCartRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopCartRoute
  ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRoute
  ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRoute
}

const ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteChildren: ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteChildren =
  {
    ProtectedHomeAccountsCreditsAccountIdBonusShopCartRoute:
      ProtectedHomeAccountsCreditsAccountIdBonusShopCartRoute,
    ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRoute:
      ProtectedHomeAccountsCreditsAccountIdBonusShopIndexRoute,
    ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRoute:
      ProtectedHomeAccountsCreditsAccountIdBonusShopOrderOrderIdRoute,
  }

const ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteWithChildren =
  ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute._addFileChildren(
    ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteChildren,
  )

interface ProtectedHomeAccountsCreditsAccountIdRouteRouteChildren {
  ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteWithChildren
  ProtectedHomeAccountsCreditsAccountIdBonusChecksRoute: typeof ProtectedHomeAccountsCreditsAccountIdBonusChecksRoute
  ProtectedHomeAccountsCreditsAccountIdInvoicesRoute: typeof ProtectedHomeAccountsCreditsAccountIdInvoicesRoute
  ProtectedHomeAccountsCreditsAccountIdTransactionsRoute: typeof ProtectedHomeAccountsCreditsAccountIdTransactionsRoute
  ProtectedHomeAccountsCreditsAccountIdIndexRoute: typeof ProtectedHomeAccountsCreditsAccountIdIndexRoute
  ProtectedHomeAccountsCreditsAccountIdCardsCardIdRoute: typeof ProtectedHomeAccountsCreditsAccountIdCardsCardIdRoute
}

const ProtectedHomeAccountsCreditsAccountIdRouteRouteChildren: ProtectedHomeAccountsCreditsAccountIdRouteRouteChildren =
  {
    ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRoute:
      ProtectedHomeAccountsCreditsAccountIdBonusShopRouteRouteWithChildren,
    ProtectedHomeAccountsCreditsAccountIdBonusChecksRoute:
      ProtectedHomeAccountsCreditsAccountIdBonusChecksRoute,
    ProtectedHomeAccountsCreditsAccountIdInvoicesRoute:
      ProtectedHomeAccountsCreditsAccountIdInvoicesRoute,
    ProtectedHomeAccountsCreditsAccountIdTransactionsRoute:
      ProtectedHomeAccountsCreditsAccountIdTransactionsRoute,
    ProtectedHomeAccountsCreditsAccountIdIndexRoute:
      ProtectedHomeAccountsCreditsAccountIdIndexRoute,
    ProtectedHomeAccountsCreditsAccountIdCardsCardIdRoute:
      ProtectedHomeAccountsCreditsAccountIdCardsCardIdRoute,
  }

const ProtectedHomeAccountsCreditsAccountIdRouteRouteWithChildren =
  ProtectedHomeAccountsCreditsAccountIdRouteRoute._addFileChildren(
    ProtectedHomeAccountsCreditsAccountIdRouteRouteChildren,
  )

interface ProtectedHomeAccountsDepositsAccountIdRouteRouteChildren {
  ProtectedHomeAccountsDepositsAccountIdStatementsRoute: typeof ProtectedHomeAccountsDepositsAccountIdStatementsRoute
  ProtectedHomeAccountsDepositsAccountIdTransactionsRoute: typeof ProtectedHomeAccountsDepositsAccountIdTransactionsRoute
  ProtectedHomeAccountsDepositsAccountIdIndexRoute: typeof ProtectedHomeAccountsDepositsAccountIdIndexRoute
}

const ProtectedHomeAccountsDepositsAccountIdRouteRouteChildren: ProtectedHomeAccountsDepositsAccountIdRouteRouteChildren =
  {
    ProtectedHomeAccountsDepositsAccountIdStatementsRoute:
      ProtectedHomeAccountsDepositsAccountIdStatementsRoute,
    ProtectedHomeAccountsDepositsAccountIdTransactionsRoute:
      ProtectedHomeAccountsDepositsAccountIdTransactionsRoute,
    ProtectedHomeAccountsDepositsAccountIdIndexRoute:
      ProtectedHomeAccountsDepositsAccountIdIndexRoute,
  }

const ProtectedHomeAccountsDepositsAccountIdRouteRouteWithChildren =
  ProtectedHomeAccountsDepositsAccountIdRouteRoute._addFileChildren(
    ProtectedHomeAccountsDepositsAccountIdRouteRouteChildren,
  )

interface ProtectedHomeAccountsLoansAccountIdRouteRouteChildren {
  ProtectedHomeAccountsLoansAccountIdInvoicesRoute: typeof ProtectedHomeAccountsLoansAccountIdInvoicesRoute
  ProtectedHomeAccountsLoansAccountIdTransactionsRoute: typeof ProtectedHomeAccountsLoansAccountIdTransactionsRoute
  ProtectedHomeAccountsLoansAccountIdIndexRoute: typeof ProtectedHomeAccountsLoansAccountIdIndexRoute
}

const ProtectedHomeAccountsLoansAccountIdRouteRouteChildren: ProtectedHomeAccountsLoansAccountIdRouteRouteChildren =
  {
    ProtectedHomeAccountsLoansAccountIdInvoicesRoute:
      ProtectedHomeAccountsLoansAccountIdInvoicesRoute,
    ProtectedHomeAccountsLoansAccountIdTransactionsRoute:
      ProtectedHomeAccountsLoansAccountIdTransactionsRoute,
    ProtectedHomeAccountsLoansAccountIdIndexRoute:
      ProtectedHomeAccountsLoansAccountIdIndexRoute,
  }

const ProtectedHomeAccountsLoansAccountIdRouteRouteWithChildren =
  ProtectedHomeAccountsLoansAccountIdRouteRoute._addFileChildren(
    ProtectedHomeAccountsLoansAccountIdRouteRouteChildren,
  )

interface ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteChildren {
  ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRoute
  ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRoute
  ProtectedHomeAccountsOneTimeCreditAccountIdIndexRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdIndexRoute
}

const ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteChildren: ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteChildren =
  {
    ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRoute:
      ProtectedHomeAccountsOneTimeCreditAccountIdInvoiceHistoryRoute,
    ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRoute:
      ProtectedHomeAccountsOneTimeCreditAccountIdTransactionsRoute,
    ProtectedHomeAccountsOneTimeCreditAccountIdIndexRoute:
      ProtectedHomeAccountsOneTimeCreditAccountIdIndexRoute,
  }

const ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteWithChildren =
  ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute._addFileChildren(
    ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteChildren,
  )

interface ProtectedHomeAccountsRouteRouteChildren {
  ProtectedHomeAccountsIndexRoute: typeof ProtectedHomeAccountsIndexRoute
  ProtectedHomeAccountsCreditsAccountIdRouteRoute: typeof ProtectedHomeAccountsCreditsAccountIdRouteRouteWithChildren
  ProtectedHomeAccountsDepositsAccountIdRouteRoute: typeof ProtectedHomeAccountsDepositsAccountIdRouteRouteWithChildren
  ProtectedHomeAccountsLoansAccountIdRouteRoute: typeof ProtectedHomeAccountsLoansAccountIdRouteRouteWithChildren
  ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute: typeof ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteWithChildren
  ProtectedHomeAccountsCardsCardIdRoute: typeof ProtectedHomeAccountsCardsCardIdRoute
  ProtectedHomeAccountsCardsCardId3dsPasswordRoute: typeof ProtectedHomeAccountsCardsCardId3dsPasswordRoute
}

const ProtectedHomeAccountsRouteRouteChildren: ProtectedHomeAccountsRouteRouteChildren =
  {
    ProtectedHomeAccountsIndexRoute: ProtectedHomeAccountsIndexRoute,
    ProtectedHomeAccountsCreditsAccountIdRouteRoute:
      ProtectedHomeAccountsCreditsAccountIdRouteRouteWithChildren,
    ProtectedHomeAccountsDepositsAccountIdRouteRoute:
      ProtectedHomeAccountsDepositsAccountIdRouteRouteWithChildren,
    ProtectedHomeAccountsLoansAccountIdRouteRoute:
      ProtectedHomeAccountsLoansAccountIdRouteRouteWithChildren,
    ProtectedHomeAccountsOneTimeCreditAccountIdRouteRoute:
      ProtectedHomeAccountsOneTimeCreditAccountIdRouteRouteWithChildren,
    ProtectedHomeAccountsCardsCardIdRoute:
      ProtectedHomeAccountsCardsCardIdRoute,
    ProtectedHomeAccountsCardsCardId3dsPasswordRoute:
      ProtectedHomeAccountsCardsCardId3dsPasswordRoute,
  }

const ProtectedHomeAccountsRouteRouteWithChildren =
  ProtectedHomeAccountsRouteRoute._addFileChildren(
    ProtectedHomeAccountsRouteRouteChildren,
  )

interface ProtectedHomeDiscoverRouteRouteChildren {
  ProtectedHomeDiscoverIndexRoute: typeof ProtectedHomeDiscoverIndexRoute
}

const ProtectedHomeDiscoverRouteRouteChildren: ProtectedHomeDiscoverRouteRouteChildren =
  {
    ProtectedHomeDiscoverIndexRoute: ProtectedHomeDiscoverIndexRoute,
  }

const ProtectedHomeDiscoverRouteRouteWithChildren =
  ProtectedHomeDiscoverRouteRoute._addFileChildren(
    ProtectedHomeDiscoverRouteRouteChildren,
  )

interface ProtectedHomeServiceRouteRouteChildren {
  ProtectedHomeServiceAccountRoute: typeof ProtectedHomeServiceAccountRoute
  ProtectedHomeServiceDocumentsRoute: typeof ProtectedHomeServiceDocumentsRoute
  ProtectedHomeServiceKycRoute: typeof ProtectedHomeServiceKycRoute
  ProtectedHomeServiceLanguageRoute: typeof ProtectedHomeServiceLanguageRoute
  ProtectedHomeServiceMessagesRoute: typeof ProtectedHomeServiceMessagesRoute
  ProtectedHomeServiceNotificationsRoute: typeof ProtectedHomeServiceNotificationsRoute
  ProtectedHomeServiceProfileRoute: typeof ProtectedHomeServiceProfileRoute
  ProtectedHomeServiceSavedAccountRoute: typeof ProtectedHomeServiceSavedAccountRoute
  ProtectedHomeServiceThemeRoute: typeof ProtectedHomeServiceThemeRoute
  ProtectedHomeServiceIndexRoute: typeof ProtectedHomeServiceIndexRoute
  ProtectedHomeServiceConnectBankCallbackRoute: typeof ProtectedHomeServiceConnectBankCallbackRoute
  ProtectedHomeServiceConnectBankCancelRoute: typeof ProtectedHomeServiceConnectBankCancelRoute
  ProtectedHomeServiceConnectBankErrorRoute: typeof ProtectedHomeServiceConnectBankErrorRoute
  ProtectedHomeServiceConnectBankSuccessRoute: typeof ProtectedHomeServiceConnectBankSuccessRoute
}

const ProtectedHomeServiceRouteRouteChildren: ProtectedHomeServiceRouteRouteChildren =
  {
    ProtectedHomeServiceAccountRoute: ProtectedHomeServiceAccountRoute,
    ProtectedHomeServiceDocumentsRoute: ProtectedHomeServiceDocumentsRoute,
    ProtectedHomeServiceKycRoute: ProtectedHomeServiceKycRoute,
    ProtectedHomeServiceLanguageRoute: ProtectedHomeServiceLanguageRoute,
    ProtectedHomeServiceMessagesRoute: ProtectedHomeServiceMessagesRoute,
    ProtectedHomeServiceNotificationsRoute:
      ProtectedHomeServiceNotificationsRoute,
    ProtectedHomeServiceProfileRoute: ProtectedHomeServiceProfileRoute,
    ProtectedHomeServiceSavedAccountRoute:
      ProtectedHomeServiceSavedAccountRoute,
    ProtectedHomeServiceThemeRoute: ProtectedHomeServiceThemeRoute,
    ProtectedHomeServiceIndexRoute: ProtectedHomeServiceIndexRoute,
    ProtectedHomeServiceConnectBankCallbackRoute:
      ProtectedHomeServiceConnectBankCallbackRoute,
    ProtectedHomeServiceConnectBankCancelRoute:
      ProtectedHomeServiceConnectBankCancelRoute,
    ProtectedHomeServiceConnectBankErrorRoute:
      ProtectedHomeServiceConnectBankErrorRoute,
    ProtectedHomeServiceConnectBankSuccessRoute:
      ProtectedHomeServiceConnectBankSuccessRoute,
  }

const ProtectedHomeServiceRouteRouteWithChildren =
  ProtectedHomeServiceRouteRoute._addFileChildren(
    ProtectedHomeServiceRouteRouteChildren,
  )

interface ProtectedHomeStatementsIdRouteRouteChildren {
  ProtectedHomeStatementsIdConnectedAccountPaymentRoute: typeof ProtectedHomeStatementsIdConnectedAccountPaymentRoute
  ProtectedHomeStatementsIdOpenBankingRoute: typeof ProtectedHomeStatementsIdOpenBankingRoute
  ProtectedHomeStatementsIdIndexRoute: typeof ProtectedHomeStatementsIdIndexRoute
}

const ProtectedHomeStatementsIdRouteRouteChildren: ProtectedHomeStatementsIdRouteRouteChildren =
  {
    ProtectedHomeStatementsIdConnectedAccountPaymentRoute:
      ProtectedHomeStatementsIdConnectedAccountPaymentRoute,
    ProtectedHomeStatementsIdOpenBankingRoute:
      ProtectedHomeStatementsIdOpenBankingRoute,
    ProtectedHomeStatementsIdIndexRoute: ProtectedHomeStatementsIdIndexRoute,
  }

const ProtectedHomeStatementsIdRouteRouteWithChildren =
  ProtectedHomeStatementsIdRouteRoute._addFileChildren(
    ProtectedHomeStatementsIdRouteRouteChildren,
  )

interface ProtectedHomeStatementsRouteRouteChildren {
  ProtectedHomeStatementsIdRouteRoute: typeof ProtectedHomeStatementsIdRouteRouteWithChildren
  ProtectedHomeStatementsIndexRoute: typeof ProtectedHomeStatementsIndexRoute
}

const ProtectedHomeStatementsRouteRouteChildren: ProtectedHomeStatementsRouteRouteChildren =
  {
    ProtectedHomeStatementsIdRouteRoute:
      ProtectedHomeStatementsIdRouteRouteWithChildren,
    ProtectedHomeStatementsIndexRoute: ProtectedHomeStatementsIndexRoute,
  }

const ProtectedHomeStatementsRouteRouteWithChildren =
  ProtectedHomeStatementsRouteRoute._addFileChildren(
    ProtectedHomeStatementsRouteRouteChildren,
  )

interface ProtectedHomeRouteRouteChildren {
  ProtectedHomeAccountsRouteRoute: typeof ProtectedHomeAccountsRouteRouteWithChildren
  ProtectedHomeDiscoverRouteRoute: typeof ProtectedHomeDiscoverRouteRouteWithChildren
  ProtectedHomeServiceRouteRoute: typeof ProtectedHomeServiceRouteRouteWithChildren
  ProtectedHomeStatementsRouteRoute: typeof ProtectedHomeStatementsRouteRouteWithChildren
  ProtectedHomePurchasesRoute: typeof ProtectedHomePurchasesRoute
  ProtectedHomeIndexRoute: typeof ProtectedHomeIndexRoute
  ProtectedHomeBillsIdOpenBankingRoute: typeof ProtectedHomeBillsIdOpenBankingRoute
}

const ProtectedHomeRouteRouteChildren: ProtectedHomeRouteRouteChildren = {
  ProtectedHomeAccountsRouteRoute: ProtectedHomeAccountsRouteRouteWithChildren,
  ProtectedHomeDiscoverRouteRoute: ProtectedHomeDiscoverRouteRouteWithChildren,
  ProtectedHomeServiceRouteRoute: ProtectedHomeServiceRouteRouteWithChildren,
  ProtectedHomeStatementsRouteRoute:
    ProtectedHomeStatementsRouteRouteWithChildren,
  ProtectedHomePurchasesRoute: ProtectedHomePurchasesRoute,
  ProtectedHomeIndexRoute: ProtectedHomeIndexRoute,
  ProtectedHomeBillsIdOpenBankingRoute: ProtectedHomeBillsIdOpenBankingRoute,
}

const ProtectedHomeRouteRouteWithChildren =
  ProtectedHomeRouteRoute._addFileChildren(ProtectedHomeRouteRouteChildren)

interface ProtectedStatementPaymentStatementIdPaymentRouteChildren {
  ProtectedStatementPaymentStatementIdPaymentOptionsRoute: typeof ProtectedStatementPaymentStatementIdPaymentOptionsRoute
  ProtectedStatementPaymentStatementIdPaymentSelectRoute: typeof ProtectedStatementPaymentStatementIdPaymentSelectRoute
  ProtectedStatementPaymentStatementIdPaymentIndexRoute: typeof ProtectedStatementPaymentStatementIdPaymentIndexRoute
}

const ProtectedStatementPaymentStatementIdPaymentRouteChildren: ProtectedStatementPaymentStatementIdPaymentRouteChildren =
  {
    ProtectedStatementPaymentStatementIdPaymentOptionsRoute:
      ProtectedStatementPaymentStatementIdPaymentOptionsRoute,
    ProtectedStatementPaymentStatementIdPaymentSelectRoute:
      ProtectedStatementPaymentStatementIdPaymentSelectRoute,
    ProtectedStatementPaymentStatementIdPaymentIndexRoute:
      ProtectedStatementPaymentStatementIdPaymentIndexRoute,
  }

const ProtectedStatementPaymentStatementIdPaymentRouteWithChildren =
  ProtectedStatementPaymentStatementIdPaymentRoute._addFileChildren(
    ProtectedStatementPaymentStatementIdPaymentRouteChildren,
  )

interface ProtectedStatementPaymentStatementIdCallbackStatusesRouteChildren {
  ProtectedStatementPaymentStatementIdCallbackStatusesCancelRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesCancelRoute
  ProtectedStatementPaymentStatementIdCallbackStatusesErrorRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesErrorRoute
  ProtectedStatementPaymentStatementIdCallbackStatusesPendingRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesPendingRoute
  ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRoute
  ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRoute
  ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRoute
}

const ProtectedStatementPaymentStatementIdCallbackStatusesRouteChildren: ProtectedStatementPaymentStatementIdCallbackStatusesRouteChildren =
  {
    ProtectedStatementPaymentStatementIdCallbackStatusesCancelRoute:
      ProtectedStatementPaymentStatementIdCallbackStatusesCancelRoute,
    ProtectedStatementPaymentStatementIdCallbackStatusesErrorRoute:
      ProtectedStatementPaymentStatementIdCallbackStatusesErrorRoute,
    ProtectedStatementPaymentStatementIdCallbackStatusesPendingRoute:
      ProtectedStatementPaymentStatementIdCallbackStatusesPendingRoute,
    ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRoute:
      ProtectedStatementPaymentStatementIdCallbackStatusesSuccessRoute,
    ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRoute:
      ProtectedStatementPaymentStatementIdCallbackStatusesTimeoutRoute,
    ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRoute:
      ProtectedStatementPaymentStatementIdCallbackStatusesUnknownRoute,
  }

const ProtectedStatementPaymentStatementIdCallbackStatusesRouteWithChildren =
  ProtectedStatementPaymentStatementIdCallbackStatusesRoute._addFileChildren(
    ProtectedStatementPaymentStatementIdCallbackStatusesRouteChildren,
  )

interface ProtectedStatementPaymentStatementIdCallbackRouteChildren {
  ProtectedStatementPaymentStatementIdCallbackStatusesRoute: typeof ProtectedStatementPaymentStatementIdCallbackStatusesRouteWithChildren
  ProtectedStatementPaymentStatementIdCallbackConnectedAccountRoute: typeof ProtectedStatementPaymentStatementIdCallbackConnectedAccountRoute
  ProtectedStatementPaymentStatementIdCallbackOpenBankingRoute: typeof ProtectedStatementPaymentStatementIdCallbackOpenBankingRoute
}

const ProtectedStatementPaymentStatementIdCallbackRouteChildren: ProtectedStatementPaymentStatementIdCallbackRouteChildren =
  {
    ProtectedStatementPaymentStatementIdCallbackStatusesRoute:
      ProtectedStatementPaymentStatementIdCallbackStatusesRouteWithChildren,
    ProtectedStatementPaymentStatementIdCallbackConnectedAccountRoute:
      ProtectedStatementPaymentStatementIdCallbackConnectedAccountRoute,
    ProtectedStatementPaymentStatementIdCallbackOpenBankingRoute:
      ProtectedStatementPaymentStatementIdCallbackOpenBankingRoute,
  }

const ProtectedStatementPaymentStatementIdCallbackRouteWithChildren =
  ProtectedStatementPaymentStatementIdCallbackRoute._addFileChildren(
    ProtectedStatementPaymentStatementIdCallbackRouteChildren,
  )

interface ProtectedStatementPaymentStatementIdRouteChildren {
  ProtectedStatementPaymentStatementIdPaymentRoute: typeof ProtectedStatementPaymentStatementIdPaymentRouteWithChildren
  ProtectedStatementPaymentStatementIdCallbackRoute: typeof ProtectedStatementPaymentStatementIdCallbackRouteWithChildren
  ProtectedStatementPaymentStatementIdCancelCallbackRoute: typeof ProtectedStatementPaymentStatementIdCancelCallbackRoute
  ProtectedStatementPaymentStatementIdConnectBankCallbackRoute: typeof ProtectedStatementPaymentStatementIdConnectBankCallbackRoute
  ProtectedStatementPaymentStatementIdConnectBankCancelRoute: typeof ProtectedStatementPaymentStatementIdConnectBankCancelRoute
  ProtectedStatementPaymentStatementIdConnectBankErrorRoute: typeof ProtectedStatementPaymentStatementIdConnectBankErrorRoute
  ProtectedStatementPaymentStatementIdConnectBankSuccessRoute: typeof ProtectedStatementPaymentStatementIdConnectBankSuccessRoute
}

const ProtectedStatementPaymentStatementIdRouteChildren: ProtectedStatementPaymentStatementIdRouteChildren =
  {
    ProtectedStatementPaymentStatementIdPaymentRoute:
      ProtectedStatementPaymentStatementIdPaymentRouteWithChildren,
    ProtectedStatementPaymentStatementIdCallbackRoute:
      ProtectedStatementPaymentStatementIdCallbackRouteWithChildren,
    ProtectedStatementPaymentStatementIdCancelCallbackRoute:
      ProtectedStatementPaymentStatementIdCancelCallbackRoute,
    ProtectedStatementPaymentStatementIdConnectBankCallbackRoute:
      ProtectedStatementPaymentStatementIdConnectBankCallbackRoute,
    ProtectedStatementPaymentStatementIdConnectBankCancelRoute:
      ProtectedStatementPaymentStatementIdConnectBankCancelRoute,
    ProtectedStatementPaymentStatementIdConnectBankErrorRoute:
      ProtectedStatementPaymentStatementIdConnectBankErrorRoute,
    ProtectedStatementPaymentStatementIdConnectBankSuccessRoute:
      ProtectedStatementPaymentStatementIdConnectBankSuccessRoute,
  }

const ProtectedStatementPaymentStatementIdRouteWithChildren =
  ProtectedStatementPaymentStatementIdRoute._addFileChildren(
    ProtectedStatementPaymentStatementIdRouteChildren,
  )

interface ProtectedBillPaymentBillIdCallbackStatusesRouteChildren {
  ProtectedBillPaymentBillIdCallbackStatusesCancelRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesCancelRoute
  ProtectedBillPaymentBillIdCallbackStatusesErrorRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesErrorRoute
  ProtectedBillPaymentBillIdCallbackStatusesPendingRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesPendingRoute
  ProtectedBillPaymentBillIdCallbackStatusesSuccessRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesSuccessRoute
  ProtectedBillPaymentBillIdCallbackStatusesTimeoutRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesTimeoutRoute
  ProtectedBillPaymentBillIdCallbackStatusesUnknownRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesUnknownRoute
}

const ProtectedBillPaymentBillIdCallbackStatusesRouteChildren: ProtectedBillPaymentBillIdCallbackStatusesRouteChildren =
  {
    ProtectedBillPaymentBillIdCallbackStatusesCancelRoute:
      ProtectedBillPaymentBillIdCallbackStatusesCancelRoute,
    ProtectedBillPaymentBillIdCallbackStatusesErrorRoute:
      ProtectedBillPaymentBillIdCallbackStatusesErrorRoute,
    ProtectedBillPaymentBillIdCallbackStatusesPendingRoute:
      ProtectedBillPaymentBillIdCallbackStatusesPendingRoute,
    ProtectedBillPaymentBillIdCallbackStatusesSuccessRoute:
      ProtectedBillPaymentBillIdCallbackStatusesSuccessRoute,
    ProtectedBillPaymentBillIdCallbackStatusesTimeoutRoute:
      ProtectedBillPaymentBillIdCallbackStatusesTimeoutRoute,
    ProtectedBillPaymentBillIdCallbackStatusesUnknownRoute:
      ProtectedBillPaymentBillIdCallbackStatusesUnknownRoute,
  }

const ProtectedBillPaymentBillIdCallbackStatusesRouteWithChildren =
  ProtectedBillPaymentBillIdCallbackStatusesRoute._addFileChildren(
    ProtectedBillPaymentBillIdCallbackStatusesRouteChildren,
  )

interface ProtectedBillPaymentBillIdCallbackRouteChildren {
  ProtectedBillPaymentBillIdCallbackStatusesRoute: typeof ProtectedBillPaymentBillIdCallbackStatusesRouteWithChildren
  ProtectedBillPaymentBillIdCallbackOpenBankingRoute: typeof ProtectedBillPaymentBillIdCallbackOpenBankingRoute
}

const ProtectedBillPaymentBillIdCallbackRouteChildren: ProtectedBillPaymentBillIdCallbackRouteChildren =
  {
    ProtectedBillPaymentBillIdCallbackStatusesRoute:
      ProtectedBillPaymentBillIdCallbackStatusesRouteWithChildren,
    ProtectedBillPaymentBillIdCallbackOpenBankingRoute:
      ProtectedBillPaymentBillIdCallbackOpenBankingRoute,
  }

const ProtectedBillPaymentBillIdCallbackRouteWithChildren =
  ProtectedBillPaymentBillIdCallbackRoute._addFileChildren(
    ProtectedBillPaymentBillIdCallbackRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedDepositOnboardingRouteRoute: typeof ProtectedDepositOnboardingRouteRouteWithChildren
  ProtectedHomeRouteRoute: typeof ProtectedHomeRouteRouteWithChildren
  ProtectedBankidRoute: typeof ProtectedBankidRoute
  ProtectedCreditAccountPaymentCallbackRoute: typeof ProtectedCreditAccountPaymentCallbackRoute
  ProtectedDirectTransferCallbackRoute: typeof ProtectedDirectTransferCallbackRoute
  ProtectedKycIdRoute: typeof ProtectedKycIdRoute
  ProtectedKycSuccessRoute: typeof ProtectedKycSuccessRoute
  ProtectedMonthlyDepositCallbackRoute: typeof ProtectedMonthlyDepositCallbackRoute
  ProtectedTransferAccountIdRoute: typeof ProtectedTransferAccountIdRoute
  ProtectedWithdrawalCallbackRoute: typeof ProtectedWithdrawalCallbackRoute
  ProtectedAgreementsIndexRoute: typeof ProtectedAgreementsIndexRoute
  ProtectedBillPaymentIndexRoute: typeof ProtectedBillPaymentIndexRoute
  ProtectedCreditAccountPaymentIndexRoute: typeof ProtectedCreditAccountPaymentIndexRoute
  ProtectedKycIndexRoute: typeof ProtectedKycIndexRoute
  ProtectedWithdrawalIndexRoute: typeof ProtectedWithdrawalIndexRoute
  ProtectedAgreementsAgreementIdSuccessRoute: typeof ProtectedAgreementsAgreementIdSuccessRoute
  ProtectedBillPaymentBillIdConversionOptionsRoute: typeof ProtectedBillPaymentBillIdConversionOptionsRoute
  ProtectedBillPaymentBillIdOptionsRoute: typeof ProtectedBillPaymentBillIdOptionsRoute
  ProtectedConnectedAccountAddCallbackRoute: typeof ProtectedConnectedAccountAddCallbackRoute
  ProtectedConnectedAccountRemoveCallbackRoute: typeof ProtectedConnectedAccountRemoveCallbackRoute
  ProtectedCreditAccountPaymentCreateIdRoute: typeof ProtectedCreditAccountPaymentCreateIdRoute
  ProtectedSavingsCloseIdAccountNumberRoute: typeof ProtectedSavingsCloseIdAccountNumberRoute
  ProtectedStatementPaymentStatementIdRoute: typeof ProtectedStatementPaymentStatementIdRouteWithChildren
  ProtectedTransferCallbackFailedRoute: typeof ProtectedTransferCallbackFailedRoute
  ProtectedWithdrawalAccountsCallbackRoute: typeof ProtectedWithdrawalAccountsCallbackRoute
  ProtectedWithdrawalOpenbankingCallbackRoute: typeof ProtectedWithdrawalOpenbankingCallbackRoute
  ProtectedAgreementsAgreementIdIndexRoute: typeof ProtectedAgreementsAgreementIdIndexRoute
  ProtectedBillPaymentBillIdIndexRoute: typeof ProtectedBillPaymentBillIdIndexRoute
  ProtectedConnectedAccountAddIndexRoute: typeof ProtectedConnectedAccountAddIndexRoute
  ProtectedCreditAccountPaymentCreateIndexRoute: typeof ProtectedCreditAccountPaymentCreateIndexRoute
  ProtectedBillPaymentBillIdCallbackRoute: typeof ProtectedBillPaymentBillIdCallbackRouteWithChildren
  ProtectedBillPaymentBillIdConnectBankCallbackRoute: typeof ProtectedBillPaymentBillIdConnectBankCallbackRoute
  ProtectedBillPaymentBillIdConnectBankCancelRoute: typeof ProtectedBillPaymentBillIdConnectBankCancelRoute
  ProtectedBillPaymentBillIdConnectBankErrorRoute: typeof ProtectedBillPaymentBillIdConnectBankErrorRoute
  ProtectedBillPaymentBillIdConnectBankSuccessRoute: typeof ProtectedBillPaymentBillIdConnectBankSuccessRoute
  ProtectedAccountsCreditsAccountIdCloseConfirmRoute: typeof ProtectedAccountsCreditsAccountIdCloseConfirmRoute
  ProtectedAccountsCreditsAccountIdCloseSuccessRoute: typeof ProtectedAccountsCreditsAccountIdCloseSuccessRoute
  ProtectedAccountsDepositsAccountIdCloseConfirmRoute: typeof ProtectedAccountsDepositsAccountIdCloseConfirmRoute
  ProtectedAccountsDepositsAccountIdCloseSuccessRoute: typeof ProtectedAccountsDepositsAccountIdCloseSuccessRoute
  ProtectedAccountsInvoicesAccountIdCloseConfirmRoute: typeof ProtectedAccountsInvoicesAccountIdCloseConfirmRoute
  ProtectedAccountsInvoicesAccountIdCloseSuccessRoute: typeof ProtectedAccountsInvoicesAccountIdCloseSuccessRoute
  ProtectedAccountsLoansAccountIdCloseConfirmRoute: typeof ProtectedAccountsLoansAccountIdCloseConfirmRoute
  ProtectedAccountsLoansAccountIdCloseSuccessRoute: typeof ProtectedAccountsLoansAccountIdCloseSuccessRoute
  ProtectedAccountsCreditsAccountIdCloseIndexRoute: typeof ProtectedAccountsCreditsAccountIdCloseIndexRoute
  ProtectedAccountsDepositsAccountIdCloseIndexRoute: typeof ProtectedAccountsDepositsAccountIdCloseIndexRoute
  ProtectedAccountsInvoicesAccountIdCloseIndexRoute: typeof ProtectedAccountsInvoicesAccountIdCloseIndexRoute
  ProtectedAccountsLoansAccountIdCloseIndexRoute: typeof ProtectedAccountsLoansAccountIdCloseIndexRoute
  ProtectedAccountsCreditsAccountIdPpiCloseConfirmRoute: typeof ProtectedAccountsCreditsAccountIdPpiCloseConfirmRoute
  ProtectedAccountsCreditsAccountIdPpiCloseSuccessRoute: typeof ProtectedAccountsCreditsAccountIdPpiCloseSuccessRoute
  ProtectedAccountsLoansAccountIdPpiCloseConfirmRoute: typeof ProtectedAccountsLoansAccountIdPpiCloseConfirmRoute
  ProtectedAccountsLoansAccountIdPpiCloseSuccessRoute: typeof ProtectedAccountsLoansAccountIdPpiCloseSuccessRoute
  ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRoute: typeof ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRoute
  ProtectedAccountsCreditsAccountIdPpiCloseIndexRoute: typeof ProtectedAccountsCreditsAccountIdPpiCloseIndexRoute
  ProtectedAccountsLoansAccountIdPpiCloseIndexRoute: typeof ProtectedAccountsLoansAccountIdPpiCloseIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDepositOnboardingRouteRoute:
    ProtectedDepositOnboardingRouteRouteWithChildren,
  ProtectedHomeRouteRoute: ProtectedHomeRouteRouteWithChildren,
  ProtectedBankidRoute: ProtectedBankidRoute,
  ProtectedCreditAccountPaymentCallbackRoute:
    ProtectedCreditAccountPaymentCallbackRoute,
  ProtectedDirectTransferCallbackRoute: ProtectedDirectTransferCallbackRoute,
  ProtectedKycIdRoute: ProtectedKycIdRoute,
  ProtectedKycSuccessRoute: ProtectedKycSuccessRoute,
  ProtectedMonthlyDepositCallbackRoute: ProtectedMonthlyDepositCallbackRoute,
  ProtectedTransferAccountIdRoute: ProtectedTransferAccountIdRoute,
  ProtectedWithdrawalCallbackRoute: ProtectedWithdrawalCallbackRoute,
  ProtectedAgreementsIndexRoute: ProtectedAgreementsIndexRoute,
  ProtectedBillPaymentIndexRoute: ProtectedBillPaymentIndexRoute,
  ProtectedCreditAccountPaymentIndexRoute:
    ProtectedCreditAccountPaymentIndexRoute,
  ProtectedKycIndexRoute: ProtectedKycIndexRoute,
  ProtectedWithdrawalIndexRoute: ProtectedWithdrawalIndexRoute,
  ProtectedAgreementsAgreementIdSuccessRoute:
    ProtectedAgreementsAgreementIdSuccessRoute,
  ProtectedBillPaymentBillIdConversionOptionsRoute:
    ProtectedBillPaymentBillIdConversionOptionsRoute,
  ProtectedBillPaymentBillIdOptionsRoute:
    ProtectedBillPaymentBillIdOptionsRoute,
  ProtectedConnectedAccountAddCallbackRoute:
    ProtectedConnectedAccountAddCallbackRoute,
  ProtectedConnectedAccountRemoveCallbackRoute:
    ProtectedConnectedAccountRemoveCallbackRoute,
  ProtectedCreditAccountPaymentCreateIdRoute:
    ProtectedCreditAccountPaymentCreateIdRoute,
  ProtectedSavingsCloseIdAccountNumberRoute:
    ProtectedSavingsCloseIdAccountNumberRoute,
  ProtectedStatementPaymentStatementIdRoute:
    ProtectedStatementPaymentStatementIdRouteWithChildren,
  ProtectedTransferCallbackFailedRoute: ProtectedTransferCallbackFailedRoute,
  ProtectedWithdrawalAccountsCallbackRoute:
    ProtectedWithdrawalAccountsCallbackRoute,
  ProtectedWithdrawalOpenbankingCallbackRoute:
    ProtectedWithdrawalOpenbankingCallbackRoute,
  ProtectedAgreementsAgreementIdIndexRoute:
    ProtectedAgreementsAgreementIdIndexRoute,
  ProtectedBillPaymentBillIdIndexRoute: ProtectedBillPaymentBillIdIndexRoute,
  ProtectedConnectedAccountAddIndexRoute:
    ProtectedConnectedAccountAddIndexRoute,
  ProtectedCreditAccountPaymentCreateIndexRoute:
    ProtectedCreditAccountPaymentCreateIndexRoute,
  ProtectedBillPaymentBillIdCallbackRoute:
    ProtectedBillPaymentBillIdCallbackRouteWithChildren,
  ProtectedBillPaymentBillIdConnectBankCallbackRoute:
    ProtectedBillPaymentBillIdConnectBankCallbackRoute,
  ProtectedBillPaymentBillIdConnectBankCancelRoute:
    ProtectedBillPaymentBillIdConnectBankCancelRoute,
  ProtectedBillPaymentBillIdConnectBankErrorRoute:
    ProtectedBillPaymentBillIdConnectBankErrorRoute,
  ProtectedBillPaymentBillIdConnectBankSuccessRoute:
    ProtectedBillPaymentBillIdConnectBankSuccessRoute,
  ProtectedAccountsCreditsAccountIdCloseConfirmRoute:
    ProtectedAccountsCreditsAccountIdCloseConfirmRoute,
  ProtectedAccountsCreditsAccountIdCloseSuccessRoute:
    ProtectedAccountsCreditsAccountIdCloseSuccessRoute,
  ProtectedAccountsDepositsAccountIdCloseConfirmRoute:
    ProtectedAccountsDepositsAccountIdCloseConfirmRoute,
  ProtectedAccountsDepositsAccountIdCloseSuccessRoute:
    ProtectedAccountsDepositsAccountIdCloseSuccessRoute,
  ProtectedAccountsInvoicesAccountIdCloseConfirmRoute:
    ProtectedAccountsInvoicesAccountIdCloseConfirmRoute,
  ProtectedAccountsInvoicesAccountIdCloseSuccessRoute:
    ProtectedAccountsInvoicesAccountIdCloseSuccessRoute,
  ProtectedAccountsLoansAccountIdCloseConfirmRoute:
    ProtectedAccountsLoansAccountIdCloseConfirmRoute,
  ProtectedAccountsLoansAccountIdCloseSuccessRoute:
    ProtectedAccountsLoansAccountIdCloseSuccessRoute,
  ProtectedAccountsCreditsAccountIdCloseIndexRoute:
    ProtectedAccountsCreditsAccountIdCloseIndexRoute,
  ProtectedAccountsDepositsAccountIdCloseIndexRoute:
    ProtectedAccountsDepositsAccountIdCloseIndexRoute,
  ProtectedAccountsInvoicesAccountIdCloseIndexRoute:
    ProtectedAccountsInvoicesAccountIdCloseIndexRoute,
  ProtectedAccountsLoansAccountIdCloseIndexRoute:
    ProtectedAccountsLoansAccountIdCloseIndexRoute,
  ProtectedAccountsCreditsAccountIdPpiCloseConfirmRoute:
    ProtectedAccountsCreditsAccountIdPpiCloseConfirmRoute,
  ProtectedAccountsCreditsAccountIdPpiCloseSuccessRoute:
    ProtectedAccountsCreditsAccountIdPpiCloseSuccessRoute,
  ProtectedAccountsLoansAccountIdPpiCloseConfirmRoute:
    ProtectedAccountsLoansAccountIdPpiCloseConfirmRoute,
  ProtectedAccountsLoansAccountIdPpiCloseSuccessRoute:
    ProtectedAccountsLoansAccountIdPpiCloseSuccessRoute,
  ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRoute:
    ProtectedTransferCallbackSuccessFromAccountIdToAccountIdAmountRoute,
  ProtectedAccountsCreditsAccountIdPpiCloseIndexRoute:
    ProtectedAccountsCreditsAccountIdPpiCloseIndexRoute,
  ProtectedAccountsLoansAccountIdPpiCloseIndexRoute:
    ProtectedAccountsLoansAccountIdPpiCloseIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  NotFoundRoute: NotFoundRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  AppRoute: AppRoute,
  AuthRoute: AuthRoute,
  AuthDoneRoute: AuthDoneRoute,
  CloseRoute: CloseRoute,
  ConfigRoute: ConfigRoute,
  DemoRoute: DemoRoute,
  ErrorRoute: ErrorRoute,
  LogoutRoute: LogoutRoute,
  MaintenanceRoute: MaintenanceRoute,
  TermsAndConditionsRoute: TermsAndConditionsRoute,
  DeeplinkSplatRoute: DeeplinkSplatRoute,
  LoginConsentsRoute: LoginConsentsRoute,
  LoginErrorRoute: LoginErrorRoute,
  ZendeskLogoutRoute: ZendeskLogoutRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
